/* tslint:disable */
/* eslint-disable */
/**
 * Smart Layers Core
 * Smart Layers core backend services
 *
 * The version of the OpenAPI document: 0.02
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface APIKeyOut
 */
export interface APIKeyOut {
    /**
     * 
     * @type {Array<PipelinesInner>}
     * @memberof APIKeyOut
     */
    'pipelines': Array<PipelinesInner>;
    /**
     * 
     * @type {string}
     * @memberof APIKeyOut
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof APIKeyOut
     */
    'api_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof APIKeyOut
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof APIKeyOut
     */
    'value': string;
    /**
     * 
     * @type {Owner}
     * @memberof APIKeyOut
     */
    'owner': Owner;
    /**
     * 
     * @type {string}
     * @memberof APIKeyOut
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface APISettings
 */
export interface APISettings {
    /**
     * 
     * @type {string}
     * @memberof APISettings
     */
    'max_file_limit': string;
    /**
     * 
     * @type {string}
     * @memberof APISettings
     */
    'max_pdf_pages': string;
}
/**
 * 
 * @export
 * @interface AccessTokenIn
 */
export interface AccessTokenIn {
    /**
     * 
     * @type {string}
     * @memberof AccessTokenIn
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenIn
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface AccessTokenOut
 */
export interface AccessTokenOut {
    /**
     * 
     * @type {string}
     * @memberof AccessTokenOut
     */
    'access_token': string;
}
/**
 * 
 * @export
 * @interface ActiveAdmin
 */
export interface ActiveAdmin {
    /**
     * 
     * @type {string}
     * @memberof ActiveAdmin
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof ActiveAdmin
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof ActiveAdmin
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof ActiveAdmin
     */
    'api_calls': number;
    /**
     * 
     * @type {BusinessModel}
     * @memberof ActiveAdmin
     */
    'business_model'?: BusinessModel;
    /**
     * 
     * @type {string}
     * @memberof ActiveAdmin
     */
    'organization': string;
    /**
     * 
     * @type {UserRoles}
     * @memberof ActiveAdmin
     */
    'role'?: UserRoles;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveAdmin
     */
    'verified'?: boolean;
}
/**
 * 
 * @export
 * @interface AddAPICallsUnit
 */
export interface AddAPICallsUnit {
    /**
     * 
     * @type {number}
     * @memberof AddAPICallsUnit
     */
    'new_api_calls_units': number;
}
/**
 * 
 * @export
 * @interface Annotation
 */
export interface Annotation {
    /**
     * 
     * @type {OcrLabel}
     * @memberof Annotation
     */
    'ocr_label': OcrLabel;
    /**
     * 
     * @type {string}
     * @memberof Annotation
     */
    'ocr_text': string;
    /**
     * 
     * @type {BoundingBox}
     * @memberof Annotation
     */
    'bndbox': BoundingBox;
}
/**
 * 
 * @export
 * @interface AppModelsZeroShotQuestionLabel
 */
export interface AppModelsZeroShotQuestionLabel {
    /**
     * 
     * @type {string}
     * @memberof AppModelsZeroShotQuestionLabel
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof AppModelsZeroShotQuestionLabel
     */
    'question': string;
}
/**
 * 
 * @export
 * @interface AppRoutersSchemasSufganiyotDryRunOut
 */
export interface AppRoutersSchemasSufganiyotDryRunOut {
    /**
     * 
     * @type {string}
     * @memberof AppRoutersSchemasSufganiyotDryRunOut
     */
    'detail': string;
}
/**
 * 
 * @export
 * @interface AppRoutersSchemasZeroShotDryRunOut
 */
export interface AppRoutersSchemasZeroShotDryRunOut {
    /**
     * 
     * @type {string}
     * @memberof AppRoutersSchemasZeroShotDryRunOut
     */
    'detail': string;
}
/**
 * 
 * @export
 * @interface AppRoutersSchemasZeroShotZeroShotQuestionLabel
 */
export interface AppRoutersSchemasZeroShotZeroShotQuestionLabel {
    /**
     * 
     * @type {string}
     * @memberof AppRoutersSchemasZeroShotZeroShotQuestionLabel
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof AppRoutersSchemasZeroShotZeroShotQuestionLabel
     */
    'question': string;
}
/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    '_id': string;
    /**
     * 
     * @type {BucketOut}
     * @memberof Attachment
     */
    'bucket': BucketOut;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'original_file_name': string;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'mime_type': string;
    /**
     * 
     * @type {number}
     * @memberof Attachment
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface Attachment1
 */
export interface Attachment1 {
    /**
     * 
     * @type {string}
     * @memberof Attachment1
     */
    '_id': string;
    /**
     * 
     * @type {BucketOut}
     * @memberof Attachment1
     */
    'bucket': BucketOut;
    /**
     * 
     * @type {string}
     * @memberof Attachment1
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof Attachment1
     */
    'original_file_name': string;
    /**
     * 
     * @type {string}
     * @memberof Attachment1
     */
    'mime_type': string;
    /**
     * 
     * @type {number}
     * @memberof Attachment1
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface Author
 */
export interface Author {
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof Author
     */
    'api_calls': number;
    /**
     * 
     * @type {BusinessModel}
     * @memberof Author
     */
    'business_model'?: BusinessModel;
    /**
     * 
     * @type {string}
     * @memberof Author
     */
    'organization': string;
    /**
     * 
     * @type {UserRoles}
     * @memberof Author
     */
    'role'?: UserRoles;
    /**
     * 
     * @type {boolean}
     * @memberof Author
     */
    'verified'?: boolean;
}
/**
 * 
 * @export
 * @interface BoundingBox
 */
export interface BoundingBox {
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    'xmin': number;
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    'xmax': number;
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    'ymin': number;
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    'ymax': number;
}
/**
 * 
 * @export
 * @interface BucketOut
 */
export interface BucketOut {
    /**
     * 
     * @type {string}
     * @memberof BucketOut
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof BucketOut
     */
    'name': string;
    /**
     * 
     * @type {UserOut}
     * @memberof BucketOut
     */
    'created_by': UserOut;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const BusinessModel = {
    Freemium: 'Freemium',
    Premium: 'Premium'
} as const;

export type BusinessModel = typeof BusinessModel[keyof typeof BusinessModel];


/**
 * 
 * @export
 * @interface ClassifierDatasetToPipelineWorkerOutput
 */
export interface ClassifierDatasetToPipelineWorkerOutput {
    /**
     * 
     * @type {string}
     * @memberof ClassifierDatasetToPipelineWorkerOutput
     */
    'classifier_model_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClassifierDatasetToPipelineWorkerOutput
     */
    'pipeline_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClassifierDatasetToPipelineWorkerOutput
     */
    'elapsed_seconds'?: number | null;
}
/**
 * 
 * @export
 * @interface CreatedBy
 */
export interface CreatedBy {
    /**
     * 
     * @type {string}
     * @memberof CreatedBy
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedBy
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedBy
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof CreatedBy
     */
    'api_calls': number;
    /**
     * 
     * @type {BusinessModel}
     * @memberof CreatedBy
     */
    'business_model'?: BusinessModel;
    /**
     * 
     * @type {string}
     * @memberof CreatedBy
     */
    'organization': string;
    /**
     * 
     * @type {UserRoles}
     * @memberof CreatedBy
     */
    'role'?: UserRoles;
    /**
     * 
     * @type {boolean}
     * @memberof CreatedBy
     */
    'verified'?: boolean;
}
/**
 * 
 * @export
 * @interface Dataset
 */
export interface Dataset {
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const DatasetLanguage = {
    Eng: 'eng',
    Fra: 'fra',
    Spa: 'spa'
} as const;

export type DatasetLanguage = typeof DatasetLanguage[keyof typeof DatasetLanguage];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const DatasetNature = {
    Messy: 'MESSY',
    Clean: 'CLEAN'
} as const;

export type DatasetNature = typeof DatasetNature[keyof typeof DatasetNature];


/**
 * 
 * @export
 * @interface DatasetParameters
 */
export interface DatasetParameters {
    /**
     * 
     * @type {DatasetNature}
     * @memberof DatasetParameters
     */
    'nature'?: DatasetNature;
    /**
     * 
     * @type {Array<DatasetLanguage>}
     * @memberof DatasetParameters
     */
    'languages'?: Array<DatasetLanguage>;
    /**
     * 
     * @type {boolean}
     * @memberof DatasetParameters
     */
    'has_handwritten_characters'?: boolean;
}
/**
 * 
 * @export
 * @interface DatasetRecordFileDataOut
 */
export interface DatasetRecordFileDataOut {
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordFileDataOut
     */
    'dataset_record_id': string;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordFileDataOut
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordFileDataOut
     */
    'original_file_name': string;
}
/**
 * 
 * @export
 * @interface DatasetRecordGroup
 */
export interface DatasetRecordGroup {
    /**
     * 
     * @type {Id}
     * @memberof DatasetRecordGroup
     */
    '_id': Id;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatasetRecordGroup
     */
    'record_ids': Array<string>;
    /**
     * 
     * @type {Array<Array<Annotation>>}
     * @memberof DatasetRecordGroup
     */
    'annotations': Array<Array<Annotation>>;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordGroup
     */
    'dataset': string;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordGroup
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordGroup
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface DatasetRecordGroupForMany
 */
export interface DatasetRecordGroupForMany {
    /**
     * 
     * @type {Id}
     * @memberof DatasetRecordGroupForMany
     */
    '_id': Id;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordGroupForMany
     */
    'dataset': string;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordGroupForMany
     */
    'group_type': string;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordGroupForMany
     */
    'thumb_ref': string;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordGroupForMany
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordGroupForMany
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DatasetRecordGroupForMany
     */
    'updated_at': string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const DatasetRecordSortBy = {
    DateCreated: 'DATE_CREATED',
    DateUpdated: 'DATE_UPDATED',
    NumberOfAnnotations: 'NUMBER_OF_ANNOTATIONS'
} as const;

export type DatasetRecordSortBy = typeof DatasetRecordSortBy[keyof typeof DatasetRecordSortBy];


/**
 * 
 * @export
 * @interface DatasetToPipelineWorkerOutput
 */
export interface DatasetToPipelineWorkerOutput {
    /**
     * 
     * @type {string}
     * @memberof DatasetToPipelineWorkerOutput
     */
    'model_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatasetToPipelineWorkerOutput
     */
    'pipeline_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DatasetToPipelineWorkerOutput
     */
    'elapsed_seconds'?: number | null;
}
/**
 * 
 * @export
 * @interface DatasetValidityCheck
 */
export interface DatasetValidityCheck {
    /**
     * 
     * @type {Array<DatasetValidityReason>}
     * @memberof DatasetValidityCheck
     */
    'reasons': Array<DatasetValidityReason>;
    /**
     * 
     * @type {boolean}
     * @memberof DatasetValidityCheck
     */
    'valid': boolean;
    /**
     * 
     * @type {string}
     * @memberof DatasetValidityCheck
     */
    'dataset_id': string;
}
/**
 * 
 * @export
 * @interface DatasetValidityReason
 */
export interface DatasetValidityReason {
    /**
     * 
     * @type {DatasetValidityReasonOption}
     * @memberof DatasetValidityReason
     */
    'reason': DatasetValidityReasonOption;
    /**
     * 
     * @type {DatasetValidityReasonMeta}
     * @memberof DatasetValidityReason
     */
    'meta': DatasetValidityReasonMeta;
}
/**
 * 
 * @export
 * @interface DatasetValidityReasonLabelMajority
 */
export interface DatasetValidityReasonLabelMajority {
    /**
     * 
     * @type {OcrLabel1}
     * @memberof DatasetValidityReasonLabelMajority
     */
    'ocr_label': OcrLabel1;
    /**
     * 
     * @type {object}
     * @memberof DatasetValidityReasonLabelMajority
     */
    'extra'?: object;
}
/**
 * 
 * @export
 * @interface DatasetValidityReasonMeta
 */
export interface DatasetValidityReasonMeta {
    /**
     * 
     * @type {Array<string>}
     * @memberof DatasetValidityReasonMeta
     */
    'record_ids'?: Array<string>;
    /**
     * 
     * @type {Array<DatasetValidityReasonLabelMajority>}
     * @memberof DatasetValidityReasonMeta
     */
    'ocr_labels_data'?: Array<DatasetValidityReasonLabelMajority>;
    /**
     * 
     * @type {string}
     * @memberof DatasetValidityReasonMeta
     */
    'expected_value'?: string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const DatasetValidityReasonOption = {
    MinimumRecordsRequired: 'MINIMUM_RECORDS_REQUIRED',
    DatasetHasNoLabels: 'DATASET_HAS_NO_LABELS',
    PdfConversionInProgress: 'PDF_CONVERSION_IN_PROGRESS',
    RecordsWithoutAnnotations: 'RECORDS_WITHOUT_ANNOTATIONS',
    LabelMajority: 'LABEL_MAJORITY'
} as const;

export type DatasetValidityReasonOption = typeof DatasetValidityReasonOption[keyof typeof DatasetValidityReasonOption];


/**
 * 
 * @export
 * @interface DatasetsInner
 */
export interface DatasetsInner {
}
/**
 * 
 * @export
 * @interface DocumentClassifierDatasetSchema
 */
export interface DocumentClassifierDatasetSchema {
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierDatasetSchema
     */
    'main_path': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentClassifierDatasetSchema
     */
    'dataset_names': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentClassifierDatasetSchema
     */
    'split': boolean;
    /**
     * 
     * @type {number}
     * @memberof DocumentClassifierDatasetSchema
     */
    'val_size': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentClassifierDatasetSchema
     */
    'test_size': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentClassifierDatasetSchema
     */
    'limit': number;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentClassifierDatasetSchema
     */
    'shuffle': boolean;
}
/**
 * 
 * @export
 * @interface DocumentClassifierModelConfigSchema
 */
export interface DocumentClassifierModelConfigSchema {
    /**
     * 
     * @type {DocumentClassifierDatasetSchema}
     * @memberof DocumentClassifierModelConfigSchema
     */
    'dataset': DocumentClassifierDatasetSchema;
    /**
     * 
     * @type {DocumentClassifierModelSchema}
     * @memberof DocumentClassifierModelConfigSchema
     */
    'model': DocumentClassifierModelSchema;
}
/**
 * 
 * @export
 * @interface DocumentClassifierModelDatasetHash
 */
export interface DocumentClassifierModelDatasetHash {
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierModelDatasetHash
     */
    'dataset_id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierModelDatasetHash
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface DocumentClassifierModelOut
 */
export interface DocumentClassifierModelOut {
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierModelOut
     */
    '_id': string;
    /**
     * 
     * @type {PipelineModelVariant}
     * @memberof DocumentClassifierModelOut
     */
    'variant': PipelineModelVariant;
    /**
     * 
     * @type {DocumentClassifierModelConfigSchema}
     * @memberof DocumentClassifierModelOut
     */
    'model_config': DocumentClassifierModelConfigSchema;
    /**
     * 
     * @type {object}
     * @memberof DocumentClassifierModelOut
     */
    'evaluation_report': object;
    /**
     * 
     * @type {object}
     * @memberof DocumentClassifierModelOut
     */
    'attributes'?: object | null;
    /**
     * 
     * @type {ModelBinariesZip}
     * @memberof DocumentClassifierModelOut
     */
    'model_binaries_zip': ModelBinariesZip;
    /**
     * 
     * @type {DocumentClassifierModelTrainingStatus}
     * @memberof DocumentClassifierModelOut
     */
    'status': DocumentClassifierModelTrainingStatus;
    /**
     * 
     * @type {Array<DatasetsInner>}
     * @memberof DocumentClassifierModelOut
     */
    'datasets'?: Array<DatasetsInner> | null;
    /**
     * 
     * @type {Array<DocumentClassifierModelDatasetHash>}
     * @memberof DocumentClassifierModelOut
     */
    'dataset_hashes'?: Array<DocumentClassifierModelDatasetHash> | null;
    /**
     * 
     * @type {CreatedBy}
     * @memberof DocumentClassifierModelOut
     */
    'created_by': CreatedBy;
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierModelOut
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface DocumentClassifierModelSchema
 */
export interface DocumentClassifierModelSchema {
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierModelSchema
     */
    'device': string;
    /**
     * 
     * @type {number}
     * @memberof DocumentClassifierModelSchema
     */
    'epochs': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentClassifierModelSchema
     */
    'batch_size': number;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentClassifierModelSchema
     */
    'fp16': boolean;
    /**
     * 
     * @type {number}
     * @memberof DocumentClassifierModelSchema
     */
    'es_patience': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentClassifierModelSchema
     */
    'lr': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierModelSchema
     */
    'save_path': string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const DocumentClassifierModelTrainingStatus = {
    NotTraining: 'NOT_TRAINING',
    Training: 'TRAINING',
    Ready: 'READY'
} as const;

export type DocumentClassifierModelTrainingStatus = typeof DocumentClassifierModelTrainingStatus[keyof typeof DocumentClassifierModelTrainingStatus];


/**
 * 
 * @export
 * @interface DocumentClassifierModelUpdateSchema
 */
export interface DocumentClassifierModelUpdateSchema {
    /**
     * 
     * @type {DocumentClassifierModelTrainingStatus}
     * @memberof DocumentClassifierModelUpdateSchema
     */
    'status'?: DocumentClassifierModelTrainingStatus | null;
    /**
     * 
     * @type {object}
     * @memberof DocumentClassifierModelUpdateSchema
     */
    'attributes'?: object | null;
    /**
     * 
     * @type {Array<DocumentClassifierModelDatasetHash>}
     * @memberof DocumentClassifierModelUpdateSchema
     */
    'dataset_hashes'?: Array<DocumentClassifierModelDatasetHash> | null;
    /**
     * 
     * @type {DocumentClassifierModelConfigSchema}
     * @memberof DocumentClassifierModelUpdateSchema
     */
    'model_config'?: DocumentClassifierModelConfigSchema;
    /**
     * 
     * @type {object}
     * @memberof DocumentClassifierModelUpdateSchema
     */
    'evaluation_report'?: object | null;
}
/**
 * 
 * @export
 * @interface DocumentClassifierWorkOrderIn
 */
export interface DocumentClassifierWorkOrderIn {
    /**
     * 
     * @type {DocumentClassifierWorkOrderInput}
     * @memberof DocumentClassifierWorkOrderIn
     */
    'inputs': DocumentClassifierWorkOrderInput;
}
/**
 * 
 * @export
 * @interface DocumentClassifierWorkOrderInput
 */
export interface DocumentClassifierWorkOrderInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentClassifierWorkOrderInput
     */
    'dataset_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface DocumentClassifierWorkOrderOut
 */
export interface DocumentClassifierWorkOrderOut {
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierWorkOrderOut
     */
    '_id': string;
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof DocumentClassifierWorkOrderOut
     */
    'order_status': WorkOrderStatus;
    /**
     * 
     * @type {WorkOrderType}
     * @memberof DocumentClassifierWorkOrderOut
     */
    'order_type': WorkOrderType;
    /**
     * 
     * @type {DocumentClassifierWorkOrderInput}
     * @memberof DocumentClassifierWorkOrderOut
     */
    'inputs': DocumentClassifierWorkOrderInput;
    /**
     * 
     * @type {ClassifierDatasetToPipelineWorkerOutput}
     * @memberof DocumentClassifierWorkOrderOut
     */
    'outputs': ClassifierDatasetToPipelineWorkerOutput;
    /**
     * 
     * @type {object}
     * @memberof DocumentClassifierWorkOrderOut
     */
    'errors': object;
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierWorkOrderOut
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierWorkOrderOut
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface DocumentClassifierWorkOrderUpdate
 */
export interface DocumentClassifierWorkOrderUpdate {
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof DocumentClassifierWorkOrderUpdate
     */
    'order_status'?: WorkOrderStatus | null;
    /**
     * 
     * @type {Inputs}
     * @memberof DocumentClassifierWorkOrderUpdate
     */
    'inputs'?: Inputs | null;
    /**
     * 
     * @type {Outputs}
     * @memberof DocumentClassifierWorkOrderUpdate
     */
    'outputs'?: Outputs | null;
    /**
     * 
     * @type {object}
     * @memberof DocumentClassifierWorkOrderUpdate
     */
    'errors'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentClassifierWorkOrderUpdate
     */
    'created_by'?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentDatasetFullOut
 */
export interface DocumentDatasetFullOut {
    /**
     * 
     * @type {DocumentDatasetOut}
     * @memberof DocumentDatasetFullOut
     */
    'dataset': DocumentDatasetOut;
    /**
     * 
     * @type {number}
     * @memberof DocumentDatasetFullOut
     */
    'total_records': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentDatasetFullOut
     */
    'total_records_with_annotations': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentDatasetFullOut
     */
    'total_annotations': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentDatasetFullOut
     */
    'average_records_image_height': number;
    /**
     * 
     * @type {number}
     * @memberof DocumentDatasetFullOut
     */
    'average_records_image_width': number;
}
/**
 * 
 * @export
 * @interface DocumentDatasetOut
 */
export interface DocumentDatasetOut {
    /**
     * 
     * @type {string}
     * @memberof DocumentDatasetOut
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDatasetOut
     */
    'name': string;
    /**
     * 
     * @type {CreatedBy}
     * @memberof DocumentDatasetOut
     */
    'created_by': CreatedBy;
    /**
     * 
     * @type {string}
     * @memberof DocumentDatasetOut
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentDatasetOut
     */
    'created_at': string;
    /**
     * 
     * @type {object}
     * @memberof DocumentDatasetOut
     */
    'attributes': object;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDatasetOut
     */
    'should_compute_ocr': boolean;
    /**
     * 
     * @type {Array<OcrLabelsInner>}
     * @memberof DocumentDatasetOut
     */
    'ocr_labels': Array<OcrLabelsInner>;
    /**
     * 
     * @type {DatasetParameters}
     * @memberof DocumentDatasetOut
     */
    'dataset_parameters': DatasetParameters;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const DocumentDatasetSortBy = {
    NumberOfLabels: 'NUMBER_OF_LABELS',
    DateCreated: 'DATE_CREATED',
    DateUpdated: 'DATE_UPDATED',
    Name: 'NAME'
} as const;

export type DocumentDatasetSortBy = typeof DocumentDatasetSortBy[keyof typeof DocumentDatasetSortBy];


/**
 * 
 * @export
 * @interface EmailVerificationRequest
 */
export interface EmailVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailVerificationRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface EmailVerificationToken
 */
export interface EmailVerificationToken {
    /**
     * 
     * @type {string}
     * @memberof EmailVerificationToken
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface EvaluationReport
 */
export interface EvaluationReport {
    /**
     * 
     * @type {Array<SufganiyotModelEvaluationReportRow>}
     * @memberof EvaluationReport
     */
    'rows': Array<SufganiyotModelEvaluationReportRow>;
}
/**
 * 
 * @export
 * @interface FileObject
 */
export interface FileObject {
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    '_id': string;
    /**
     * 
     * @type {BucketOut}
     * @memberof FileObject
     */
    'bucket': BucketOut;
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    'original_file_name': string;
    /**
     * 
     * @type {string}
     * @memberof FileObject
     */
    'mime_type': string;
    /**
     * 
     * @type {number}
     * @memberof FileObject
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface FileObject1
 */
export interface FileObject1 {
    /**
     * 
     * @type {string}
     * @memberof FileObject1
     */
    '_id': string;
    /**
     * 
     * @type {BucketOut}
     * @memberof FileObject1
     */
    'bucket': BucketOut;
    /**
     * 
     * @type {string}
     * @memberof FileObject1
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof FileObject1
     */
    'original_file_name': string;
    /**
     * 
     * @type {string}
     * @memberof FileObject1
     */
    'mime_type': string;
    /**
     * 
     * @type {number}
     * @memberof FileObject1
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface FileObjectOut
 */
export interface FileObjectOut {
    /**
     * 
     * @type {string}
     * @memberof FileObjectOut
     */
    '_id': string;
    /**
     * 
     * @type {BucketOut}
     * @memberof FileObjectOut
     */
    'bucket': BucketOut;
    /**
     * 
     * @type {string}
     * @memberof FileObjectOut
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof FileObjectOut
     */
    'original_file_name': string;
    /**
     * 
     * @type {string}
     * @memberof FileObjectOut
     */
    'mime_type': string;
    /**
     * 
     * @type {number}
     * @memberof FileObjectOut
     */
    'size': number;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const GenericSortBy = {
    Created: 'DATE_CREATED',
    Updated: 'DATE_UPDATED'
} as const;

export type GenericSortBy = typeof GenericSortBy[keyof typeof GenericSortBy];


/**
 * 
 * @export
 * @interface GenericWorkOrderOut
 */
export interface GenericWorkOrderOut {
    /**
     * 
     * @type {string}
     * @memberof GenericWorkOrderOut
     */
    '_id': string;
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof GenericWorkOrderOut
     */
    'order_status': WorkOrderStatus;
    /**
     * 
     * @type {WorkOrderType}
     * @memberof GenericWorkOrderOut
     */
    'order_type': WorkOrderType;
    /**
     * 
     * @type {object}
     * @memberof GenericWorkOrderOut
     */
    'inputs': object;
    /**
     * 
     * @type {object}
     * @memberof GenericWorkOrderOut
     */
    'errors': object;
    /**
     * 
     * @type {string}
     * @memberof GenericWorkOrderOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof GenericWorkOrderOut
     */
    'created_by': string;
    /**
     * 
     * @type {DatasetToPipelineWorkerOutput}
     * @memberof GenericWorkOrderOut
     */
    'outputs': DatasetToPipelineWorkerOutput;
}
/**
 * 
 * @export
 * @interface GroupId
 */
export interface GroupId {
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface Id
 */
export interface Id {
}
/**
 * 
 * @export
 * @interface Inputs
 */
export interface Inputs {
    /**
     * 
     * @type {string}
     * @memberof Inputs
     */
    'dataset_id': string;
}
/**
 * 
 * @export
 * @interface Inputs1
 */
export interface Inputs1 {
    /**
     * 
     * @type {string}
     * @memberof Inputs1
     */
    'dataset_id': string;
    /**
     * 
     * @type {SufganiyotWorkOrderModelConfig}
     * @memberof Inputs1
     */
    'custom_model_config'?: SufganiyotWorkOrderModelConfig;
}
/**
 * 
 * @export
 * @interface Inputs2
 */
export interface Inputs2 {
    /**
     * 
     * @type {string}
     * @memberof Inputs2
     */
    'pipeline_name': string;
    /**
     * 
     * @type {string}
     * @memberof Inputs2
     */
    'prompt_extension': string;
    /**
     * 
     * @type {ZeroShotGPTModelChoice}
     * @memberof Inputs2
     */
    'gpt_model'?: ZeroShotGPTModelChoice;
    /**
     * 
     * @type {Array<AppRoutersSchemasZeroShotZeroShotQuestionLabel>}
     * @memberof Inputs2
     */
    'question_labels': Array<AppRoutersSchemasZeroShotZeroShotQuestionLabel>;
    /**
     * 
     * @type {string}
     * @memberof Inputs2
     */
    'document_language'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Inputs2
     */
    'activate_double_shot'?: boolean;
}
/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * 
 * @export
 * @interface ManyAPIKeys
 */
export interface ManyAPIKeys {
    /**
     * 
     * @type {Array<APIKeyOut>}
     * @memberof ManyAPIKeys
     */
    'apikeys': Array<APIKeyOut>;
}
/**
 * 
 * @export
 * @interface ManyDatasetRecordFileDataOut
 */
export interface ManyDatasetRecordFileDataOut {
    /**
     * 
     * @type {number}
     * @memberof ManyDatasetRecordFileDataOut
     */
    'total': number;
    /**
     * 
     * @type {Array<DatasetRecordFileDataOut>}
     * @memberof ManyDatasetRecordFileDataOut
     */
    'files_data': Array<DatasetRecordFileDataOut>;
}
/**
 * 
 * @export
 * @interface ManyDatasetRecordGroup
 */
export interface ManyDatasetRecordGroup {
    /**
     * 
     * @type {number}
     * @memberof ManyDatasetRecordGroup
     */
    'total': number;
    /**
     * 
     * @type {Array<DatasetRecordGroupForMany>}
     * @memberof ManyDatasetRecordGroup
     */
    'data': Array<DatasetRecordGroupForMany>;
}
/**
 * 
 * @export
 * @interface ManyDocumentClassifierModelOut
 */
export interface ManyDocumentClassifierModelOut {
    /**
     * 
     * @type {Array<DocumentClassifierModelOut>}
     * @memberof ManyDocumentClassifierModelOut
     */
    'models'?: Array<DocumentClassifierModelOut>;
    /**
     * 
     * @type {number}
     * @memberof ManyDocumentClassifierModelOut
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ManyDocumentClassifierWorkOrderOut
 */
export interface ManyDocumentClassifierWorkOrderOut {
    /**
     * 
     * @type {Array<DocumentClassifierWorkOrderOut>}
     * @memberof ManyDocumentClassifierWorkOrderOut
     */
    'orders'?: Array<DocumentClassifierWorkOrderOut>;
}
/**
 * 
 * @export
 * @interface ManyDocumentDatasetOut
 */
export interface ManyDocumentDatasetOut {
    /**
     * 
     * @type {Array<DocumentDatasetOut>}
     * @memberof ManyDocumentDatasetOut
     */
    'datasets': Array<DocumentDatasetOut>;
    /**
     * 
     * @type {number}
     * @memberof ManyDocumentDatasetOut
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ManyGenericWorkOrderOut
 */
export interface ManyGenericWorkOrderOut {
    /**
     * 
     * @type {Array<GenericWorkOrderOut>}
     * @memberof ManyGenericWorkOrderOut
     */
    'orders'?: Array<GenericWorkOrderOut>;
}
/**
 * 
 * @export
 * @interface ManyNotificationsOut
 */
export interface ManyNotificationsOut {
    /**
     * 
     * @type {number}
     * @memberof ManyNotificationsOut
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof ManyNotificationsOut
     */
    'unread'?: number;
    /**
     * 
     * @type {Array<NotificationOut>}
     * @memberof ManyNotificationsOut
     */
    'notifications': Array<NotificationOut>;
}
/**
 * 
 * @export
 * @interface ManyOCRLabelOut
 */
export interface ManyOCRLabelOut {
    /**
     * 
     * @type {number}
     * @memberof ManyOCRLabelOut
     */
    'total': number;
    /**
     * 
     * @type {Array<OCRLabelOut>}
     * @memberof ManyOCRLabelOut
     */
    'ocr_labels': Array<OCRLabelOut>;
}
/**
 * 
 * @export
 * @interface ManyPipelineLogOut
 */
export interface ManyPipelineLogOut {
    /**
     * 
     * @type {Array<PipelineLogOut>}
     * @memberof ManyPipelineLogOut
     */
    'logs': Array<PipelineLogOut>;
    /**
     * 
     * @type {number}
     * @memberof ManyPipelineLogOut
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ManyPipelineModelOut
 */
export interface ManyPipelineModelOut {
    /**
     * 
     * @type {Array<PipelineModelOut>}
     * @memberof ManyPipelineModelOut
     */
    'models'?: Array<PipelineModelOut>;
    /**
     * 
     * @type {number}
     * @memberof ManyPipelineModelOut
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ManyPipelineResultFileDataOut
 */
export interface ManyPipelineResultFileDataOut {
    /**
     * 
     * @type {number}
     * @memberof ManyPipelineResultFileDataOut
     */
    'total': number;
    /**
     * 
     * @type {Array<PipelineResultFileDataOut>}
     * @memberof ManyPipelineResultFileDataOut
     */
    'files_data': Array<PipelineResultFileDataOut>;
}
/**
 * 
 * @export
 * @interface ManyPipelineResultGroup
 */
export interface ManyPipelineResultGroup {
    /**
     * 
     * @type {number}
     * @memberof ManyPipelineResultGroup
     */
    'total': number;
    /**
     * 
     * @type {Array<PipelineResultGroupForMany>}
     * @memberof ManyPipelineResultGroup
     */
    'data': Array<PipelineResultGroupForMany>;
}
/**
 * 
 * @export
 * @interface ManyPipelinesOut
 */
export interface ManyPipelinesOut {
    /**
     * 
     * @type {Array<PipelineOut>}
     * @memberof ManyPipelinesOut
     */
    'pipelines': Array<PipelineOut>;
    /**
     * 
     * @type {number}
     * @memberof ManyPipelinesOut
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ManyPipelinesResultOut
 */
export interface ManyPipelinesResultOut {
    /**
     * 
     * @type {Array<PipelineResultOut>}
     * @memberof ManyPipelinesResultOut
     */
    'results': Array<PipelineResultOut>;
    /**
     * 
     * @type {number}
     * @memberof ManyPipelinesResultOut
     */
    'total_pending_pipeline_results': number;
    /**
     * 
     * @type {number}
     * @memberof ManyPipelinesResultOut
     */
    'total_results': number;
}
/**
 * 
 * @export
 * @interface ManyPremiumRequests
 */
export interface ManyPremiumRequests {
    /**
     * 
     * @type {Array<PremiumRequest>}
     * @memberof ManyPremiumRequests
     */
    'requests': Array<PremiumRequest>;
}
/**
 * 
 * @export
 * @interface ManyRabbitMQQueueStat
 */
export interface ManyRabbitMQQueueStat {
    /**
     * 
     * @type {Array<RabbitMQQueueStat>}
     * @memberof ManyRabbitMQQueueStat
     */
    'queues': Array<RabbitMQQueueStat>;
}
/**
 * 
 * @export
 * @interface ManyRecentPipelineResults
 */
export interface ManyRecentPipelineResults {
    /**
     * 
     * @type {Array<RecentPipelineResultOut>}
     * @memberof ManyRecentPipelineResults
     */
    'results': Array<RecentPipelineResultOut>;
    /**
     * 
     * @type {number}
     * @memberof ManyRecentPipelineResults
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ManySmartSmartOCRRecordOut
 */
export interface ManySmartSmartOCRRecordOut {
    /**
     * 
     * @type {Array<RecordsInner>}
     * @memberof ManySmartSmartOCRRecordOut
     */
    'records': Array<RecordsInner>;
    /**
     * 
     * @type {Array<RecordsInner>}
     * @memberof ManySmartSmartOCRRecordOut
     */
    'next_records': Array<RecordsInner>;
    /**
     * 
     * @type {Array<RecordsInner>}
     * @memberof ManySmartSmartOCRRecordOut
     */
    'previous_records': Array<RecordsInner>;
    /**
     * 
     * @type {number}
     * @memberof ManySmartSmartOCRRecordOut
     */
    'total_records': number;
    /**
     * 
     * @type {number}
     * @memberof ManySmartSmartOCRRecordOut
     */
    'total_records_with_annotations': number;
    /**
     * 
     * @type {number}
     * @memberof ManySmartSmartOCRRecordOut
     */
    'total_annotations': number;
    /**
     * 
     * @type {number}
     * @memberof ManySmartSmartOCRRecordOut
     */
    'average_records_image_height': number;
    /**
     * 
     * @type {number}
     * @memberof ManySmartSmartOCRRecordOut
     */
    'average_records_image_width': number;
}
/**
 * 
 * @export
 * @interface ManySufganiyotWorkOrderOut
 */
export interface ManySufganiyotWorkOrderOut {
    /**
     * 
     * @type {Array<SufganiyotWorkOrderOut>}
     * @memberof ManySufganiyotWorkOrderOut
     */
    'orders'?: Array<SufganiyotWorkOrderOut>;
}
/**
 * 
 * @export
 * @interface ManyUsersOut
 */
export interface ManyUsersOut {
    /**
     * 
     * @type {number}
     * @memberof ManyUsersOut
     */
    'count'?: number;
    /**
     * 
     * @type {Array<UserOut>}
     * @memberof ManyUsersOut
     */
    'users': Array<UserOut>;
}
/**
 * 
 * @export
 * @interface ManyZeroShotWorkOrderOut
 */
export interface ManyZeroShotWorkOrderOut {
    /**
     * 
     * @type {Array<ZeroShotWorkOrderOut>}
     * @memberof ManyZeroShotWorkOrderOut
     */
    'orders'?: Array<ZeroShotWorkOrderOut>;
}
/**
 * 
 * @export
 * @interface MiniFileObjectInfoOut
 */
export interface MiniFileObjectInfoOut {
    /**
     * 
     * @type {string}
     * @memberof MiniFileObjectInfoOut
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof MiniFileObjectInfoOut
     */
    'original_file_name': string;
}
/**
 * 
 * @export
 * @interface ModelBinariesZip
 */
export interface ModelBinariesZip {
    /**
     * 
     * @type {string}
     * @memberof ModelBinariesZip
     */
    '_id': string;
    /**
     * 
     * @type {BucketOut}
     * @memberof ModelBinariesZip
     */
    'bucket': BucketOut;
    /**
     * 
     * @type {string}
     * @memberof ModelBinariesZip
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof ModelBinariesZip
     */
    'original_file_name': string;
    /**
     * 
     * @type {string}
     * @memberof ModelBinariesZip
     */
    'mime_type': string;
    /**
     * 
     * @type {number}
     * @memberof ModelBinariesZip
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface ModelConfig
 */
export interface ModelConfig {
    /**
     * 
     * @type {object}
     * @memberof ModelConfig
     */
    'preprocess': object;
    /**
     * 
     * @type {object}
     * @memberof ModelConfig
     */
    'training': object;
    /**
     * 
     * @type {object}
     * @memberof ModelConfig
     */
    'postprocess': object;
    /**
     * 
     * @type {object}
     * @memberof ModelConfig
     */
    'multiprocessing'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof ModelConfig
     */
    'evaluation': object;
    /**
     * 
     * @type {SufganiyotModelConfigDataset}
     * @memberof ModelConfig
     */
    'dataset': SufganiyotModelConfigDataset;
    /**
     * 
     * @type {SufganiyotModelConfigDonutPreprocessor}
     * @memberof ModelConfig
     */
    'donut_preprocessor': SufganiyotModelConfigDonutPreprocessor;
    /**
     * 
     * @type {SufganiyotModelDonutModel}
     * @memberof ModelConfig
     */
    'donut_model': SufganiyotModelDonutModel;
}
/**
 * 
 * @export
 * @interface ModelConfig1
 */
export interface ModelConfig1 {
    /**
     * 
     * @type {object}
     * @memberof ModelConfig1
     */
    'preprocess': object;
    /**
     * 
     * @type {object}
     * @memberof ModelConfig1
     */
    'training': object;
    /**
     * 
     * @type {object}
     * @memberof ModelConfig1
     */
    'postprocess': object;
    /**
     * 
     * @type {object}
     * @memberof ModelConfig1
     */
    'multiprocessing'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof ModelConfig1
     */
    'evaluation': object;
    /**
     * 
     * @type {SufganiyotModelConfigDataset}
     * @memberof ModelConfig1
     */
    'dataset': SufganiyotModelConfigDataset;
    /**
     * 
     * @type {SufganiyotModelConfigDonutPreprocessor}
     * @memberof ModelConfig1
     */
    'donut_preprocessor': SufganiyotModelConfigDonutPreprocessor;
    /**
     * 
     * @type {SufganiyotModelDonutModel}
     * @memberof ModelConfig1
     */
    'donut_model': SufganiyotModelDonutModel;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const ModelTrainingStatus = {
    NotTraining: 'NOT_TRAINING',
    Training: 'TRAINING',
    Ready: 'READY'
} as const;

export type ModelTrainingStatus = typeof ModelTrainingStatus[keyof typeof ModelTrainingStatus];


/**
 * 
 * @export
 * @interface NewAPIKey
 */
export interface NewAPIKey {
    /**
     * 
     * @type {Array<string>}
     * @memberof NewAPIKey
     */
    'pipelines': Array<string>;
}
/**
 * 
 * @export
 * @interface NewDocumentDataset
 */
export interface NewDocumentDataset {
    /**
     * 
     * @type {string}
     * @memberof NewDocumentDataset
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NewDocumentDataset
     */
    'ocr_labels': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof NewDocumentDataset
     */
    'should_compute_ocr'?: boolean;
    /**
     * 
     * @type {DatasetParameters}
     * @memberof NewDocumentDataset
     */
    'dataset_parameters'?: DatasetParameters;
    /**
     * 
     * @type {object}
     * @memberof NewDocumentDataset
     */
    'attributes'?: object;
}
/**
 * 
 * @export
 * @interface NewPipeline
 */
export interface NewPipeline {
    /**
     * 
     * @type {PipelineVariant}
     * @memberof NewPipeline
     */
    'pipeline_variant': PipelineVariant;
    /**
     * 
     * @type {PipelineConfiguration}
     * @memberof NewPipeline
     */
    'pipeline_configuration': PipelineConfiguration;
    /**
     * 
     * @type {string}
     * @memberof NewPipeline
     */
    'pipeline_name': string;
    /**
     * 
     * @type {string}
     * @memberof NewPipeline
     */
    'created_by'?: string | null;
}
/**
 * 
 * @export
 * @interface NotificationCreate
 */
export interface NotificationCreate {
    /**
     * 
     * @type {string}
     * @memberof NotificationCreate
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationCreate
     */
    'icon'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationCreate
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface NotificationOut
 */
export interface NotificationOut {
    /**
     * 
     * @type {string}
     * @memberof NotificationOut
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationOut
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationOut
     */
    'icon'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationOut
     */
    'created_at': string;
    /**
     * 
     * @type {UserOut}
     * @memberof NotificationOut
     */
    'user': UserOut;
    /**
     * 
     * @type {string}
     * @memberof NotificationOut
     */
    'date_seen'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationOut
     */
    'has_been_seen'?: boolean;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const NotificationType = {
    All: 'ALL',
    Seen: 'SEEN',
    Unseen: 'UNSEEN'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


/**
 * 
 * @export
 * @interface OCRLabelBase
 */
export interface OCRLabelBase {
    /**
     * 
     * @type {string}
     * @memberof OCRLabelBase
     */
    'label_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelBase
     */
    'is_datetime': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelBase
     */
    'has_regex': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelBase
     */
    'is_float': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelBase
     */
    'is_percent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelBase
     */
    'is_money': boolean;
    /**
     * 
     * @type {string}
     * @memberof OCRLabelBase
     */
    'regex'?: string | null;
}
/**
 * 
 * @export
 * @interface OCRLabelEdit
 */
export interface OCRLabelEdit {
    /**
     * 
     * @type {string}
     * @memberof OCRLabelEdit
     */
    'label_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelEdit
     */
    'is_datetime'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelEdit
     */
    'has_regex'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelEdit
     */
    'is_float'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelEdit
     */
    'is_percent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelEdit
     */
    'is_money'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OCRLabelEdit
     */
    'regex'?: string | null;
}
/**
 * 
 * @export
 * @interface OCRLabelOut
 */
export interface OCRLabelOut {
    /**
     * 
     * @type {string}
     * @memberof OCRLabelOut
     */
    'label_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelOut
     */
    'is_datetime': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelOut
     */
    'has_regex': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelOut
     */
    'is_float': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelOut
     */
    'is_percent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OCRLabelOut
     */
    'is_money': boolean;
    /**
     * 
     * @type {string}
     * @memberof OCRLabelOut
     */
    'regex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OCRLabelOut
     */
    '_id': string;
    /**
     * 
     * @type {Array<any>}
     * @memberof OCRLabelOut
     */
    'datasets': Array<any>;
    /**
     * 
     * @type {string}
     * @memberof OCRLabelOut
     */
    'created_at': string;
    /**
     * 
     * @type {UserOut}
     * @memberof OCRLabelOut
     */
    'created_by': UserOut;
}
/**
 * 
 * @export
 * @interface OCRToken
 */
export interface OCRToken {
    /**
     * 
     * @type {number}
     * @memberof OCRToken
     */
    'n_token': number;
    /**
     * 
     * @type {string}
     * @memberof OCRToken
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof OCRToken
     */
    'confidence': number;
    /**
     * 
     * @type {number}
     * @memberof OCRToken
     */
    'top': number;
    /**
     * 
     * @type {number}
     * @memberof OCRToken
     */
    'left': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof OCRToken
     */
    'box': Array<number>;
    /**
     * 
     * @type {number}
     * @memberof OCRToken
     */
    'box_width': number;
    /**
     * 
     * @type {number}
     * @memberof OCRToken
     */
    'box_height': number;
    /**
     * 
     * @type {number}
     * @memberof OCRToken
     */
    'x_position': number;
    /**
     * 
     * @type {number}
     * @memberof OCRToken
     */
    'y_position': number;
    /**
     * 
     * @type {number}
     * @memberof OCRToken
     */
    'n_line': number;
}
/**
 * 
 * @export
 * @interface OcrLabel
 */
export interface OcrLabel {
    /**
     * 
     * @type {string}
     * @memberof OcrLabel
     */
    'label_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof OcrLabel
     */
    'is_datetime': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcrLabel
     */
    'has_regex': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcrLabel
     */
    'is_float': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcrLabel
     */
    'is_percent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcrLabel
     */
    'is_money': boolean;
    /**
     * 
     * @type {string}
     * @memberof OcrLabel
     */
    'regex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OcrLabel
     */
    '_id': string;
    /**
     * 
     * @type {Array<any>}
     * @memberof OcrLabel
     */
    'datasets': Array<any>;
    /**
     * 
     * @type {string}
     * @memberof OcrLabel
     */
    'created_at': string;
    /**
     * 
     * @type {UserOut}
     * @memberof OcrLabel
     */
    'created_by': UserOut;
}
/**
 * 
 * @export
 * @interface OcrLabel1
 */
export interface OcrLabel1 {
}
/**
 * 
 * @export
 * @interface OcrLabelsInner
 */
export interface OcrLabelsInner {
    /**
     * 
     * @type {string}
     * @memberof OcrLabelsInner
     */
    'label_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof OcrLabelsInner
     */
    'is_datetime': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcrLabelsInner
     */
    'has_regex': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcrLabelsInner
     */
    'is_float': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcrLabelsInner
     */
    'is_percent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OcrLabelsInner
     */
    'is_money': boolean;
    /**
     * 
     * @type {string}
     * @memberof OcrLabelsInner
     */
    'regex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OcrLabelsInner
     */
    '_id': string;
    /**
     * 
     * @type {Array<any>}
     * @memberof OcrLabelsInner
     */
    'datasets': Array<any>;
    /**
     * 
     * @type {string}
     * @memberof OcrLabelsInner
     */
    'created_at': string;
    /**
     * 
     * @type {UserOut}
     * @memberof OcrLabelsInner
     */
    'created_by': UserOut;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const OrderDirection = {
    Ascending: 'ASCENDING',
    Descending: 'DESCENDING'
} as const;

export type OrderDirection = typeof OrderDirection[keyof typeof OrderDirection];


/**
 * 
 * @export
 * @interface Outputs
 */
export interface Outputs {
    /**
     * 
     * @type {string}
     * @memberof Outputs
     */
    'classifier_model_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Outputs
     */
    'pipeline_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Outputs
     */
    'elapsed_seconds'?: number | null;
}
/**
 * 
 * @export
 * @interface Outputs1
 */
export interface Outputs1 {
    /**
     * 
     * @type {string}
     * @memberof Outputs1
     */
    'model_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Outputs1
     */
    'pipeline_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Outputs1
     */
    'elapsed_seconds'?: number | null;
}
/**
 * 
 * @export
 * @interface Owner
 */
export interface Owner {
    /**
     * 
     * @type {string}
     * @memberof Owner
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof Owner
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof Owner
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof Owner
     */
    'api_calls': number;
    /**
     * 
     * @type {BusinessModel}
     * @memberof Owner
     */
    'business_model'?: BusinessModel;
    /**
     * 
     * @type {string}
     * @memberof Owner
     */
    'organization': string;
    /**
     * 
     * @type {UserRoles}
     * @memberof Owner
     */
    'role'?: UserRoles;
    /**
     * 
     * @type {boolean}
     * @memberof Owner
     */
    'verified'?: boolean;
}
/**
 * 
 * @export
 * @interface Owner1
 */
export interface Owner1 {
    /**
     * 
     * @type {string}
     * @memberof Owner1
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof Owner1
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof Owner1
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof Owner1
     */
    'api_calls': number;
    /**
     * 
     * @type {BusinessModel}
     * @memberof Owner1
     */
    'business_model'?: BusinessModel;
    /**
     * 
     * @type {string}
     * @memberof Owner1
     */
    'organization': string;
    /**
     * 
     * @type {UserRoles}
     * @memberof Owner1
     */
    'role'?: UserRoles;
    /**
     * 
     * @type {boolean}
     * @memberof Owner1
     */
    'verified'?: boolean;
}
/**
 * 
 * @export
 * @interface PDFObjectDocumentDatasetOut
 */
export interface PDFObjectDocumentDatasetOut {
    /**
     * 
     * @type {string}
     * @memberof PDFObjectDocumentDatasetOut
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof PDFObjectDocumentDatasetOut
     */
    'display_name': string;
    /**
     * 
     * @type {CreatedBy}
     * @memberof PDFObjectDocumentDatasetOut
     */
    'created_by': CreatedBy;
    /**
     * 
     * @type {string}
     * @memberof PDFObjectDocumentDatasetOut
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof PDFObjectDocumentDatasetOut
     */
    'created_at': string;
    /**
     * 
     * @type {object}
     * @memberof PDFObjectDocumentDatasetOut
     */
    'attributes': object;
    /**
     * 
     * @type {boolean}
     * @memberof PDFObjectDocumentDatasetOut
     */
    'should_compute_ocr': boolean;
    /**
     * 
     * @type {Array<OcrLabelsInner>}
     * @memberof PDFObjectDocumentDatasetOut
     */
    'ocr_labels': Array<OcrLabelsInner>;
    /**
     * 
     * @type {DatasetParameters}
     * @memberof PDFObjectDocumentDatasetOut
     */
    'dataset_parameters': DatasetParameters;
}
/**
 * 
 * @export
 * @interface PDFObjectEdit
 */
export interface PDFObjectEdit {
    /**
     * 
     * @type {PDFStatus}
     * @memberof PDFObjectEdit
     */
    'status'?: PDFStatus;
    /**
     * 
     * @type {string}
     * @memberof PDFObjectEdit
     */
    'notification_id'?: string;
}
/**
 * 
 * @export
 * @interface PDFObjectOut
 */
export interface PDFObjectOut {
    /**
     * 
     * @type {PDFStatus}
     * @memberof PDFObjectOut
     */
    'status': PDFStatus;
    /**
     * 
     * @type {NotificationOut}
     * @memberof PDFObjectOut
     */
    'error_notification'?: NotificationOut;
    /**
     * 
     * @type {FileObjectOut}
     * @memberof PDFObjectOut
     */
    'file_object': FileObjectOut;
    /**
     * 
     * @type {string}
     * @memberof PDFObjectOut
     */
    'pdfuid': string;
    /**
     * 
     * @type {PDFResourceType}
     * @memberof PDFObjectOut
     */
    'resource_type': PDFResourceType;
    /**
     * 
     * @type {Owner}
     * @memberof PDFObjectOut
     */
    'owner': Owner;
    /**
     * 
     * @type {string}
     * @memberof PDFObjectOut
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof PDFObjectOut
     */
    'created_at': string;
    /**
     * 
     * @type {PipelineOut}
     * @memberof PDFObjectOut
     */
    'pipeline'?: PipelineOut;
    /**
     * 
     * @type {PDFObjectDocumentDatasetOut}
     * @memberof PDFObjectOut
     */
    'dataset'?: PDFObjectDocumentDatasetOut;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PDFResourceType = {
    DatasetRecord: 'DATASET_RECORD',
    PipelineResult: 'PIPELINE_RESULT'
} as const;

export type PDFResourceType = typeof PDFResourceType[keyof typeof PDFResourceType];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PDFStatus = {
    Ready: 'READY',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type PDFStatus = typeof PDFStatus[keyof typeof PDFStatus];


/**
 * 
 * @export
 * @interface PDFUIDResponse
 */
export interface PDFUIDResponse {
    /**
     * 
     * @type {string}
     * @memberof PDFUIDResponse
     */
    'pdfuid': string;
}
/**
 * 
 * @export
 * @interface PipelineConfiguration
 */
export interface PipelineConfiguration {
    /**
     * 
     * @type {string}
     * @memberof PipelineConfiguration
     */
    'model_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipelineConfiguration
     */
    'classifier_model_id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipelineConfiguration
     */
    'document_dataset_id'?: string | null;
    /**
     * 
     * @type {ZeroShotConfig}
     * @memberof PipelineConfiguration
     */
    'zero_shot_config'?: ZeroShotConfig | null;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PipelineDeploymentStatus = {
    Ready: 'READY',
    Deployed: 'DEPLOYED'
} as const;

export type PipelineDeploymentStatus = typeof PipelineDeploymentStatus[keyof typeof PipelineDeploymentStatus];


/**
 * 
 * @export
 * @interface PipelineLogOut
 */
export interface PipelineLogOut {
    /**
     * 
     * @type {UserOut}
     * @memberof PipelineLogOut
     */
    'user_who_logged'?: UserOut;
    /**
     * 
     * @type {PipelineDeploymentStatus}
     * @memberof PipelineLogOut
     */
    'status_when_logged': PipelineDeploymentStatus;
    /**
     * 
     * @type {string}
     * @memberof PipelineLogOut
     */
    'date_logged': string;
    /**
     * 
     * @type {UserOut}
     * @memberof PipelineLogOut
     */
    'pipeline_owner': UserOut;
    /**
     * 
     * @type {PipelineOut}
     * @memberof PipelineLogOut
     */
    'pipeline': PipelineOut;
}
/**
 * 
 * @export
 * @interface PipelineModelConfig
 */
export interface PipelineModelConfig {
    /**
     * 
     * @type {object}
     * @memberof PipelineModelConfig
     */
    'preprocess': object;
    /**
     * 
     * @type {object}
     * @memberof PipelineModelConfig
     */
    'training': object;
    /**
     * 
     * @type {object}
     * @memberof PipelineModelConfig
     */
    'postprocess': object;
    /**
     * 
     * @type {object}
     * @memberof PipelineModelConfig
     */
    'multiprocessing'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof PipelineModelConfig
     */
    'evaluation': object;
}
/**
 * 
 * @export
 * @interface PipelineModelEdit
 */
export interface PipelineModelEdit {
    /**
     * 
     * @type {string}
     * @memberof PipelineModelEdit
     */
    'dataset_hash'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PipelineModelEdit
     */
    'dataset_id'?: string | null;
    /**
     * 
     * @type {ModelConfig}
     * @memberof PipelineModelEdit
     */
    'model_config'?: ModelConfig | null;
    /**
     * 
     * @type {EvaluationReport}
     * @memberof PipelineModelEdit
     */
    'evaluation_report'?: EvaluationReport | null;
    /**
     * 
     * @type {ModelTrainingStatus}
     * @memberof PipelineModelEdit
     */
    'status'?: ModelTrainingStatus | null;
    /**
     * 
     * @type {object}
     * @memberof PipelineModelEdit
     */
    'attributes'?: object | null;
}
/**
 * 
 * @export
 * @interface PipelineModelEvaluationReport
 */
export interface PipelineModelEvaluationReport {
    /**
     * 
     * @type {Array<SufganiyotModelEvaluationReportRow>}
     * @memberof PipelineModelEvaluationReport
     */
    'rows': Array<SufganiyotModelEvaluationReportRow>;
}
/**
 * 
 * @export
 * @interface PipelineModelOut
 */
export interface PipelineModelOut {
    /**
     * 
     * @type {string}
     * @memberof PipelineModelOut
     */
    '_id': string;
    /**
     * 
     * @type {Dataset}
     * @memberof PipelineModelOut
     */
    'dataset': Dataset;
    /**
     * 
     * @type {PipelineModelVariant}
     * @memberof PipelineModelOut
     */
    'variant': PipelineModelVariant;
    /**
     * 
     * @type {ModelConfig1}
     * @memberof PipelineModelOut
     */
    'model_config': ModelConfig1;
    /**
     * 
     * @type {PipelineModelEvaluationReport}
     * @memberof PipelineModelOut
     */
    'evaluation_report': PipelineModelEvaluationReport;
    /**
     * 
     * @type {object}
     * @memberof PipelineModelOut
     */
    'attributes'?: object | null;
    /**
     * 
     * @type {ModelBinariesZip}
     * @memberof PipelineModelOut
     */
    'model_binaries_zip': ModelBinariesZip;
    /**
     * 
     * @type {ModelTrainingStatus}
     * @memberof PipelineModelOut
     */
    'status': ModelTrainingStatus;
    /**
     * 
     * @type {string}
     * @memberof PipelineModelOut
     */
    'dataset_hash'?: string;
    /**
     * 
     * @type {CreatedBy}
     * @memberof PipelineModelOut
     */
    'created_by': CreatedBy;
    /**
     * 
     * @type {string}
     * @memberof PipelineModelOut
     */
    'created_at': string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PipelineModelVariant = {
    SufganiyotDocumentParser: 'SUFGANIYOT_DOCUMENT_PARSER',
    DocumentClassifier: 'DOCUMENT_CLASSIFIER',
    ZeroShot: 'ZERO_SHOT'
} as const;

export type PipelineModelVariant = typeof PipelineModelVariant[keyof typeof PipelineModelVariant];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PipelineModelVariantsForUI = {
    All: 'ALL',
    SufganiyotDocumentParser: 'SUFGANIYOT_DOCUMENT_PARSER',
    DocumentClassifier: 'DOCUMENT_CLASSIFIER',
    ZeroShot: 'ZERO_SHOT'
} as const;

export type PipelineModelVariantsForUI = typeof PipelineModelVariantsForUI[keyof typeof PipelineModelVariantsForUI];


/**
 * 
 * @export
 * @interface PipelineOut
 */
export interface PipelineOut {
    /**
     * 
     * @type {PipelineVariant}
     * @memberof PipelineOut
     */
    'pipeline_variant': PipelineVariant;
    /**
     * 
     * @type {PipelineConfiguration}
     * @memberof PipelineOut
     */
    'pipeline_configuration': PipelineConfiguration;
    /**
     * 
     * @type {string}
     * @memberof PipelineOut
     */
    'pipeline_name': string;
    /**
     * 
     * @type {CreatedBy}
     * @memberof PipelineOut
     */
    'created_by': CreatedBy;
    /**
     * 
     * @type {string}
     * @memberof PipelineOut
     */
    '_id': string;
    /**
     * 
     * @type {PipelineDeploymentStatus}
     * @memberof PipelineOut
     */
    'deployment_status': PipelineDeploymentStatus;
    /**
     * 
     * @type {number}
     * @memberof PipelineOut
     */
    'total_results': number;
    /**
     * 
     * @type {string}
     * @memberof PipelineOut
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface PipelineResultFileDataOut
 */
export interface PipelineResultFileDataOut {
    /**
     * 
     * @type {string}
     * @memberof PipelineResultFileDataOut
     */
    'pipeline_result_id': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultFileDataOut
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultFileDataOut
     */
    'original_file_name': string;
}
/**
 * 
 * @export
 * @interface PipelineResultGroupForMany
 */
export interface PipelineResultGroupForMany {
    /**
     * 
     * @type {Id}
     * @memberof PipelineResultGroupForMany
     */
    '_id': Id;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultGroupForMany
     */
    'pipeline': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultGroupForMany
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultGroupForMany
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultGroupForMany
     */
    'group_type': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultGroupForMany
     */
    'thumb_ref': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultGroupForMany
     */
    'created_by': string;
}
/**
 * 
 * @export
 * @interface PipelineResultOut
 */
export interface PipelineResultOut {
    /**
     * 
     * @type {string}
     * @memberof PipelineResultOut
     */
    'request_log'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof PipelineResultOut
     */
    'machine_result'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof PipelineResultOut
     */
    'result'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof PipelineResultOut
     */
    'result_reviewed'?: boolean | null;
    /**
     * 
     * @type {PipelineResultStatus}
     * @memberof PipelineResultOut
     */
    'status': PipelineResultStatus;
    /**
     * 
     * @type {object}
     * @memberof PipelineResultOut
     */
    'attributes': object;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultOut
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultOut
     */
    'pipeline_id': string;
    /**
     * 
     * @type {object}
     * @memberof PipelineResultOut
     */
    'evaluation_report'?: object;
    /**
     * 
     * @type {FileObject}
     * @memberof PipelineResultOut
     */
    'file_object'?: FileObject | null;
    /**
     * 
     * @type {Array<OCRToken>}
     * @memberof PipelineResultOut
     */
    'ocr_tokens'?: Array<OCRToken> | null;
    /**
     * 
     * @type {ProcessedFileObject}
     * @memberof PipelineResultOut
     */
    'processed_file_object'?: ProcessedFileObject | null;
    /**
     * 
     * @type {ThumbnailFileObject}
     * @memberof PipelineResultOut
     */
    'thumbnail_file_object'?: ThumbnailFileObject | null;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PipelineResultOut
     */
    'updated_at': string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PipelineResultStatus = {
    Pending: 'Pending',
    Completed: 'Completed',
    Failed: 'Failed',
    Rejected: 'Rejected'
} as const;

export type PipelineResultStatus = typeof PipelineResultStatus[keyof typeof PipelineResultStatus];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PipelineSortBy = {
    DateCreated: 'DATE_CREATED',
    DateUpdated: 'DATE_UPDATED',
    NumberOfResults: 'NUMBER_OF_RESULTS',
    Name: 'NAME'
} as const;

export type PipelineSortBy = typeof PipelineSortBy[keyof typeof PipelineSortBy];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const PipelineVariant = {
    Any: 'ANY',
    SufganiyotDocumentParser: 'SUFGANIYOT_DOCUMENT_PARSER',
    DocumentClassifier: 'DOCUMENT_CLASSIFIER',
    ZeroShot: 'ZERO_SHOT'
} as const;

export type PipelineVariant = typeof PipelineVariant[keyof typeof PipelineVariant];


/**
 * 
 * @export
 * @interface PipelinesInner
 */
export interface PipelinesInner {
    /**
     * 
     * @type {PipelineVariant}
     * @memberof PipelinesInner
     */
    'pipeline_variant': PipelineVariant;
    /**
     * 
     * @type {PipelineConfiguration}
     * @memberof PipelinesInner
     */
    'pipeline_configuration': PipelineConfiguration;
    /**
     * 
     * @type {string}
     * @memberof PipelinesInner
     */
    'pipeline_name': string;
    /**
     * 
     * @type {CreatedBy}
     * @memberof PipelinesInner
     */
    'created_by': CreatedBy;
    /**
     * 
     * @type {string}
     * @memberof PipelinesInner
     */
    '_id': string;
    /**
     * 
     * @type {PipelineDeploymentStatus}
     * @memberof PipelinesInner
     */
    'deployment_status': PipelineDeploymentStatus;
    /**
     * 
     * @type {number}
     * @memberof PipelinesInner
     */
    'total_results': number;
    /**
     * 
     * @type {string}
     * @memberof PipelinesInner
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface PremiumRequest
 */
export interface PremiumRequest {
    /**
     * 
     * @type {string}
     * @memberof PremiumRequest
     */
    '_id': string;
    /**
     * 
     * @type {UserOut}
     * @memberof PremiumRequest
     */
    'user': UserOut;
    /**
     * 
     * @type {string}
     * @memberof PremiumRequest
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof PremiumRequest
     */
    'fullfiled_at'?: string | null;
}
/**
 * 
 * @export
 * @interface PremiumRequestStatus
 */
export interface PremiumRequestStatus {
    /**
     * 
     * @type {boolean}
     * @memberof PremiumRequestStatus
     */
    'is_processed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumRequestStatus
     */
    'has_request': boolean;
    /**
     * 
     * @type {PremiumRequest}
     * @memberof PremiumRequestStatus
     */
    'premium_request'?: PremiumRequest;
}
/**
 * 
 * @export
 * @interface ProcessedFileObject
 */
export interface ProcessedFileObject {
    /**
     * 
     * @type {string}
     * @memberof ProcessedFileObject
     */
    '_id': string;
    /**
     * 
     * @type {BucketOut}
     * @memberof ProcessedFileObject
     */
    'bucket': BucketOut;
    /**
     * 
     * @type {string}
     * @memberof ProcessedFileObject
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProcessedFileObject
     */
    'original_file_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProcessedFileObject
     */
    'mime_type': string;
    /**
     * 
     * @type {number}
     * @memberof ProcessedFileObject
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface RabbitMQChannelDetail
 */
export interface RabbitMQChannelDetail {
    /**
     * 
     * @type {string}
     * @memberof RabbitMQChannelDetail
     */
    'connection_name': string;
    /**
     * 
     * @type {string}
     * @memberof RabbitMQChannelDetail
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RabbitMQChannelDetail
     */
    'node': string;
    /**
     * 
     * @type {number}
     * @memberof RabbitMQChannelDetail
     */
    'number': number;
    /**
     * 
     * @type {string}
     * @memberof RabbitMQChannelDetail
     */
    'peer_host': string;
    /**
     * 
     * @type {string}
     * @memberof RabbitMQChannelDetail
     */
    'peer_port': string;
    /**
     * 
     * @type {string}
     * @memberof RabbitMQChannelDetail
     */
    'user': string;
}
/**
 * 
 * @export
 * @interface RabbitMQConsumer
 */
export interface RabbitMQConsumer {
    /**
     * 
     * @type {object}
     * @memberof RabbitMQConsumer
     */
    'arguments': object;
    /**
     * 
     * @type {boolean}
     * @memberof RabbitMQConsumer
     */
    'ack_required': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RabbitMQConsumer
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof RabbitMQConsumer
     */
    'activity_status': string;
    /**
     * 
     * @type {RabbitMQChannelDetail}
     * @memberof RabbitMQConsumer
     */
    'channel_details': RabbitMQChannelDetail;
    /**
     * 
     * @type {string}
     * @memberof RabbitMQConsumer
     */
    'consumer_tag': string;
    /**
     * 
     * @type {boolean}
     * @memberof RabbitMQConsumer
     */
    'exclusive': boolean;
    /**
     * 
     * @type {number}
     * @memberof RabbitMQConsumer
     */
    'prefetch_count': number;
    /**
     * 
     * @type {RabbitMQQueue}
     * @memberof RabbitMQConsumer
     */
    'queue': RabbitMQQueue;
}
/**
 * 
 * @export
 * @interface RabbitMQQueue
 */
export interface RabbitMQQueue {
    /**
     * 
     * @type {string}
     * @memberof RabbitMQQueue
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface RabbitMQQueueDetail
 */
export interface RabbitMQQueueDetail {
    /**
     * 
     * @type {number}
     * @memberof RabbitMQQueueDetail
     */
    'messages_unacknowledged_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof RabbitMQQueueDetail
     */
    'messages_ready_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof RabbitMQQueueDetail
     */
    'messages_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof RabbitMQQueueDetail
     */
    'message_bytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof RabbitMQQueueDetail
     */
    'consumers_count'?: number;
}
/**
 * 
 * @export
 * @interface RabbitMQQueueStat
 */
export interface RabbitMQQueueStat {
    /**
     * 
     * @type {string}
     * @memberof RabbitMQQueueStat
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof RabbitMQQueueStat
     */
    'is_id': boolean;
    /**
     * 
     * @type {Array<RabbitMQConsumer>}
     * @memberof RabbitMQQueueStat
     */
    'consumers': Array<RabbitMQConsumer>;
    /**
     * 
     * @type {RabbitMQQueueDetail}
     * @memberof RabbitMQQueueStat
     */
    'details': RabbitMQQueueDetail;
}
/**
 * 
 * @export
 * @interface RecentPipelineResultOut
 */
export interface RecentPipelineResultOut {
    /**
     * 
     * @type {string}
     * @memberof RecentPipelineResultOut
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof RecentPipelineResultOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof RecentPipelineResultOut
     */
    'updated_at': string;
    /**
     * 
     * @type {PipelineResultStatus}
     * @memberof RecentPipelineResultOut
     */
    'status': PipelineResultStatus;
    /**
     * 
     * @type {object}
     * @memberof RecentPipelineResultOut
     */
    'attributes': object;
    /**
     * 
     * @type {FileObjectOut}
     * @memberof RecentPipelineResultOut
     */
    'file_object': FileObjectOut;
    /**
     * 
     * @type {string}
     * @memberof RecentPipelineResultOut
     */
    'pipeline_id': string;
    /**
     * 
     * @type {string}
     * @memberof RecentPipelineResultOut
     */
    'pipeline_variant': string;
    /**
     * 
     * @type {UserOut}
     * @memberof RecentPipelineResultOut
     */
    'owner': UserOut;
}
/**
 * 
 * @export
 * @interface RecordsInner
 */
export interface RecordsInner {
    /**
     * 
     * @type {string}
     * @memberof RecordsInner
     */
    '_id': string;
    /**
     * 
     * @type {Array<Annotation>}
     * @memberof RecordsInner
     */
    'annotations': Array<Annotation>;
    /**
     * 
     * @type {Array<OCRToken>}
     * @memberof RecordsInner
     */
    'ocr_tokens'?: Array<OCRToken> | null;
    /**
     * 
     * @type {object}
     * @memberof RecordsInner
     */
    'attributes': object;
    /**
     * 
     * @type {string}
     * @memberof RecordsInner
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof RecordsInner
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof RecordsInner
     */
    'annotations_size': number;
    /**
     * 
     * @type {FileObject1}
     * @memberof RecordsInner
     */
    'file_object': FileObject1;
    /**
     * 
     * @type {ThumbnailObject}
     * @memberof RecordsInner
     */
    'thumbnail_object'?: ThumbnailObject | null;
    /**
     * 
     * @type {string}
     * @memberof RecordsInner
     */
    'dataset': string;
    /**
     * 
     * @type {string}
     * @memberof RecordsInner
     */
    'original_file_name': string;
}
/**
 * 
 * @export
 * @interface ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
 */
export interface ResponseCreatePipelineResultPipelinesPipelineIdResultsPost {
    /**
     * 
     * @type {string}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'request_log'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'machine_result'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'result'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'result_reviewed'?: boolean | null;
    /**
     * 
     * @type {PipelineResultStatus}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'status': PipelineResultStatus;
    /**
     * 
     * @type {object}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'attributes': object;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'pipeline_id': string;
    /**
     * 
     * @type {object}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'evaluation_report'?: object;
    /**
     * 
     * @type {FileObject}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'file_object'?: FileObject | null;
    /**
     * 
     * @type {Array<OCRToken>}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'ocr_tokens'?: Array<OCRToken> | null;
    /**
     * 
     * @type {ProcessedFileObject}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'processed_file_object'?: ProcessedFileObject | null;
    /**
     * 
     * @type {ThumbnailFileObject}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'thumbnail_file_object'?: ThumbnailFileObject | null;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof ResponseCreatePipelineResultPipelinesPipelineIdResultsPost
     */
    'pdfuid': string;
}
/**
 * 
 * @export
 * @interface ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost
 */
export interface ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost {
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost
     */
    '_id': string;
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost
     */
    'order_status': WorkOrderStatus;
    /**
     * 
     * @type {WorkOrderType}
     * @memberof ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost
     */
    'order_type': WorkOrderType;
    /**
     * 
     * @type {DocumentClassifierWorkOrderInput}
     * @memberof ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost
     */
    'inputs': DocumentClassifierWorkOrderInput;
    /**
     * 
     * @type {ClassifierDatasetToPipelineWorkerOutput}
     * @memberof ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost
     */
    'outputs': ClassifierDatasetToPipelineWorkerOutput;
    /**
     * 
     * @type {object}
     * @memberof ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost
     */
    'errors': object;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost
     */
    'detail': string;
}
/**
 * 
 * @export
 * @interface ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost
 */
export interface ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost {
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost
     */
    '_id': string;
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost
     */
    'order_status': WorkOrderStatus;
    /**
     * 
     * @type {WorkOrderType}
     * @memberof ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost
     */
    'order_type': WorkOrderType;
    /**
     * 
     * @type {SufganiyotInputWithCustomConfig}
     * @memberof ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost
     */
    'inputs': SufganiyotInputWithCustomConfig;
    /**
     * 
     * @type {DatasetToPipelineWorkerOutput}
     * @memberof ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost
     */
    'outputs': DatasetToPipelineWorkerOutput;
    /**
     * 
     * @type {object}
     * @memberof ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost
     */
    'errors': object;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost
     */
    'detail': string;
}
/**
 * 
 * @export
 * @interface ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost
 */
export interface ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost {
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost
     */
    '_id': string;
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost
     */
    'order_status': WorkOrderStatus;
    /**
     * 
     * @type {WorkOrderType}
     * @memberof ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost
     */
    'order_type': WorkOrderType;
    /**
     * 
     * @type {SufganiyotInputWithCustomConfig}
     * @memberof ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost
     */
    'inputs': SufganiyotInputWithCustomConfig;
    /**
     * 
     * @type {DatasetToPipelineWorkerOutput}
     * @memberof ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost
     */
    'outputs': DatasetToPipelineWorkerOutput;
    /**
     * 
     * @type {object}
     * @memberof ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost
     */
    'errors': object;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost
     */
    'detail': string;
}
/**
 * 
 * @export
 * @interface ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost
 */
export interface ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost {
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost
     */
    '_id': string;
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost
     */
    'order_status': WorkOrderStatus;
    /**
     * 
     * @type {WorkOrderType}
     * @memberof ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost
     */
    'order_type': WorkOrderType;
    /**
     * 
     * @type {ZeroShotInput}
     * @memberof ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost
     */
    'inputs': ZeroShotInput;
    /**
     * 
     * @type {ZeroShotOutput}
     * @memberof ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost
     */
    'outputs': ZeroShotOutput;
    /**
     * 
     * @type {object}
     * @memberof ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost
     */
    'errors': object;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost
     */
    'detail': string;
}
/**
 * 
 * @export
 * @interface ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
 */
export interface ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost {
    /**
     * 
     * @type {string}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    '_id': string;
    /**
     * 
     * @type {Array<Annotation>}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    'annotations': Array<Annotation>;
    /**
     * 
     * @type {Array<OCRToken>}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    'ocr_tokens'?: Array<OCRToken> | null;
    /**
     * 
     * @type {object}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    'attributes': object;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    'annotations_size': number;
    /**
     * 
     * @type {FileObject1}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    'file_object': FileObject1;
    /**
     * 
     * @type {ThumbnailObject}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    'thumbnail_object'?: ThumbnailObject | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    'dataset': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost
     */
    'pdfuid': string;
}
/**
 * 
 * @export
 * @interface ResponsesInner
 */
export interface ResponsesInner {
    /**
     * 
     * @type {string}
     * @memberof ResponsesInner
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInner
     */
    'content': string;
    /**
     * 
     * @type {Author}
     * @memberof ResponsesInner
     */
    'author'?: Author | null;
    /**
     * 
     * @type {string}
     * @memberof ResponsesInner
     */
    'submitted_at': string;
    /**
     * 
     * @type {Attachment1}
     * @memberof ResponsesInner
     */
    'attachment'?: Attachment1 | null;
}
/**
 * 
 * @export
 * @interface ResultsIDlist
 */
export interface ResultsIDlist {
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultsIDlist
     */
    'result_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface SLFactoryWorkerInputBase
 */
export interface SLFactoryWorkerInputBase {
    /**
     * 
     * @type {string}
     * @memberof SLFactoryWorkerInputBase
     */
    'dataset_id': string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const SMLFileVersion = {
    Processed: 'PROCESSED',
    Thumbnail: 'THUMBNAIL',
    Original: 'ORIGINAL'
} as const;

export type SMLFileVersion = typeof SMLFileVersion[keyof typeof SMLFileVersion];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const SMLOCRFileVersion = {
    Thumbnail: 'THUMBNAIL',
    Original: 'ORIGINAL'
} as const;

export type SMLOCRFileVersion = typeof SMLOCRFileVersion[keyof typeof SMLOCRFileVersion];


/**
 * 
 * @export
 * @interface SinglePipelineResultGroup
 */
export interface SinglePipelineResultGroup {
    /**
     * 
     * @type {Id}
     * @memberof SinglePipelineResultGroup
     */
    '_id': Id;
    /**
     * 
     * @type {Array<string>}
     * @memberof SinglePipelineResultGroup
     */
    'result_ids': Array<string>;
    /**
     * 
     * @type {Array<Array<object>>}
     * @memberof SinglePipelineResultGroup
     */
    'results': Array<Array<object>>;
    /**
     * 
     * @type {Array<Array<object>>}
     * @memberof SinglePipelineResultGroup
     */
    'machine_results': Array<Array<object>>;
    /**
     * 
     * @type {string}
     * @memberof SinglePipelineResultGroup
     */
    'pipeline': string;
    /**
     * 
     * @type {string}
     * @memberof SinglePipelineResultGroup
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SinglePipelineResultGroup
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface SmartOCRRecordOut
 */
export interface SmartOCRRecordOut {
    /**
     * 
     * @type {string}
     * @memberof SmartOCRRecordOut
     */
    '_id': string;
    /**
     * 
     * @type {Array<Annotation>}
     * @memberof SmartOCRRecordOut
     */
    'annotations': Array<Annotation>;
    /**
     * 
     * @type {Array<OCRToken>}
     * @memberof SmartOCRRecordOut
     */
    'ocr_tokens'?: Array<OCRToken> | null;
    /**
     * 
     * @type {object}
     * @memberof SmartOCRRecordOut
     */
    'attributes': object;
    /**
     * 
     * @type {string}
     * @memberof SmartOCRRecordOut
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SmartOCRRecordOut
     */
    'updated_at': string;
    /**
     * 
     * @type {number}
     * @memberof SmartOCRRecordOut
     */
    'annotations_size': number;
    /**
     * 
     * @type {FileObject1}
     * @memberof SmartOCRRecordOut
     */
    'file_object': FileObject1;
    /**
     * 
     * @type {ThumbnailObject}
     * @memberof SmartOCRRecordOut
     */
    'thumbnail_object'?: ThumbnailObject | null;
    /**
     * 
     * @type {string}
     * @memberof SmartOCRRecordOut
     */
    'dataset': string;
}
/**
 * 
 * @export
 * @interface StatusMessage
 */
export interface StatusMessage {
    /**
     * 
     * @type {boolean}
     * @memberof StatusMessage
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof StatusMessage
     */
    'extra'?: string | null;
}
/**
 * 
 * @export
 * @interface SufganiyotCustomModelWorkOrderIn
 */
export interface SufganiyotCustomModelWorkOrderIn {
    /**
     * 
     * @type {SufganiyotInputWithCustomConfig}
     * @memberof SufganiyotCustomModelWorkOrderIn
     */
    'inputs': SufganiyotInputWithCustomConfig;
}
/**
 * 
 * @export
 * @interface SufganiyotInputWithCustomConfig
 */
export interface SufganiyotInputWithCustomConfig {
    /**
     * 
     * @type {string}
     * @memberof SufganiyotInputWithCustomConfig
     */
    'dataset_id': string;
    /**
     * 
     * @type {SufganiyotWorkOrderModelConfig}
     * @memberof SufganiyotInputWithCustomConfig
     */
    'custom_model_config'?: SufganiyotWorkOrderModelConfig;
}
/**
 * 
 * @export
 * @interface SufganiyotInputWithoutCustomModelConfig
 */
export interface SufganiyotInputWithoutCustomModelConfig {
    /**
     * 
     * @type {string}
     * @memberof SufganiyotInputWithoutCustomModelConfig
     */
    'dataset_id': string;
}
/**
 * 
 * @export
 * @interface SufganiyotModelConfig
 */
export interface SufganiyotModelConfig {
    /**
     * 
     * @type {SufganiyotModelConfigDataset}
     * @memberof SufganiyotModelConfig
     */
    'dataset': SufganiyotModelConfigDataset;
    /**
     * 
     * @type {SufganiyotModelConfigDonutPreprocessor}
     * @memberof SufganiyotModelConfig
     */
    'donut_preprocessor': SufganiyotModelConfigDonutPreprocessor;
    /**
     * 
     * @type {SufganiyotModelDonutModel}
     * @memberof SufganiyotModelConfig
     */
    'donut_model': SufganiyotModelDonutModel;
}
/**
 * 
 * @export
 * @interface SufganiyotModelConfigDataset
 */
export interface SufganiyotModelConfigDataset {
    /**
     * 
     * @type {string}
     * @memberof SufganiyotModelConfigDataset
     */
    'main_path': string;
    /**
     * 
     * @type {boolean}
     * @memberof SufganiyotModelConfigDataset
     */
    'split': boolean;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelConfigDataset
     */
    'val_size': number;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelConfigDataset
     */
    'test_size': number;
}
/**
 * 
 * @export
 * @interface SufganiyotModelConfigDonutPreprocessor
 */
export interface SufganiyotModelConfigDonutPreprocessor {
    /**
     * 
     * @type {Array<number>}
     * @memberof SufganiyotModelConfigDonutPreprocessor
     */
    'image_shape': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SufganiyotModelConfigDonutPreprocessor
     */
    'save_path': string;
}
/**
 * 
 * @export
 * @interface SufganiyotModelDonutModel
 */
export interface SufganiyotModelDonutModel {
    /**
     * 
     * @type {string}
     * @memberof SufganiyotModelDonutModel
     */
    'preprocessor_load_path': string;
    /**
     * 
     * @type {string}
     * @memberof SufganiyotModelDonutModel
     */
    'device': string;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelDonutModel
     */
    'epochs': number;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelDonutModel
     */
    'batch_size': number;
    /**
     * 
     * @type {boolean}
     * @memberof SufganiyotModelDonutModel
     */
    'fp16': boolean;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelDonutModel
     */
    'es_patience': number;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelDonutModel
     */
    'learning_rate': number;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelDonutModel
     */
    'weight_decay': number;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelDonutModel
     */
    'num_beams': number;
    /**
     * 
     * @type {string}
     * @memberof SufganiyotModelDonutModel
     */
    'save_path': string;
}
/**
 * 
 * @export
 * @interface SufganiyotModelEvaluationReportRow
 */
export interface SufganiyotModelEvaluationReportRow {
    /**
     * 
     * @type {string}
     * @memberof SufganiyotModelEvaluationReportRow
     */
    'doc': string;
    /**
     * 
     * @type {string}
     * @memberof SufganiyotModelEvaluationReportRow
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof SufganiyotModelEvaluationReportRow
     */
    'pred_label': string;
    /**
     * 
     * @type {string}
     * @memberof SufganiyotModelEvaluationReportRow
     */
    'annotation': string;
    /**
     * 
     * @type {string}
     * @memberof SufganiyotModelEvaluationReportRow
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelEvaluationReportRow
     */
    'cmr'?: number;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelEvaluationReportRow
     */
    'levenshtein_ratio': number;
    /**
     * 
     * @type {number}
     * @memberof SufganiyotModelEvaluationReportRow
     */
    'cer'?: number;
}
/**
 * 
 * @export
 * @interface SufganiyotWorkOrderIn
 */
export interface SufganiyotWorkOrderIn {
    /**
     * 
     * @type {SufganiyotInputWithoutCustomModelConfig}
     * @memberof SufganiyotWorkOrderIn
     */
    'inputs': SufganiyotInputWithoutCustomModelConfig;
}
/**
 * 
 * @export
 * @interface SufganiyotWorkOrderModelConfig
 */
export interface SufganiyotWorkOrderModelConfig {
    /**
     * 
     * @type {number}
     * @memberof SufganiyotWorkOrderModelConfig
     */
    'subset'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SufganiyotWorkOrderModelConfig
     */
    'train_val_test_split'?: Array<number>;
}
/**
 * 
 * @export
 * @interface SufganiyotWorkOrderOut
 */
export interface SufganiyotWorkOrderOut {
    /**
     * 
     * @type {string}
     * @memberof SufganiyotWorkOrderOut
     */
    '_id': string;
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof SufganiyotWorkOrderOut
     */
    'order_status': WorkOrderStatus;
    /**
     * 
     * @type {WorkOrderType}
     * @memberof SufganiyotWorkOrderOut
     */
    'order_type': WorkOrderType;
    /**
     * 
     * @type {SufganiyotInputWithCustomConfig}
     * @memberof SufganiyotWorkOrderOut
     */
    'inputs': SufganiyotInputWithCustomConfig;
    /**
     * 
     * @type {DatasetToPipelineWorkerOutput}
     * @memberof SufganiyotWorkOrderOut
     */
    'outputs': DatasetToPipelineWorkerOutput;
    /**
     * 
     * @type {object}
     * @memberof SufganiyotWorkOrderOut
     */
    'errors': object;
    /**
     * 
     * @type {string}
     * @memberof SufganiyotWorkOrderOut
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof SufganiyotWorkOrderOut
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface SufganiyotWorkOrderUpdate
 */
export interface SufganiyotWorkOrderUpdate {
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof SufganiyotWorkOrderUpdate
     */
    'order_status'?: WorkOrderStatus | null;
    /**
     * 
     * @type {Inputs1}
     * @memberof SufganiyotWorkOrderUpdate
     */
    'inputs'?: Inputs1 | null;
    /**
     * 
     * @type {Outputs1}
     * @memberof SufganiyotWorkOrderUpdate
     */
    'outputs'?: Outputs1 | null;
    /**
     * 
     * @type {object}
     * @memberof SufganiyotWorkOrderUpdate
     */
    'errors'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof SufganiyotWorkOrderUpdate
     */
    'created_by'?: string | null;
}
/**
 * 
 * @export
 * @interface ThumbnailFileObject
 */
export interface ThumbnailFileObject {
    /**
     * 
     * @type {string}
     * @memberof ThumbnailFileObject
     */
    '_id': string;
    /**
     * 
     * @type {BucketOut}
     * @memberof ThumbnailFileObject
     */
    'bucket': BucketOut;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailFileObject
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailFileObject
     */
    'original_file_name': string;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailFileObject
     */
    'mime_type': string;
    /**
     * 
     * @type {number}
     * @memberof ThumbnailFileObject
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface ThumbnailObject
 */
export interface ThumbnailObject {
    /**
     * 
     * @type {string}
     * @memberof ThumbnailObject
     */
    '_id': string;
    /**
     * 
     * @type {BucketOut}
     * @memberof ThumbnailObject
     */
    'bucket': BucketOut;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailObject
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailObject
     */
    'original_file_name': string;
    /**
     * 
     * @type {string}
     * @memberof ThumbnailObject
     */
    'mime_type': string;
    /**
     * 
     * @type {number}
     * @memberof ThumbnailObject
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface TicketOut
 */
export interface TicketOut {
    /**
     * 
     * @type {string}
     * @memberof TicketOut
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof TicketOut
     */
    '_id': string;
    /**
     * 
     * @type {number}
     * @memberof TicketOut
     */
    'ticket_no': number;
    /**
     * 
     * @type {Array<ResponsesInner>}
     * @memberof TicketOut
     */
    'responses': Array<ResponsesInner>;
    /**
     * 
     * @type {TicketStatus}
     * @memberof TicketOut
     */
    'status'?: TicketStatus;
    /**
     * 
     * @type {Owner1}
     * @memberof TicketOut
     */
    'owner'?: Owner1 | null;
    /**
     * 
     * @type {ActiveAdmin}
     * @memberof TicketOut
     */
    'active_admin'?: ActiveAdmin | null;
    /**
     * 
     * @type {string}
     * @memberof TicketOut
     */
    'created_at': string;
    /**
     * 
     * @type {Attachment}
     * @memberof TicketOut
     */
    'attachment'?: Attachment | null;
}
/**
 * 
 * @export
 * @interface TicketResponseOut
 */
export interface TicketResponseOut {
    /**
     * 
     * @type {string}
     * @memberof TicketResponseOut
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof TicketResponseOut
     */
    'content': string;
    /**
     * 
     * @type {Author}
     * @memberof TicketResponseOut
     */
    'author'?: Author | null;
    /**
     * 
     * @type {string}
     * @memberof TicketResponseOut
     */
    'submitted_at': string;
    /**
     * 
     * @type {Attachment1}
     * @memberof TicketResponseOut
     */
    'attachment'?: Attachment1 | null;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const TicketStatus = {
    Closed: 'CLOSED',
    Open: 'OPEN'
} as const;

export type TicketStatus = typeof TicketStatus[keyof typeof TicketStatus];


/**
 * 
 * @export
 * @interface UpdateDocumentDataset
 */
export interface UpdateDocumentDataset {
    /**
     * 
     * @type {string}
     * @memberof UpdateDocumentDataset
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDocumentDataset
     */
    'ocr_labels'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDocumentDataset
     */
    'should_compute_ocr'?: boolean;
    /**
     * 
     * @type {DatasetParameters}
     * @memberof UpdateDocumentDataset
     */
    'dataset_parameters'?: DatasetParameters;
    /**
     * 
     * @type {object}
     * @memberof UpdateDocumentDataset
     */
    'attributes'?: object;
}
/**
 * 
 * @export
 * @interface UpdatePipeline
 */
export interface UpdatePipeline {
    /**
     * 
     * @type {PipelineDeploymentStatus}
     * @memberof UpdatePipeline
     */
    'deployment_status'?: PipelineDeploymentStatus | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePipeline
     */
    'pipeline_name'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdatePipelineResult
 */
export interface UpdatePipelineResult {
    /**
     * 
     * @type {string}
     * @memberof UpdatePipelineResult
     */
    'request_log'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof UpdatePipelineResult
     */
    'machine_result'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof UpdatePipelineResult
     */
    'evaluation_report'?: object;
    /**
     * 
     * @type {object}
     * @memberof UpdatePipelineResult
     */
    'result'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof UpdatePipelineResult
     */
    'attributes'?: object | null;
    /**
     * 
     * @type {Array<OCRToken>}
     * @memberof UpdatePipelineResult
     */
    'ocr_tokens'?: Array<OCRToken> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePipelineResult
     */
    'result_reviewed'?: boolean | null;
    /**
     * 
     * @type {PipelineResultStatus}
     * @memberof UpdatePipelineResult
     */
    'status'?: PipelineResultStatus | null;
}
/**
 * 
 * @export
 * @interface UserOut
 */
export interface UserOut {
    /**
     * 
     * @type {string}
     * @memberof UserOut
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserOut
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof UserOut
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof UserOut
     */
    'api_calls': number;
    /**
     * 
     * @type {BusinessModel}
     * @memberof UserOut
     */
    'business_model'?: BusinessModel;
    /**
     * 
     * @type {string}
     * @memberof UserOut
     */
    'organization': string;
    /**
     * 
     * @type {UserRoles}
     * @memberof UserOut
     */
    'role'?: UserRoles;
    /**
     * 
     * @type {boolean}
     * @memberof UserOut
     */
    'verified'?: boolean;
}
/**
 * 
 * @export
 * @interface UserOutWithStat
 */
export interface UserOutWithStat {
    /**
     * 
     * @type {string}
     * @memberof UserOutWithStat
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserOutWithStat
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof UserOutWithStat
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof UserOutWithStat
     */
    'api_calls': number;
    /**
     * 
     * @type {BusinessModel}
     * @memberof UserOutWithStat
     */
    'business_model'?: BusinessModel;
    /**
     * 
     * @type {string}
     * @memberof UserOutWithStat
     */
    'organization': string;
    /**
     * 
     * @type {UserRoles}
     * @memberof UserOutWithStat
     */
    'role'?: UserRoles;
    /**
     * 
     * @type {boolean}
     * @memberof UserOutWithStat
     */
    'verified'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserOutWithStat
     */
    'n_datasets': number;
    /**
     * 
     * @type {number}
     * @memberof UserOutWithStat
     */
    'n_pipelines': number;
    /**
     * 
     * @type {number}
     * @memberof UserOutWithStat
     */
    'n_models': number;
    /**
     * 
     * @type {number}
     * @memberof UserOutWithStat
     */
    'n_classifier_models': number;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const UserRoles = {
    User: 'User',
    Admin: 'Admin',
    Worker: 'Worker'
} as const;

export type UserRoles = typeof UserRoles[keyof typeof UserRoles];


/**
 * 
 * @export
 * @interface UserSignUpIn
 */
export interface UserSignUpIn {
    /**
     * 
     * @type {string}
     * @memberof UserSignUpIn
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof UserSignUpIn
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof UserSignUpIn
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserSignUpIn
     */
    'organization': string;
    /**
     * 
     * @type {UserRoles}
     * @memberof UserSignUpIn
     */
    'role'?: UserRoles;
    /**
     * 
     * @type {string}
     * @memberof UserSignUpIn
     */
    'admin_signup_token'?: string | null;
}
/**
 * 
 * @export
 * @interface UserUpdate
 */
export interface UserUpdate {
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    'organization'?: string | null;
    /**
     * 
     * @type {UserRoles}
     * @memberof UserUpdate
     */
    'role'?: UserRoles | null;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const UsersSortBy = {
    Username: 'USERNAME',
    Email: 'EMAIL',
    DateCreated: 'DATE_CREATED'
} as const;

export type UsersSortBy = typeof UsersSortBy[keyof typeof UsersSortBy];


/**
 * 
 * @export
 * @interface UsersStat
 */
export interface UsersStat {
    /**
     * 
     * @type {number}
     * @memberof UsersStat
     */
    'premium_accounts': number;
    /**
     * 
     * @type {number}
     * @memberof UsersStat
     */
    'verified_users': number;
    /**
     * 
     * @type {number}
     * @memberof UsersStat
     */
    'total_users': number;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const WorkOrderStatus = {
    Processing: 'PROCESSING',
    Failed: 'FAILED',
    Complete: 'COMPLETE'
} as const;

export type WorkOrderStatus = typeof WorkOrderStatus[keyof typeof WorkOrderStatus];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const WorkOrderType = {
    OcrDatasetToPipeline: 'OCR_DATASET_TO_PIPELINE',
    SufganiyotDatasetToPipeline: 'SUFGANIYOT_DATASET_TO_PIPELINE',
    DocumentClassifierDatasetsToPipeline: 'DOCUMENT_CLASSIFIER_DATASETS_TO_PIPELINE',
    ZeroShotPipeline: 'ZERO_SHOT_PIPELINE'
} as const;

export type WorkOrderType = typeof WorkOrderType[keyof typeof WorkOrderType];


/**
 * 
 * @export
 * @interface ZeroPipelineConfiguration
 */
export interface ZeroPipelineConfiguration {
    /**
     * 
     * @type {string}
     * @memberof ZeroPipelineConfiguration
     */
    'prompt_extension': string;
    /**
     * 
     * @type {Array<AppModelsZeroShotQuestionLabel>}
     * @memberof ZeroPipelineConfiguration
     */
    'question_labels': Array<AppModelsZeroShotQuestionLabel>;
    /**
     * 
     * @type {string}
     * @memberof ZeroPipelineConfiguration
     */
    'gpt_model'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ZeroPipelineConfiguration
     */
    'activate_double_shot'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ZeroPipelineConfiguration
     */
    'language'?: string;
}
/**
 * 
 * @export
 * @interface ZeroShotConfig
 */
export interface ZeroShotConfig {
    /**
     * 
     * @type {string}
     * @memberof ZeroShotConfig
     */
    'prompt_extension': string;
    /**
     * 
     * @type {Array<AppModelsZeroShotQuestionLabel>}
     * @memberof ZeroShotConfig
     */
    'question_labels': Array<AppModelsZeroShotQuestionLabel>;
    /**
     * 
     * @type {string}
     * @memberof ZeroShotConfig
     */
    'gpt_model'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ZeroShotConfig
     */
    'activate_double_shot'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ZeroShotConfig
     */
    'language'?: string;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const ZeroShotGPTModelChoice = {
    _35Turbo: 'gpt-3.5-turbo',
    _4: 'gpt-4'
} as const;

export type ZeroShotGPTModelChoice = typeof ZeroShotGPTModelChoice[keyof typeof ZeroShotGPTModelChoice];


/**
 * 
 * @export
 * @interface ZeroShotInput
 */
export interface ZeroShotInput {
    /**
     * 
     * @type {string}
     * @memberof ZeroShotInput
     */
    'pipeline_name': string;
    /**
     * 
     * @type {string}
     * @memberof ZeroShotInput
     */
    'prompt_extension': string;
    /**
     * 
     * @type {ZeroShotGPTModelChoice}
     * @memberof ZeroShotInput
     */
    'gpt_model'?: ZeroShotGPTModelChoice;
    /**
     * 
     * @type {Array<AppRoutersSchemasZeroShotZeroShotQuestionLabel>}
     * @memberof ZeroShotInput
     */
    'question_labels': Array<AppRoutersSchemasZeroShotZeroShotQuestionLabel>;
    /**
     * 
     * @type {string}
     * @memberof ZeroShotInput
     */
    'document_language'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ZeroShotInput
     */
    'activate_double_shot'?: boolean;
}
/**
 * 
 * @export
 * @interface ZeroShotOutput
 */
export interface ZeroShotOutput {
    /**
     * 
     * @type {string}
     * @memberof ZeroShotOutput
     */
    'pipeline_id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ZeroShotOutput
     */
    'elapsed_seconds'?: number | null;
}
/**
 * 
 * @export
 * @interface ZeroShotWorkOrderIn
 */
export interface ZeroShotWorkOrderIn {
    /**
     * 
     * @type {ZeroShotInput}
     * @memberof ZeroShotWorkOrderIn
     */
    'inputs': ZeroShotInput;
}
/**
 * 
 * @export
 * @interface ZeroShotWorkOrderOut
 */
export interface ZeroShotWorkOrderOut {
    /**
     * 
     * @type {string}
     * @memberof ZeroShotWorkOrderOut
     */
    '_id': string;
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof ZeroShotWorkOrderOut
     */
    'order_status': WorkOrderStatus;
    /**
     * 
     * @type {WorkOrderType}
     * @memberof ZeroShotWorkOrderOut
     */
    'order_type': WorkOrderType;
    /**
     * 
     * @type {ZeroShotInput}
     * @memberof ZeroShotWorkOrderOut
     */
    'inputs': ZeroShotInput;
    /**
     * 
     * @type {ZeroShotOutput}
     * @memberof ZeroShotWorkOrderOut
     */
    'outputs': ZeroShotOutput;
    /**
     * 
     * @type {object}
     * @memberof ZeroShotWorkOrderOut
     */
    'errors': object;
    /**
     * 
     * @type {string}
     * @memberof ZeroShotWorkOrderOut
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof ZeroShotWorkOrderOut
     */
    'created_at': string;
}
/**
 * 
 * @export
 * @interface ZeroShotWorkOrderUpdate
 */
export interface ZeroShotWorkOrderUpdate {
    /**
     * 
     * @type {WorkOrderStatus}
     * @memberof ZeroShotWorkOrderUpdate
     */
    'order_status'?: WorkOrderStatus | null;
    /**
     * 
     * @type {Inputs2}
     * @memberof ZeroShotWorkOrderUpdate
     */
    'inputs'?: Inputs2 | null;
    /**
     * 
     * @type {Outputs1}
     * @memberof ZeroShotWorkOrderUpdate
     */
    'outputs'?: Outputs1 | null;
    /**
     * 
     * @type {object}
     * @memberof ZeroShotWorkOrderUpdate
     */
    'errors'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof ZeroShotWorkOrderUpdate
     */
    'created_by'?: string | null;
}

/**
 * DocumentClassifierModelsApi - axios parameter creator
 * @export
 */
export const DocumentClassifierModelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Document Classifier Model
         * @param {string} authorization 
         * @param {string} requestJson 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentClassifierModel: async (authorization: string, requestJson: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createDocumentClassifierModel', 'authorization', authorization)
            // verify required parameter 'requestJson' is not null or undefined
            assertParamExists('createDocumentClassifierModel', 'requestJson', requestJson)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createDocumentClassifierModel', 'file', file)
            const localVarPath = `/document-classifier-models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (requestJson !== undefined) { 
                localVarFormParams.append('request_json', requestJson as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Document Classifier Model By Id
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentClassifierModelById: async (documentClassifierModelId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentClassifierModelId' is not null or undefined
            assertParamExists('deleteDocumentClassifierModelById', 'documentClassifierModelId', documentClassifierModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteDocumentClassifierModelById', 'authorization', authorization)
            const localVarPath = `/document-classifier-models/{document_classifier_model_id}`
                .replace(`{${"document_classifier_model_id"}}`, encodeURIComponent(String(documentClassifierModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * join works here. User ID can be sent to retrieve the pipelines for that particular user.
         * @summary Get Attached Document Classifier Model Pipelines
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachedDocumentClassifierModelPipelines: async (documentClassifierModelId: string, authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentClassifierModelId' is not null or undefined
            assertParamExists('getAttachedDocumentClassifierModelPipelines', 'documentClassifierModelId', documentClassifierModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAttachedDocumentClassifierModelPipelines', 'authorization', authorization)
            const localVarPath = `/document-classifier-models/{document_classifier_model_id}/pipelines`
                .replace(`{${"document_classifier_model_id"}}`, encodeURIComponent(String(documentClassifierModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * join works here
         * @summary Get Document Classifier Model By Id
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentClassifierModelById: async (documentClassifierModelId: string, authorization: string, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentClassifierModelId' is not null or undefined
            assertParamExists('getDocumentClassifierModelById', 'documentClassifierModelId', documentClassifierModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDocumentClassifierModelById', 'authorization', authorization)
            const localVarPath = `/document-classifier-models/{document_classifier_model_id}`
                .replace(`{${"document_classifier_model_id"}}`, encodeURIComponent(String(documentClassifierModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Document Classifier Model File
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentClassifierModelFile: async (documentClassifierModelId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentClassifierModelId' is not null or undefined
            assertParamExists('getDocumentClassifierModelFile', 'documentClassifierModelId', documentClassifierModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDocumentClassifierModelFile', 'authorization', authorization)
            const localVarPath = `/document-classifier-models/{document_classifier_model_id}/download`
                .replace(`{${"document_classifier_model_id"}}`, encodeURIComponent(String(documentClassifierModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * join works here. User ID can be sent to retrieve the models for that particular user.
         * @summary Get Document Classifier Models
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentClassifierModels: async (authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDocumentClassifierModels', 'authorization', authorization)
            const localVarPath = `/document-classifier-models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Document Classifier Model
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {DocumentClassifierModelUpdateSchema} documentClassifierModelUpdateSchema   
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentClassifierModel: async (documentClassifierModelId: string, authorization: string, documentClassifierModelUpdateSchema: DocumentClassifierModelUpdateSchema, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentClassifierModelId' is not null or undefined
            assertParamExists('updateDocumentClassifierModel', 'documentClassifierModelId', documentClassifierModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateDocumentClassifierModel', 'authorization', authorization)
            // verify required parameter 'documentClassifierModelUpdateSchema' is not null or undefined
            assertParamExists('updateDocumentClassifierModel', 'documentClassifierModelUpdateSchema', documentClassifierModelUpdateSchema)
            const localVarPath = `/document-classifier-models/{document_classifier_model_id}`
                .replace(`{${"document_classifier_model_id"}}`, encodeURIComponent(String(documentClassifierModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentClassifierModelUpdateSchema, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Document Classifier Model File
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentClassifierModelFile: async (documentClassifierModelId: string, authorization: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentClassifierModelId' is not null or undefined
            assertParamExists('updateDocumentClassifierModelFile', 'documentClassifierModelId', documentClassifierModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateDocumentClassifierModelFile', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('updateDocumentClassifierModelFile', 'file', file)
            const localVarPath = `/document-classifier-models/{document_classifier_model_id}/file`
                .replace(`{${"document_classifier_model_id"}}`, encodeURIComponent(String(documentClassifierModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentClassifierModelsApi - functional programming interface
 * @export
 */
export const DocumentClassifierModelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentClassifierModelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Document Classifier Model
         * @param {string} authorization 
         * @param {string} requestJson 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDocumentClassifierModel(authorization: string, requestJson: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentClassifierModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDocumentClassifierModel(authorization, requestJson, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Document Classifier Model By Id
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentClassifierModelById(documentClassifierModelId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentClassifierModelById(documentClassifierModelId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * join works here. User ID can be sent to retrieve the pipelines for that particular user.
         * @summary Get Attached Document Classifier Model Pipelines
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachedDocumentClassifierModelPipelines(documentClassifierModelId: string, authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyPipelinesOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachedDocumentClassifierModelPipelines(documentClassifierModelId, authorization, userId, orderBy, orderDirection, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * join works here
         * @summary Get Document Classifier Model By Id
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentClassifierModelById(documentClassifierModelId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentClassifierModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentClassifierModelById(documentClassifierModelId, authorization, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Document Classifier Model File
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentClassifierModelFile(documentClassifierModelId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentClassifierModelFile(documentClassifierModelId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * join works here. User ID can be sent to retrieve the models for that particular user.
         * @summary Get Document Classifier Models
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentClassifierModels(authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyDocumentClassifierModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentClassifierModels(authorization, userId, orderBy, orderDirection, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Document Classifier Model
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {DocumentClassifierModelUpdateSchema} documentClassifierModelUpdateSchema   
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumentClassifierModel(documentClassifierModelId: string, authorization: string, documentClassifierModelUpdateSchema: DocumentClassifierModelUpdateSchema, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocumentClassifierModel(documentClassifierModelId, authorization, documentClassifierModelUpdateSchema, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Document Classifier Model File
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumentClassifierModelFile(documentClassifierModelId: string, authorization: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentClassifierModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocumentClassifierModelFile(documentClassifierModelId, authorization, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentClassifierModelsApi - factory interface
 * @export
 */
export const DocumentClassifierModelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentClassifierModelsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Document Classifier Model
         * @param {string} authorization 
         * @param {string} requestJson 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDocumentClassifierModel(authorization: string, requestJson: string, file: any, options?: any): AxiosPromise<DocumentClassifierModelOut> {
            return localVarFp.createDocumentClassifierModel(authorization, requestJson, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Document Classifier Model By Id
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentClassifierModelById(documentClassifierModelId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteDocumentClassifierModelById(documentClassifierModelId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * join works here. User ID can be sent to retrieve the pipelines for that particular user.
         * @summary Get Attached Document Classifier Model Pipelines
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachedDocumentClassifierModelPipelines(documentClassifierModelId: string, authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyPipelinesOut> {
            return localVarFp.getAttachedDocumentClassifierModelPipelines(documentClassifierModelId, authorization, userId, orderBy, orderDirection, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * join works here
         * @summary Get Document Classifier Model By Id
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentClassifierModelById(documentClassifierModelId: string, authorization: string, join?: boolean, options?: any): AxiosPromise<DocumentClassifierModelOut> {
            return localVarFp.getDocumentClassifierModelById(documentClassifierModelId, authorization, join, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Document Classifier Model File
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentClassifierModelFile(documentClassifierModelId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.getDocumentClassifierModelFile(documentClassifierModelId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * join works here. User ID can be sent to retrieve the models for that particular user.
         * @summary Get Document Classifier Models
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentClassifierModels(authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyDocumentClassifierModelOut> {
            return localVarFp.getDocumentClassifierModels(authorization, userId, orderBy, orderDirection, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Document Classifier Model
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {DocumentClassifierModelUpdateSchema} documentClassifierModelUpdateSchema   
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentClassifierModel(documentClassifierModelId: string, authorization: string, documentClassifierModelUpdateSchema: DocumentClassifierModelUpdateSchema, options?: any): AxiosPromise<any> {
            return localVarFp.updateDocumentClassifierModel(documentClassifierModelId, authorization, documentClassifierModelUpdateSchema, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Document Classifier Model File
         * @param {string} documentClassifierModelId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentClassifierModelFile(documentClassifierModelId: string, authorization: string, file: any, options?: any): AxiosPromise<DocumentClassifierModelOut> {
            return localVarFp.updateDocumentClassifierModelFile(documentClassifierModelId, authorization, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentClassifierModelsApi - object-oriented interface
 * @export
 * @class DocumentClassifierModelsApi
 * @extends {BaseAPI}
 */
export class DocumentClassifierModelsApi extends BaseAPI {
    /**
     * 
     * @summary Create Document Classifier Model
     * @param {string} authorization 
     * @param {string} requestJson 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentClassifierModelsApi
     */
    public createDocumentClassifierModel(authorization: string, requestJson: string, file: any, options?: AxiosRequestConfig) {
        return DocumentClassifierModelsApiFp(this.configuration).createDocumentClassifierModel(authorization, requestJson, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Document Classifier Model By Id
     * @param {string} documentClassifierModelId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentClassifierModelsApi
     */
    public deleteDocumentClassifierModelById(documentClassifierModelId: string, authorization: string, options?: AxiosRequestConfig) {
        return DocumentClassifierModelsApiFp(this.configuration).deleteDocumentClassifierModelById(documentClassifierModelId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * join works here. User ID can be sent to retrieve the pipelines for that particular user.
     * @summary Get Attached Document Classifier Model Pipelines
     * @param {string} documentClassifierModelId 
     * @param {string} authorization 
     * @param {string} [userId] 
     * @param {GenericSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentClassifierModelsApi
     */
    public getAttachedDocumentClassifierModelPipelines(documentClassifierModelId: string, authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return DocumentClassifierModelsApiFp(this.configuration).getAttachedDocumentClassifierModelPipelines(documentClassifierModelId, authorization, userId, orderBy, orderDirection, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * join works here
     * @summary Get Document Classifier Model By Id
     * @param {string} documentClassifierModelId 
     * @param {string} authorization 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentClassifierModelsApi
     */
    public getDocumentClassifierModelById(documentClassifierModelId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig) {
        return DocumentClassifierModelsApiFp(this.configuration).getDocumentClassifierModelById(documentClassifierModelId, authorization, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Document Classifier Model File
     * @param {string} documentClassifierModelId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentClassifierModelsApi
     */
    public getDocumentClassifierModelFile(documentClassifierModelId: string, authorization: string, options?: AxiosRequestConfig) {
        return DocumentClassifierModelsApiFp(this.configuration).getDocumentClassifierModelFile(documentClassifierModelId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * join works here. User ID can be sent to retrieve the models for that particular user.
     * @summary Get Document Classifier Models
     * @param {string} authorization 
     * @param {string} [userId] 
     * @param {GenericSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentClassifierModelsApi
     */
    public getDocumentClassifierModels(authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return DocumentClassifierModelsApiFp(this.configuration).getDocumentClassifierModels(authorization, userId, orderBy, orderDirection, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Document Classifier Model
     * @param {string} documentClassifierModelId 
     * @param {string} authorization 
     * @param {DocumentClassifierModelUpdateSchema} documentClassifierModelUpdateSchema   
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentClassifierModelsApi
     */
    public updateDocumentClassifierModel(documentClassifierModelId: string, authorization: string, documentClassifierModelUpdateSchema: DocumentClassifierModelUpdateSchema, options?: AxiosRequestConfig) {
        return DocumentClassifierModelsApiFp(this.configuration).updateDocumentClassifierModel(documentClassifierModelId, authorization, documentClassifierModelUpdateSchema, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Document Classifier Model File
     * @param {string} documentClassifierModelId 
     * @param {string} authorization 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentClassifierModelsApi
     */
    public updateDocumentClassifierModelFile(documentClassifierModelId: string, authorization: string, file: any, options?: AxiosRequestConfig) {
        return DocumentClassifierModelsApiFp(this.configuration).updateDocumentClassifierModelFile(documentClassifierModelId, authorization, file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentDatasetsApi - axios parameter creator
 * @export
 */
export const DocumentDatasetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Dataset Validity Check
         * @summary Dataset Validity Check
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetValidityCheck: async (datasetId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('datasetValidityCheck', 'datasetId', datasetId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('datasetValidityCheck', 'authorization', authorization)
            const localVarPath = `/datasets/dataset-validity-check/{dataset_id}`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes many dataset
         * @summary Delete Many Datasets
         * @param {string} authorization 
         * @param {Array<string>} [datasetIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyDatasets: async (authorization: string, datasetIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteManyDatasets', 'authorization', authorization)
            const localVarPath = `/datasets/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (datasetIds) {
                localVarQueryParameter['dataset_ids'] = datasetIds;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a dataset
         * @summary Delete Smartocr Dataset
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSmartocrDataset: async (datasetId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('deleteSmartocrDataset', 'datasetId', datasetId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteSmartocrDataset', 'authorization', authorization)
            const localVarPath = `/datasets/{dataset_id}/`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a Pipeline Model record
         * @summary Delete Smartocr Record
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSmartocrRecord: async (datasetId: string, recordId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('deleteSmartocrRecord', 'datasetId', datasetId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('deleteSmartocrRecord', 'recordId', recordId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteSmartocrRecord', 'authorization', authorization)
            const localVarPath = `/datasets/{dataset_id}/record/{record_id}/`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)))
                .replace(`{${"record_id"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Duplicates the dataset with the given name.
         * @summary Duplicate Dataset
         * @param {string} datasetId 
         * @param {string} name 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateDataset: async (datasetId: string, name: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('duplicateDataset', 'datasetId', datasetId)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('duplicateDataset', 'name', name)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('duplicateDataset', 'authorization', authorization)
            const localVarPath = `/datasets/{dataset_id}/duplicate`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the file names of the records in this dataset.
         * @summary File Names By Record Id
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileNamesByRecordId: async (datasetId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('fileNamesByRecordId', 'datasetId', datasetId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('fileNamesByRecordId', 'authorization', authorization)
            const localVarPath = `/dataset/{dataset_id}/file-names-by-record-id`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The endpoint computes and returns the hash of the given dataset.
         * @summary Get Dataset Hash
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetHash: async (datasetId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('getDatasetHash', 'datasetId', datasetId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDatasetHash', 'authorization', authorization)
            const localVarPath = `/datasets/{dataset_id}/hash`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the records for this particular dataset.  * `pivot_date`: specify a date and time (2023-01-21 22:47:51.887399) where records are fetched, before and after it. Use limit to control the number of data returned. Note: `records` will be empty if this value is provided while `next_records` and `previous_records` will be populated with the appropriate records.  Annotation\'s OCR Labels can not be joined.
         * @summary Get Dataset Records
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] 
         * @param {boolean} [addAnnotations] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {DatasetRecordSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [pivotDate] The pivot date to fetch records before and after it, use limit to control the number of records returned. Note skip does not work when this field is given
         * @param {boolean} [joinAnnotationOcrLabel] When &#x60;join_annotation_ocr_label&#x60; is set to &#x60;true&#x60;, annotations will be returned in full with each &#x60;ocr_label&#x60; element returned as JSON object. If set to &#x60;false&#x60;, the &#x60;ocr_label&#x60; will be returned as a string of IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetRecords: async (datasetId: string, authorization: string, addOcrTokens?: boolean, addAnnotations?: boolean, skip?: number, limit?: number, orderBy?: DatasetRecordSortBy, orderDirection?: OrderDirection, pivotDate?: string, joinAnnotationOcrLabel?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('getDatasetRecords', 'datasetId', datasetId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDatasetRecords', 'authorization', authorization)
            const localVarPath = `/datasets/{dataset_id}/records`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (addOcrTokens !== undefined) {
                localVarQueryParameter['add_ocr_tokens'] = addOcrTokens;
            }

            if (addAnnotations !== undefined) {
                localVarQueryParameter['add_annotations'] = addAnnotations;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (pivotDate !== undefined) {
                localVarQueryParameter['pivot_date'] = (pivotDate as any instanceof Date) ?
                    (pivotDate as any).toISOString() :
                    pivotDate;
            }

            if (joinAnnotationOcrLabel !== undefined) {
                localVarQueryParameter['join_annotation_ocr_label'] = joinAnnotationOcrLabel;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the many group for the specified dataset. The response can contain a combination of PDF or Image group
         * @summary Get Many Dataset Record Groups
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {OrderDirection} [orderDirection] 
         * @param {DatasetRecordSortBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyDatasetRecordGroups: async (datasetId: string, authorization: string, skip?: number, limit?: number, orderDirection?: OrderDirection, orderBy?: DatasetRecordSortBy, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('getManyDatasetRecordGroups', 'datasetId', datasetId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getManyDatasetRecordGroups', 'authorization', authorization)
            const localVarPath = `/datasets/{dataset_id}/groups/`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a single group.  A `group_id` is either a `UUID` or regular `ID` being used across the API. `UUID` to indicate it is a PDF Document (multi-page or single page PDF document) and a regular `ID` to indicate it is an image.  If the `group_id` is of the regular `ID`, this means it will only have one element returned as member of the group (`record_ids`). When the `group_id` is a `UUID`, this will contain one or multiple members in the group.  The `group_id` when it is a regular `ID` must be a dataset record else, a `404` HTTP status code will be returned.
         * @summary Get Single Dataset Record Group
         * @param {GroupId} groupId 
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleDatasetRecordGroup: async (groupId: GroupId, datasetId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getSingleDatasetRecordGroup', 'groupId', groupId)
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('getSingleDatasetRecordGroup', 'datasetId', datasetId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSingleDatasetRecordGroup', 'authorization', authorization)
            const localVarPath = `/datasets/{dataset_id}/groups/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches the dataset that corresponds to this ID.  * `join`: if join is false, the OCR labels will only return their IDs  ### Performance Tip: A faster performance is achieved if the join is `false`.
         * @summary Get Smartocr Dataset By Id
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmartocrDatasetById: async (datasetId: string, authorization: string, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('getSmartocrDatasetById', 'datasetId', datasetId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSmartocrDatasetById', 'authorization', authorization)
            const localVarPath = `/datasets/{dataset_id}`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the datasets in the database. The user_id when passed will fetch the resources for that user only, authorized user to perform this request must have the Admin role.
         * @summary Get Smartocr Datasets
         * @param {string} authorization 
         * @param {DocumentDatasetSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [userId] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmartocrDatasets: async (authorization: string, orderBy?: DocumentDatasetSortBy, orderDirection?: OrderDirection, userId?: string, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSmartocrDatasets', 'authorization', authorization)
            const localVarPath = `/datasets/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * join takes effect here
         * @summary Get Smartocr Record Data
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
         * @param {boolean} [join] 
         * @param {boolean} [joinAnnotationOcrLabel] When &#x60;join_annotation_ocr_label&#x60; is set to &#x60;true&#x60;, annotations will be returned in full with each &#x60;ocr_label&#x60; element returned as JSON object. If set to &#x60;false&#x60;, the &#x60;ocr_label&#x60; will be returned as a string of IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmartocrRecordData: async (datasetId: string, recordId: string, authorization: string, addOcrTokens?: boolean, join?: boolean, joinAnnotationOcrLabel?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('getSmartocrRecordData', 'datasetId', datasetId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('getSmartocrRecordData', 'recordId', recordId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSmartocrRecordData', 'authorization', authorization)
            const localVarPath = `/datasets/{dataset_id}/{record_id}`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)))
                .replace(`{${"record_id"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (addOcrTokens !== undefined) {
                localVarQueryParameter['add_ocr_tokens'] = addOcrTokens;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (joinAnnotationOcrLabel !== undefined) {
                localVarQueryParameter['join_annotation_ocr_label'] = joinAnnotationOcrLabel;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the Pipeline Model record\'s file based on the passed version
         * @summary Get Smartocr Record File
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {SMLOCRFileVersion} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmartocrRecordFile: async (datasetId: string, recordId: string, authorization: string, version?: SMLOCRFileVersion, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('getSmartocrRecordFile', 'datasetId', datasetId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('getSmartocrRecordFile', 'recordId', recordId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSmartocrRecordFile', 'authorization', authorization)
            const localVarPath = `/datasets/{dataset_id}/{record_id}/download`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)))
                .replace(`{${"record_id"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a record to the specified dataset
         * @summary Post Ocr Record To Dataset
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {string} annotations 
         * @param {string} attributes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOcrRecordToDataset: async (datasetId: string, authorization: string, file: any, annotations: string, attributes: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('postOcrRecordToDataset', 'datasetId', datasetId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('postOcrRecordToDataset', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('postOcrRecordToDataset', 'file', file)
            // verify required parameter 'annotations' is not null or undefined
            assertParamExists('postOcrRecordToDataset', 'annotations', annotations)
            // verify required parameter 'attributes' is not null or undefined
            assertParamExists('postOcrRecordToDataset', 'attributes', attributes)
            const localVarPath = `/datasets/{dataset_id}/`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (annotations !== undefined) { 
                localVarFormParams.append('annotations', annotations as any);
            }
    
            if (attributes !== undefined) { 
                localVarFormParams.append('attributes', attributes as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new dataset.
         * @summary Post Smartocr Dataset
         * @param {string} authorization 
         * @param {NewDocumentDataset} newDocumentDataset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSmartocrDataset: async (authorization: string, newDocumentDataset: NewDocumentDataset, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('postSmartocrDataset', 'authorization', authorization)
            // verify required parameter 'newDocumentDataset' is not null or undefined
            assertParamExists('postSmartocrDataset', 'newDocumentDataset', newDocumentDataset)
            const localVarPath = `/datasets/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newDocumentDataset, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the dataset specified
         * @summary Update Dataset
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {UpdateDocumentDataset} updateDocumentDataset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDataset: async (datasetId: string, authorization: string, updateDocumentDataset: UpdateDocumentDataset, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('updateDataset', 'datasetId', datasetId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateDataset', 'authorization', authorization)
            // verify required parameter 'updateDocumentDataset' is not null or undefined
            assertParamExists('updateDataset', 'updateDocumentDataset', updateDocumentDataset)
            const localVarPath = `/datasets/{dataset_id}`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDocumentDataset, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the annotations for this record
         * @summary Update Record Annotation
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {Array<Annotation>} annotation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecordAnnotation: async (datasetId: string, recordId: string, authorization: string, annotation: Array<Annotation>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('updateRecordAnnotation', 'datasetId', datasetId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('updateRecordAnnotation', 'recordId', recordId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateRecordAnnotation', 'authorization', authorization)
            // verify required parameter 'annotation' is not null or undefined
            assertParamExists('updateRecordAnnotation', 'annotation', annotation)
            const localVarPath = `/datasets/{dataset_id}/{record_id}/annotations`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)))
                .replace(`{${"record_id"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(annotation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the original image for this ocr record
         * @summary Update Record Ocr Image
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecordOcrImage: async (datasetId: string, recordId: string, authorization: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('updateRecordOcrImage', 'datasetId', datasetId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('updateRecordOcrImage', 'recordId', recordId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateRecordOcrImage', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('updateRecordOcrImage', 'file', file)
            const localVarPath = `/datasets/{dataset_id}/{record_id}/image`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)))
                .replace(`{${"record_id"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the OCR tokens for this record
         * @summary Update Record Ocr Tokens
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {Array<OCRToken>} oCRToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecordOcrTokens: async (datasetId: string, recordId: string, authorization: string, oCRToken: Array<OCRToken>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('updateRecordOcrTokens', 'datasetId', datasetId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('updateRecordOcrTokens', 'recordId', recordId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateRecordOcrTokens', 'authorization', authorization)
            // verify required parameter 'oCRToken' is not null or undefined
            assertParamExists('updateRecordOcrTokens', 'oCRToken', oCRToken)
            const localVarPath = `/datasets/{dataset_id}/{record_id}/ocr-tokens`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)))
                .replace(`{${"record_id"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(oCRToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the thumbnail for this record
         * @summary Upload Thumbnail File To Ocr Record
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadThumbnailFileToOcrRecord: async (datasetId: string, recordId: string, authorization: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'datasetId' is not null or undefined
            assertParamExists('uploadThumbnailFileToOcrRecord', 'datasetId', datasetId)
            // verify required parameter 'recordId' is not null or undefined
            assertParamExists('uploadThumbnailFileToOcrRecord', 'recordId', recordId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadThumbnailFileToOcrRecord', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadThumbnailFileToOcrRecord', 'file', file)
            const localVarPath = `/datasets/{dataset_id}/{record_id}/thumbnail`
                .replace(`{${"dataset_id"}}`, encodeURIComponent(String(datasetId)))
                .replace(`{${"record_id"}}`, encodeURIComponent(String(recordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentDatasetsApi - functional programming interface
 * @export
 */
export const DocumentDatasetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentDatasetsApiAxiosParamCreator(configuration)
    return {
        /**
         * Dataset Validity Check
         * @summary Dataset Validity Check
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async datasetValidityCheck(datasetId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetValidityCheck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.datasetValidityCheck(datasetId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes many dataset
         * @summary Delete Many Datasets
         * @param {string} authorization 
         * @param {Array<string>} [datasetIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteManyDatasets(authorization: string, datasetIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteManyDatasets(authorization, datasetIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes a dataset
         * @summary Delete Smartocr Dataset
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSmartocrDataset(datasetId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSmartocrDataset(datasetId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes a Pipeline Model record
         * @summary Delete Smartocr Record
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSmartocrRecord(datasetId: string, recordId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSmartocrRecord(datasetId, recordId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Duplicates the dataset with the given name.
         * @summary Duplicate Dataset
         * @param {string} datasetId 
         * @param {string} name 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicateDataset(datasetId: string, name: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDatasetOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicateDataset(datasetId, name, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the file names of the records in this dataset.
         * @summary File Names By Record Id
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileNamesByRecordId(datasetId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyDatasetRecordFileDataOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileNamesByRecordId(datasetId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * The endpoint computes and returns the hash of the given dataset.
         * @summary Get Dataset Hash
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetHash(datasetId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetHash(datasetId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the records for this particular dataset.  * `pivot_date`: specify a date and time (2023-01-21 22:47:51.887399) where records are fetched, before and after it. Use limit to control the number of data returned. Note: `records` will be empty if this value is provided while `next_records` and `previous_records` will be populated with the appropriate records.  Annotation\'s OCR Labels can not be joined.
         * @summary Get Dataset Records
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] 
         * @param {boolean} [addAnnotations] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {DatasetRecordSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [pivotDate] The pivot date to fetch records before and after it, use limit to control the number of records returned. Note skip does not work when this field is given
         * @param {boolean} [joinAnnotationOcrLabel] When &#x60;join_annotation_ocr_label&#x60; is set to &#x60;true&#x60;, annotations will be returned in full with each &#x60;ocr_label&#x60; element returned as JSON object. If set to &#x60;false&#x60;, the &#x60;ocr_label&#x60; will be returned as a string of IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDatasetRecords(datasetId: string, authorization: string, addOcrTokens?: boolean, addAnnotations?: boolean, skip?: number, limit?: number, orderBy?: DatasetRecordSortBy, orderDirection?: OrderDirection, pivotDate?: string, joinAnnotationOcrLabel?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManySmartSmartOCRRecordOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDatasetRecords(datasetId, authorization, addOcrTokens, addAnnotations, skip, limit, orderBy, orderDirection, pivotDate, joinAnnotationOcrLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the many group for the specified dataset. The response can contain a combination of PDF or Image group
         * @summary Get Many Dataset Record Groups
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {OrderDirection} [orderDirection] 
         * @param {DatasetRecordSortBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyDatasetRecordGroups(datasetId: string, authorization: string, skip?: number, limit?: number, orderDirection?: OrderDirection, orderBy?: DatasetRecordSortBy, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyDatasetRecordGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyDatasetRecordGroups(datasetId, authorization, skip, limit, orderDirection, orderBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a single group.  A `group_id` is either a `UUID` or regular `ID` being used across the API. `UUID` to indicate it is a PDF Document (multi-page or single page PDF document) and a regular `ID` to indicate it is an image.  If the `group_id` is of the regular `ID`, this means it will only have one element returned as member of the group (`record_ids`). When the `group_id` is a `UUID`, this will contain one or multiple members in the group.  The `group_id` when it is a regular `ID` must be a dataset record else, a `404` HTTP status code will be returned.
         * @summary Get Single Dataset Record Group
         * @param {GroupId} groupId 
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSingleDatasetRecordGroup(groupId: GroupId, datasetId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DatasetRecordGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSingleDatasetRecordGroup(groupId, datasetId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetches the dataset that corresponds to this ID.  * `join`: if join is false, the OCR labels will only return their IDs  ### Performance Tip: A faster performance is achieved if the join is `false`.
         * @summary Get Smartocr Dataset By Id
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmartocrDatasetById(datasetId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDatasetFullOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSmartocrDatasetById(datasetId, authorization, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the datasets in the database. The user_id when passed will fetch the resources for that user only, authorized user to perform this request must have the Admin role.
         * @summary Get Smartocr Datasets
         * @param {string} authorization 
         * @param {DocumentDatasetSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [userId] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmartocrDatasets(authorization: string, orderBy?: DocumentDatasetSortBy, orderDirection?: OrderDirection, userId?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyDocumentDatasetOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSmartocrDatasets(authorization, orderBy, orderDirection, userId, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * join takes effect here
         * @summary Get Smartocr Record Data
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
         * @param {boolean} [join] 
         * @param {boolean} [joinAnnotationOcrLabel] When &#x60;join_annotation_ocr_label&#x60; is set to &#x60;true&#x60;, annotations will be returned in full with each &#x60;ocr_label&#x60; element returned as JSON object. If set to &#x60;false&#x60;, the &#x60;ocr_label&#x60; will be returned as a string of IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmartocrRecordData(datasetId: string, recordId: string, authorization: string, addOcrTokens?: boolean, join?: boolean, joinAnnotationOcrLabel?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmartOCRRecordOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSmartocrRecordData(datasetId, recordId, authorization, addOcrTokens, join, joinAnnotationOcrLabel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the Pipeline Model record\'s file based on the passed version
         * @summary Get Smartocr Record File
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {SMLOCRFileVersion} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSmartocrRecordFile(datasetId: string, recordId: string, authorization: string, version?: SMLOCRFileVersion, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSmartocrRecordFile(datasetId, recordId, authorization, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload a record to the specified dataset
         * @summary Post Ocr Record To Dataset
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {string} annotations 
         * @param {string} attributes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOcrRecordToDataset(datasetId: string, authorization: string, file: any, annotations: string, attributes: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOcrRecordToDataset(datasetId, authorization, file, annotations, attributes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new dataset.
         * @summary Post Smartocr Dataset
         * @param {string} authorization 
         * @param {NewDocumentDataset} newDocumentDataset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSmartocrDataset(authorization: string, newDocumentDataset: NewDocumentDataset, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDatasetOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSmartocrDataset(authorization, newDocumentDataset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the dataset specified
         * @summary Update Dataset
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {UpdateDocumentDataset} updateDocumentDataset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDataset(datasetId: string, authorization: string, updateDocumentDataset: UpdateDocumentDataset, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDatasetOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDataset(datasetId, authorization, updateDocumentDataset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the annotations for this record
         * @summary Update Record Annotation
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {Array<Annotation>} annotation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRecordAnnotation(datasetId: string, recordId: string, authorization: string, annotation: Array<Annotation>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmartOCRRecordOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRecordAnnotation(datasetId, recordId, authorization, annotation, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the original image for this ocr record
         * @summary Update Record Ocr Image
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRecordOcrImage(datasetId: string, recordId: string, authorization: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmartOCRRecordOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRecordOcrImage(datasetId, recordId, authorization, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update the OCR tokens for this record
         * @summary Update Record Ocr Tokens
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {Array<OCRToken>} oCRToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRecordOcrTokens(datasetId: string, recordId: string, authorization: string, oCRToken: Array<OCRToken>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmartOCRRecordOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRecordOcrTokens(datasetId, recordId, authorization, oCRToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the thumbnail for this record
         * @summary Upload Thumbnail File To Ocr Record
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadThumbnailFileToOcrRecord(datasetId: string, recordId: string, authorization: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmartOCRRecordOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadThumbnailFileToOcrRecord(datasetId, recordId, authorization, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentDatasetsApi - factory interface
 * @export
 */
export const DocumentDatasetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentDatasetsApiFp(configuration)
    return {
        /**
         * Dataset Validity Check
         * @summary Dataset Validity Check
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        datasetValidityCheck(datasetId: string, authorization: string, options?: any): AxiosPromise<DatasetValidityCheck> {
            return localVarFp.datasetValidityCheck(datasetId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes many dataset
         * @summary Delete Many Datasets
         * @param {string} authorization 
         * @param {Array<string>} [datasetIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyDatasets(authorization: string, datasetIds?: Array<string>, options?: any): AxiosPromise<any> {
            return localVarFp.deleteManyDatasets(authorization, datasetIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a dataset
         * @summary Delete Smartocr Dataset
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSmartocrDataset(datasetId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteSmartocrDataset(datasetId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a Pipeline Model record
         * @summary Delete Smartocr Record
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSmartocrRecord(datasetId: string, recordId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteSmartocrRecord(datasetId, recordId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Duplicates the dataset with the given name.
         * @summary Duplicate Dataset
         * @param {string} datasetId 
         * @param {string} name 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicateDataset(datasetId: string, name: string, authorization: string, options?: any): AxiosPromise<DocumentDatasetOut> {
            return localVarFp.duplicateDataset(datasetId, name, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the file names of the records in this dataset.
         * @summary File Names By Record Id
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileNamesByRecordId(datasetId: string, authorization: string, options?: any): AxiosPromise<ManyDatasetRecordFileDataOut> {
            return localVarFp.fileNamesByRecordId(datasetId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * The endpoint computes and returns the hash of the given dataset.
         * @summary Get Dataset Hash
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetHash(datasetId: string, authorization: string, options?: any): AxiosPromise<string> {
            return localVarFp.getDatasetHash(datasetId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the records for this particular dataset.  * `pivot_date`: specify a date and time (2023-01-21 22:47:51.887399) where records are fetched, before and after it. Use limit to control the number of data returned. Note: `records` will be empty if this value is provided while `next_records` and `previous_records` will be populated with the appropriate records.  Annotation\'s OCR Labels can not be joined.
         * @summary Get Dataset Records
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] 
         * @param {boolean} [addAnnotations] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {DatasetRecordSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [pivotDate] The pivot date to fetch records before and after it, use limit to control the number of records returned. Note skip does not work when this field is given
         * @param {boolean} [joinAnnotationOcrLabel] When &#x60;join_annotation_ocr_label&#x60; is set to &#x60;true&#x60;, annotations will be returned in full with each &#x60;ocr_label&#x60; element returned as JSON object. If set to &#x60;false&#x60;, the &#x60;ocr_label&#x60; will be returned as a string of IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDatasetRecords(datasetId: string, authorization: string, addOcrTokens?: boolean, addAnnotations?: boolean, skip?: number, limit?: number, orderBy?: DatasetRecordSortBy, orderDirection?: OrderDirection, pivotDate?: string, joinAnnotationOcrLabel?: boolean, options?: any): AxiosPromise<ManySmartSmartOCRRecordOut> {
            return localVarFp.getDatasetRecords(datasetId, authorization, addOcrTokens, addAnnotations, skip, limit, orderBy, orderDirection, pivotDate, joinAnnotationOcrLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the many group for the specified dataset. The response can contain a combination of PDF or Image group
         * @summary Get Many Dataset Record Groups
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {OrderDirection} [orderDirection] 
         * @param {DatasetRecordSortBy} [orderBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyDatasetRecordGroups(datasetId: string, authorization: string, skip?: number, limit?: number, orderDirection?: OrderDirection, orderBy?: DatasetRecordSortBy, options?: any): AxiosPromise<ManyDatasetRecordGroup> {
            return localVarFp.getManyDatasetRecordGroups(datasetId, authorization, skip, limit, orderDirection, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a single group.  A `group_id` is either a `UUID` or regular `ID` being used across the API. `UUID` to indicate it is a PDF Document (multi-page or single page PDF document) and a regular `ID` to indicate it is an image.  If the `group_id` is of the regular `ID`, this means it will only have one element returned as member of the group (`record_ids`). When the `group_id` is a `UUID`, this will contain one or multiple members in the group.  The `group_id` when it is a regular `ID` must be a dataset record else, a `404` HTTP status code will be returned.
         * @summary Get Single Dataset Record Group
         * @param {GroupId} groupId 
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleDatasetRecordGroup(groupId: GroupId, datasetId: string, authorization: string, options?: any): AxiosPromise<DatasetRecordGroup> {
            return localVarFp.getSingleDatasetRecordGroup(groupId, datasetId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches the dataset that corresponds to this ID.  * `join`: if join is false, the OCR labels will only return their IDs  ### Performance Tip: A faster performance is achieved if the join is `false`.
         * @summary Get Smartocr Dataset By Id
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmartocrDatasetById(datasetId: string, authorization: string, join?: boolean, options?: any): AxiosPromise<DocumentDatasetFullOut> {
            return localVarFp.getSmartocrDatasetById(datasetId, authorization, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the datasets in the database. The user_id when passed will fetch the resources for that user only, authorized user to perform this request must have the Admin role.
         * @summary Get Smartocr Datasets
         * @param {string} authorization 
         * @param {DocumentDatasetSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [userId] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmartocrDatasets(authorization: string, orderBy?: DocumentDatasetSortBy, orderDirection?: OrderDirection, userId?: string, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyDocumentDatasetOut> {
            return localVarFp.getSmartocrDatasets(authorization, orderBy, orderDirection, userId, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * join takes effect here
         * @summary Get Smartocr Record Data
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
         * @param {boolean} [join] 
         * @param {boolean} [joinAnnotationOcrLabel] When &#x60;join_annotation_ocr_label&#x60; is set to &#x60;true&#x60;, annotations will be returned in full with each &#x60;ocr_label&#x60; element returned as JSON object. If set to &#x60;false&#x60;, the &#x60;ocr_label&#x60; will be returned as a string of IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmartocrRecordData(datasetId: string, recordId: string, authorization: string, addOcrTokens?: boolean, join?: boolean, joinAnnotationOcrLabel?: boolean, options?: any): AxiosPromise<SmartOCRRecordOut> {
            return localVarFp.getSmartocrRecordData(datasetId, recordId, authorization, addOcrTokens, join, joinAnnotationOcrLabel, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the Pipeline Model record\'s file based on the passed version
         * @summary Get Smartocr Record File
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {SMLOCRFileVersion} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSmartocrRecordFile(datasetId: string, recordId: string, authorization: string, version?: SMLOCRFileVersion, options?: any): AxiosPromise<any> {
            return localVarFp.getSmartocrRecordFile(datasetId, recordId, authorization, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a record to the specified dataset
         * @summary Post Ocr Record To Dataset
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {string} annotations 
         * @param {string} attributes 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOcrRecordToDataset(datasetId: string, authorization: string, file: any, annotations: string, attributes: string, options?: any): AxiosPromise<ResponsePostOcrRecordToDatasetDatasetsDatasetIdPost> {
            return localVarFp.postOcrRecordToDataset(datasetId, authorization, file, annotations, attributes, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new dataset.
         * @summary Post Smartocr Dataset
         * @param {string} authorization 
         * @param {NewDocumentDataset} newDocumentDataset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSmartocrDataset(authorization: string, newDocumentDataset: NewDocumentDataset, options?: any): AxiosPromise<DocumentDatasetOut> {
            return localVarFp.postSmartocrDataset(authorization, newDocumentDataset, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the dataset specified
         * @summary Update Dataset
         * @param {string} datasetId 
         * @param {string} authorization 
         * @param {UpdateDocumentDataset} updateDocumentDataset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDataset(datasetId: string, authorization: string, updateDocumentDataset: UpdateDocumentDataset, options?: any): AxiosPromise<DocumentDatasetOut> {
            return localVarFp.updateDataset(datasetId, authorization, updateDocumentDataset, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the annotations for this record
         * @summary Update Record Annotation
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {Array<Annotation>} annotation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecordAnnotation(datasetId: string, recordId: string, authorization: string, annotation: Array<Annotation>, options?: any): AxiosPromise<SmartOCRRecordOut> {
            return localVarFp.updateRecordAnnotation(datasetId, recordId, authorization, annotation, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the original image for this ocr record
         * @summary Update Record Ocr Image
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecordOcrImage(datasetId: string, recordId: string, authorization: string, file: any, options?: any): AxiosPromise<SmartOCRRecordOut> {
            return localVarFp.updateRecordOcrImage(datasetId, recordId, authorization, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the OCR tokens for this record
         * @summary Update Record Ocr Tokens
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {Array<OCRToken>} oCRToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRecordOcrTokens(datasetId: string, recordId: string, authorization: string, oCRToken: Array<OCRToken>, options?: any): AxiosPromise<SmartOCRRecordOut> {
            return localVarFp.updateRecordOcrTokens(datasetId, recordId, authorization, oCRToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the thumbnail for this record
         * @summary Upload Thumbnail File To Ocr Record
         * @param {string} datasetId 
         * @param {string} recordId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadThumbnailFileToOcrRecord(datasetId: string, recordId: string, authorization: string, file: any, options?: any): AxiosPromise<SmartOCRRecordOut> {
            return localVarFp.uploadThumbnailFileToOcrRecord(datasetId, recordId, authorization, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentDatasetsApi - object-oriented interface
 * @export
 * @class DocumentDatasetsApi
 * @extends {BaseAPI}
 */
export class DocumentDatasetsApi extends BaseAPI {
    /**
     * Dataset Validity Check
     * @summary Dataset Validity Check
     * @param {string} datasetId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public datasetValidityCheck(datasetId: string, authorization: string, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).datasetValidityCheck(datasetId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes many dataset
     * @summary Delete Many Datasets
     * @param {string} authorization 
     * @param {Array<string>} [datasetIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public deleteManyDatasets(authorization: string, datasetIds?: Array<string>, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).deleteManyDatasets(authorization, datasetIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a dataset
     * @summary Delete Smartocr Dataset
     * @param {string} datasetId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public deleteSmartocrDataset(datasetId: string, authorization: string, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).deleteSmartocrDataset(datasetId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a Pipeline Model record
     * @summary Delete Smartocr Record
     * @param {string} datasetId 
     * @param {string} recordId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public deleteSmartocrRecord(datasetId: string, recordId: string, authorization: string, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).deleteSmartocrRecord(datasetId, recordId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Duplicates the dataset with the given name.
     * @summary Duplicate Dataset
     * @param {string} datasetId 
     * @param {string} name 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public duplicateDataset(datasetId: string, name: string, authorization: string, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).duplicateDataset(datasetId, name, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the file names of the records in this dataset.
     * @summary File Names By Record Id
     * @param {string} datasetId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public fileNamesByRecordId(datasetId: string, authorization: string, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).fileNamesByRecordId(datasetId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The endpoint computes and returns the hash of the given dataset.
     * @summary Get Dataset Hash
     * @param {string} datasetId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public getDatasetHash(datasetId: string, authorization: string, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).getDatasetHash(datasetId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the records for this particular dataset.  * `pivot_date`: specify a date and time (2023-01-21 22:47:51.887399) where records are fetched, before and after it. Use limit to control the number of data returned. Note: `records` will be empty if this value is provided while `next_records` and `previous_records` will be populated with the appropriate records.  Annotation\'s OCR Labels can not be joined.
     * @summary Get Dataset Records
     * @param {string} datasetId 
     * @param {string} authorization 
     * @param {boolean} [addOcrTokens] 
     * @param {boolean} [addAnnotations] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {DatasetRecordSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {string} [pivotDate] The pivot date to fetch records before and after it, use limit to control the number of records returned. Note skip does not work when this field is given
     * @param {boolean} [joinAnnotationOcrLabel] When &#x60;join_annotation_ocr_label&#x60; is set to &#x60;true&#x60;, annotations will be returned in full with each &#x60;ocr_label&#x60; element returned as JSON object. If set to &#x60;false&#x60;, the &#x60;ocr_label&#x60; will be returned as a string of IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public getDatasetRecords(datasetId: string, authorization: string, addOcrTokens?: boolean, addAnnotations?: boolean, skip?: number, limit?: number, orderBy?: DatasetRecordSortBy, orderDirection?: OrderDirection, pivotDate?: string, joinAnnotationOcrLabel?: boolean, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).getDatasetRecords(datasetId, authorization, addOcrTokens, addAnnotations, skip, limit, orderBy, orderDirection, pivotDate, joinAnnotationOcrLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the many group for the specified dataset. The response can contain a combination of PDF or Image group
     * @summary Get Many Dataset Record Groups
     * @param {string} datasetId 
     * @param {string} authorization 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {OrderDirection} [orderDirection] 
     * @param {DatasetRecordSortBy} [orderBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public getManyDatasetRecordGroups(datasetId: string, authorization: string, skip?: number, limit?: number, orderDirection?: OrderDirection, orderBy?: DatasetRecordSortBy, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).getManyDatasetRecordGroups(datasetId, authorization, skip, limit, orderDirection, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a single group.  A `group_id` is either a `UUID` or regular `ID` being used across the API. `UUID` to indicate it is a PDF Document (multi-page or single page PDF document) and a regular `ID` to indicate it is an image.  If the `group_id` is of the regular `ID`, this means it will only have one element returned as member of the group (`record_ids`). When the `group_id` is a `UUID`, this will contain one or multiple members in the group.  The `group_id` when it is a regular `ID` must be a dataset record else, a `404` HTTP status code will be returned.
     * @summary Get Single Dataset Record Group
     * @param {GroupId} groupId 
     * @param {string} datasetId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public getSingleDatasetRecordGroup(groupId: GroupId, datasetId: string, authorization: string, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).getSingleDatasetRecordGroup(groupId, datasetId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches the dataset that corresponds to this ID.  * `join`: if join is false, the OCR labels will only return their IDs  ### Performance Tip: A faster performance is achieved if the join is `false`.
     * @summary Get Smartocr Dataset By Id
     * @param {string} datasetId 
     * @param {string} authorization 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public getSmartocrDatasetById(datasetId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).getSmartocrDatasetById(datasetId, authorization, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the datasets in the database. The user_id when passed will fetch the resources for that user only, authorized user to perform this request must have the Admin role.
     * @summary Get Smartocr Datasets
     * @param {string} authorization 
     * @param {DocumentDatasetSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {string} [userId] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public getSmartocrDatasets(authorization: string, orderBy?: DocumentDatasetSortBy, orderDirection?: OrderDirection, userId?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).getSmartocrDatasets(authorization, orderBy, orderDirection, userId, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * join takes effect here
     * @summary Get Smartocr Record Data
     * @param {string} datasetId 
     * @param {string} recordId 
     * @param {string} authorization 
     * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
     * @param {boolean} [join] 
     * @param {boolean} [joinAnnotationOcrLabel] When &#x60;join_annotation_ocr_label&#x60; is set to &#x60;true&#x60;, annotations will be returned in full with each &#x60;ocr_label&#x60; element returned as JSON object. If set to &#x60;false&#x60;, the &#x60;ocr_label&#x60; will be returned as a string of IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public getSmartocrRecordData(datasetId: string, recordId: string, authorization: string, addOcrTokens?: boolean, join?: boolean, joinAnnotationOcrLabel?: boolean, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).getSmartocrRecordData(datasetId, recordId, authorization, addOcrTokens, join, joinAnnotationOcrLabel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the Pipeline Model record\'s file based on the passed version
     * @summary Get Smartocr Record File
     * @param {string} datasetId 
     * @param {string} recordId 
     * @param {string} authorization 
     * @param {SMLOCRFileVersion} [version] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public getSmartocrRecordFile(datasetId: string, recordId: string, authorization: string, version?: SMLOCRFileVersion, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).getSmartocrRecordFile(datasetId, recordId, authorization, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a record to the specified dataset
     * @summary Post Ocr Record To Dataset
     * @param {string} datasetId 
     * @param {string} authorization 
     * @param {any} file 
     * @param {string} annotations 
     * @param {string} attributes 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public postOcrRecordToDataset(datasetId: string, authorization: string, file: any, annotations: string, attributes: string, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).postOcrRecordToDataset(datasetId, authorization, file, annotations, attributes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new dataset.
     * @summary Post Smartocr Dataset
     * @param {string} authorization 
     * @param {NewDocumentDataset} newDocumentDataset 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public postSmartocrDataset(authorization: string, newDocumentDataset: NewDocumentDataset, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).postSmartocrDataset(authorization, newDocumentDataset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the dataset specified
     * @summary Update Dataset
     * @param {string} datasetId 
     * @param {string} authorization 
     * @param {UpdateDocumentDataset} updateDocumentDataset 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public updateDataset(datasetId: string, authorization: string, updateDocumentDataset: UpdateDocumentDataset, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).updateDataset(datasetId, authorization, updateDocumentDataset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the annotations for this record
     * @summary Update Record Annotation
     * @param {string} datasetId 
     * @param {string} recordId 
     * @param {string} authorization 
     * @param {Array<Annotation>} annotation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public updateRecordAnnotation(datasetId: string, recordId: string, authorization: string, annotation: Array<Annotation>, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).updateRecordAnnotation(datasetId, recordId, authorization, annotation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the original image for this ocr record
     * @summary Update Record Ocr Image
     * @param {string} datasetId 
     * @param {string} recordId 
     * @param {string} authorization 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public updateRecordOcrImage(datasetId: string, recordId: string, authorization: string, file: any, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).updateRecordOcrImage(datasetId, recordId, authorization, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the OCR tokens for this record
     * @summary Update Record Ocr Tokens
     * @param {string} datasetId 
     * @param {string} recordId 
     * @param {string} authorization 
     * @param {Array<OCRToken>} oCRToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public updateRecordOcrTokens(datasetId: string, recordId: string, authorization: string, oCRToken: Array<OCRToken>, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).updateRecordOcrTokens(datasetId, recordId, authorization, oCRToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the thumbnail for this record
     * @summary Upload Thumbnail File To Ocr Record
     * @param {string} datasetId 
     * @param {string} recordId 
     * @param {string} authorization 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentDatasetsApi
     */
    public uploadThumbnailFileToOcrRecord(datasetId: string, recordId: string, authorization: string, file: any, options?: AxiosRequestConfig) {
        return DocumentDatasetsApiFp(this.configuration).uploadThumbnailFileToOcrRecord(datasetId, recordId, authorization, file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HealthCheckApi - axios parameter creator
 * @export
 */
export const HealthCheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health Checks on MongoDB, Backend Storage and RabbitMQ. It could take up to 20 seconds before all the health checks is complete, this is due to if the RabbitMQ is not up and running as soon as possible. The HEALTH_CHECK_AUTHORIZATION_CODE must be provided.
         * @summary Check Health
         * @param {string} authorization 
         * @param {string} [authorizationCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth: async (authorization: string, authorizationCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('checkHealth', 'authorization', authorization)
            const localVarPath = `/health-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorizationCode !== undefined) {
                localVarQueryParameter['authorization_code'] = authorizationCode;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthCheckApi - functional programming interface
 * @export
 */
export const HealthCheckApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthCheckApiAxiosParamCreator(configuration)
    return {
        /**
         * Health Checks on MongoDB, Backend Storage and RabbitMQ. It could take up to 20 seconds before all the health checks is complete, this is due to if the RabbitMQ is not up and running as soon as possible. The HEALTH_CHECK_AUTHORIZATION_CODE must be provided.
         * @summary Check Health
         * @param {string} authorization 
         * @param {string} [authorizationCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkHealth(authorization: string, authorizationCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkHealth(authorization, authorizationCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthCheckApi - factory interface
 * @export
 */
export const HealthCheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthCheckApiFp(configuration)
    return {
        /**
         * Health Checks on MongoDB, Backend Storage and RabbitMQ. It could take up to 20 seconds before all the health checks is complete, this is due to if the RabbitMQ is not up and running as soon as possible. The HEALTH_CHECK_AUTHORIZATION_CODE must be provided.
         * @summary Check Health
         * @param {string} authorization 
         * @param {string} [authorizationCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkHealth(authorization: string, authorizationCode?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.checkHealth(authorization, authorizationCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthCheckApi - object-oriented interface
 * @export
 * @class HealthCheckApi
 * @extends {BaseAPI}
 */
export class HealthCheckApi extends BaseAPI {
    /**
     * Health Checks on MongoDB, Backend Storage and RabbitMQ. It could take up to 20 seconds before all the health checks is complete, this is due to if the RabbitMQ is not up and running as soon as possible. The HEALTH_CHECK_AUTHORIZATION_CODE must be provided.
     * @summary Check Health
     * @param {string} authorization 
     * @param {string} [authorizationCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckApi
     */
    public checkHealth(authorization: string, authorizationCode?: string, options?: AxiosRequestConfig) {
        return HealthCheckApiFp(this.configuration).checkHealth(authorization, authorizationCode, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MessagingQueueStatsApi - axios parameter creator
 * @export
 */
export const MessagingQueueStatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the stat and consumers for a particular queue. Only open to the Smart Layers\' admin and worker
         * @summary Get Queues Stat
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuesStat: async (authorization: string, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getQueuesStat', 'authorization', authorization)
            const localVarPath = `/queues`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the stat and consumers for all running queues. Only open to the Smart Layers\' admin and worker. If you seek to get stat for a pipeline, prefix the pipeline ID with a \'pipeline-\', e.g. pipeline-6019060393822192
         * @summary Get Queues Stat By Id Or Name
         * @param {string} queueNameOrPipelineId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuesStatByIdOrName: async (queueNameOrPipelineId: string, authorization: string, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queueNameOrPipelineId' is not null or undefined
            assertParamExists('getQueuesStatByIdOrName', 'queueNameOrPipelineId', queueNameOrPipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getQueuesStatByIdOrName', 'authorization', authorization)
            const localVarPath = `/queues/{queue_name_or_pipeline_id}`
                .replace(`{${"queue_name_or_pipeline_id"}}`, encodeURIComponent(String(queueNameOrPipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagingQueueStatsApi - functional programming interface
 * @export
 */
export const MessagingQueueStatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagingQueueStatsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the stat and consumers for a particular queue. Only open to the Smart Layers\' admin and worker
         * @summary Get Queues Stat
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueuesStat(authorization: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyRabbitMQQueueStat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQueuesStat(authorization, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the stat and consumers for all running queues. Only open to the Smart Layers\' admin and worker. If you seek to get stat for a pipeline, prefix the pipeline ID with a \'pipeline-\', e.g. pipeline-6019060393822192
         * @summary Get Queues Stat By Id Or Name
         * @param {string} queueNameOrPipelineId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQueuesStatByIdOrName(queueNameOrPipelineId: string, authorization: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RabbitMQQueueStat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQueuesStatByIdOrName(queueNameOrPipelineId, authorization, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MessagingQueueStatsApi - factory interface
 * @export
 */
export const MessagingQueueStatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagingQueueStatsApiFp(configuration)
    return {
        /**
         * Retrieve the stat and consumers for a particular queue. Only open to the Smart Layers\' admin and worker
         * @summary Get Queues Stat
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuesStat(authorization: string, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyRabbitMQQueueStat> {
            return localVarFp.getQueuesStat(authorization, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the stat and consumers for all running queues. Only open to the Smart Layers\' admin and worker. If you seek to get stat for a pipeline, prefix the pipeline ID with a \'pipeline-\', e.g. pipeline-6019060393822192
         * @summary Get Queues Stat By Id Or Name
         * @param {string} queueNameOrPipelineId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQueuesStatByIdOrName(queueNameOrPipelineId: string, authorization: string, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<RabbitMQQueueStat> {
            return localVarFp.getQueuesStatByIdOrName(queueNameOrPipelineId, authorization, skip, limit, join, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessagingQueueStatsApi - object-oriented interface
 * @export
 * @class MessagingQueueStatsApi
 * @extends {BaseAPI}
 */
export class MessagingQueueStatsApi extends BaseAPI {
    /**
     * Retrieve the stat and consumers for a particular queue. Only open to the Smart Layers\' admin and worker
     * @summary Get Queues Stat
     * @param {string} authorization 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingQueueStatsApi
     */
    public getQueuesStat(authorization: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return MessagingQueueStatsApiFp(this.configuration).getQueuesStat(authorization, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the stat and consumers for all running queues. Only open to the Smart Layers\' admin and worker. If you seek to get stat for a pipeline, prefix the pipeline ID with a \'pipeline-\', e.g. pipeline-6019060393822192
     * @summary Get Queues Stat By Id Or Name
     * @param {string} queueNameOrPipelineId 
     * @param {string} authorization 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagingQueueStatsApi
     */
    public getQueuesStatByIdOrName(queueNameOrPipelineId: string, authorization: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return MessagingQueueStatsApiFp(this.configuration).getQueuesStatByIdOrName(queueNameOrPipelineId, authorization, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MiscApi - axios parameter creator
 * @export
 */
export const MiscApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the values of the constrains in the API
         * @summary Get Api Settings
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettings: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getApiSettings', 'authorization', authorization)
            const localVarPath = `/api-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MiscApi - functional programming interface
 * @export
 */
export const MiscApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MiscApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the values of the constrains in the API
         * @summary Get Api Settings
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiSettings(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APISettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiSettings(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MiscApi - factory interface
 * @export
 */
export const MiscApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MiscApiFp(configuration)
    return {
        /**
         * Returns the values of the constrains in the API
         * @summary Get Api Settings
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiSettings(authorization: string, options?: any): AxiosPromise<APISettings> {
            return localVarFp.getApiSettings(authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MiscApi - object-oriented interface
 * @export
 * @class MiscApi
 * @extends {BaseAPI}
 */
export class MiscApi extends BaseAPI {
    /**
     * Returns the values of the constrains in the API
     * @summary Get Api Settings
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MiscApi
     */
    public getApiSettings(authorization: string, options?: AxiosRequestConfig) {
        return MiscApiFp(this.configuration).getApiSettings(authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new notification.
         * @summary Create Notification
         * @param {string} authorization 
         * @param {NotificationCreate} notificationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification: async (authorization: string, notificationCreate: NotificationCreate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createNotification', 'authorization', authorization)
            // verify required parameter 'notificationCreate' is not null or undefined
            assertParamExists('createNotification', 'notificationCreate', notificationCreate)
            const localVarPath = `/notifications/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a list of notification of this user. The data can be order only by the created at.
         * @summary Get Notification
         * @param {string} notificationId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification: async (notificationId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('getNotification', 'notificationId', notificationId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getNotification', 'authorization', authorization)
            const localVarPath = `/notifications/{notification_id}`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a list of notification of this user. The data can be order only by the created at. Only an admin can view the notifications of another user. The end_date should be a day ahead of the inteded date, e.g. getting notifiations between 2023-01-19 and 2023-01-21, the start_date would be `2023-01-19` and the end_date would be `2023-01-22`. Ensure you take care of date that when padded by a day, it will fall in to a new month.
         * @summary Get Notifications
         * @param {string} authorization 
         * @param {NotificationType} [notificationType] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [userId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (authorization: string, notificationType?: NotificationType, orderDirection?: OrderDirection, userId?: string, startDate?: string, endDate?: string, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getNotifications', 'authorization', authorization)
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (notificationType !== undefined) {
                localVarQueryParameter['notification_type'] = notificationType;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substr(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substr(0,10) :
                    endDate;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new notification.
         * @summary Mark As Seen
         * @param {string} notificationId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsSeen: async (notificationId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('markAsSeen', 'notificationId', notificationId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('markAsSeen', 'authorization', authorization)
            const localVarPath = `/notifications/{notification_id}/mark-has-seen`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new notification.
         * @summary Create Notification
         * @param {string} authorization 
         * @param {NotificationCreate} notificationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNotification(authorization: string, notificationCreate: NotificationCreate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNotification(authorization, notificationCreate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a list of notification of this user. The data can be order only by the created at.
         * @summary Get Notification
         * @param {string} notificationId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotification(notificationId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotification(notificationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a list of notification of this user. The data can be order only by the created at. Only an admin can view the notifications of another user. The end_date should be a day ahead of the inteded date, e.g. getting notifiations between 2023-01-19 and 2023-01-21, the start_date would be `2023-01-19` and the end_date would be `2023-01-22`. Ensure you take care of date that when padded by a day, it will fall in to a new month.
         * @summary Get Notifications
         * @param {string} authorization 
         * @param {NotificationType} [notificationType] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [userId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(authorization: string, notificationType?: NotificationType, orderDirection?: OrderDirection, userId?: string, startDate?: string, endDate?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyNotificationsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(authorization, notificationType, orderDirection, userId, startDate, endDate, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new notification.
         * @summary Mark As Seen
         * @param {string} notificationId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAsSeen(notificationId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAsSeen(notificationId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * Creates a new notification.
         * @summary Create Notification
         * @param {string} authorization 
         * @param {NotificationCreate} notificationCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(authorization: string, notificationCreate: NotificationCreate, options?: any): AxiosPromise<NotificationOut> {
            return localVarFp.createNotification(authorization, notificationCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a list of notification of this user. The data can be order only by the created at.
         * @summary Get Notification
         * @param {string} notificationId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(notificationId: string, authorization: string, options?: any): AxiosPromise<NotificationOut> {
            return localVarFp.getNotification(notificationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a list of notification of this user. The data can be order only by the created at. Only an admin can view the notifications of another user. The end_date should be a day ahead of the inteded date, e.g. getting notifiations between 2023-01-19 and 2023-01-21, the start_date would be `2023-01-19` and the end_date would be `2023-01-22`. Ensure you take care of date that when padded by a day, it will fall in to a new month.
         * @summary Get Notifications
         * @param {string} authorization 
         * @param {NotificationType} [notificationType] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [userId] 
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(authorization: string, notificationType?: NotificationType, orderDirection?: OrderDirection, userId?: string, startDate?: string, endDate?: string, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyNotificationsOut> {
            return localVarFp.getNotifications(authorization, notificationType, orderDirection, userId, startDate, endDate, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new notification.
         * @summary Mark As Seen
         * @param {string} notificationId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAsSeen(notificationId: string, authorization: string, options?: any): AxiosPromise<NotificationOut> {
            return localVarFp.markAsSeen(notificationId, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * Creates a new notification.
     * @summary Create Notification
     * @param {string} authorization 
     * @param {NotificationCreate} notificationCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public createNotification(authorization: string, notificationCreate: NotificationCreate, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).createNotification(authorization, notificationCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a list of notification of this user. The data can be order only by the created at.
     * @summary Get Notification
     * @param {string} notificationId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotification(notificationId: string, authorization: string, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotification(notificationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a list of notification of this user. The data can be order only by the created at. Only an admin can view the notifications of another user. The end_date should be a day ahead of the inteded date, e.g. getting notifiations between 2023-01-19 and 2023-01-21, the start_date would be `2023-01-19` and the end_date would be `2023-01-22`. Ensure you take care of date that when padded by a day, it will fall in to a new month.
     * @summary Get Notifications
     * @param {string} authorization 
     * @param {NotificationType} [notificationType] 
     * @param {OrderDirection} [orderDirection] 
     * @param {string} [userId] 
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotifications(authorization: string, notificationType?: NotificationType, orderDirection?: OrderDirection, userId?: string, startDate?: string, endDate?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotifications(authorization, notificationType, orderDirection, userId, startDate, endDate, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new notification.
     * @summary Mark As Seen
     * @param {string} notificationId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public markAsSeen(notificationId: string, authorization: string, options?: AxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markAsSeen(notificationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OCRLabelsApi - axios parameter creator
 * @export
 */
export const OCRLabelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new ocr label for this user. Returns a 409 (Conflict) if there is an OCR label with the name given.
         * @summary Create Ocr Label
         * @param {string} authorization 
         * @param {OCRLabelBase} oCRLabelBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOcrLabel: async (authorization: string, oCRLabelBase: OCRLabelBase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createOcrLabel', 'authorization', authorization)
            // verify required parameter 'oCRLabelBase' is not null or undefined
            assertParamExists('createOcrLabel', 'oCRLabelBase', oCRLabelBase)
            const localVarPath = `/ocr-labels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(oCRLabelBase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the specified ocr label
         * @summary Delete Ocr Label
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOcrLabel: async (ocrLabelId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ocrLabelId' is not null or undefined
            assertParamExists('deleteOcrLabel', 'ocrLabelId', ocrLabelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteOcrLabel', 'authorization', authorization)
            const localVarPath = `/ocr-labels/{ocr_label_id}`
                .replace(`{${"ocr_label_id"}}`, encodeURIComponent(String(ocrLabelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets all ocr labels. Join does not work here
         * @summary Get Many Ocr Labels
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyOcrLabels: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getManyOcrLabels', 'authorization', authorization)
            const localVarPath = `/ocr-labels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the specified ocr label
         * @summary Get Ocr Label
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcrLabel: async (ocrLabelId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ocrLabelId' is not null or undefined
            assertParamExists('getOcrLabel', 'ocrLabelId', ocrLabelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getOcrLabel', 'authorization', authorization)
            const localVarPath = `/ocr-labels/{ocr_label_id}`
                .replace(`{${"ocr_label_id"}}`, encodeURIComponent(String(ocrLabelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns True if the given OCR Label is being used in any annotation. False otherwise.
         * @summary Is Ocr Label Being Used
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isOcrLabelBeingUsed: async (ocrLabelId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ocrLabelId' is not null or undefined
            assertParamExists('isOcrLabelBeingUsed', 'ocrLabelId', ocrLabelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('isOcrLabelBeingUsed', 'authorization', authorization)
            const localVarPath = `/ocr-labels/is-used/{ocr_label_id}`
                .replace(`{${"ocr_label_id"}}`, encodeURIComponent(String(ocrLabelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the specified ocr label
         * @summary Update Ocr Label
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {OCRLabelEdit} oCRLabelEdit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOcrLabel: async (ocrLabelId: string, authorization: string, oCRLabelEdit: OCRLabelEdit, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ocrLabelId' is not null or undefined
            assertParamExists('updateOcrLabel', 'ocrLabelId', ocrLabelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateOcrLabel', 'authorization', authorization)
            // verify required parameter 'oCRLabelEdit' is not null or undefined
            assertParamExists('updateOcrLabel', 'oCRLabelEdit', oCRLabelEdit)
            const localVarPath = `/ocr-labels/{ocr_label_id}`
                .replace(`{${"ocr_label_id"}}`, encodeURIComponent(String(ocrLabelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(oCRLabelEdit, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OCRLabelsApi - functional programming interface
 * @export
 */
export const OCRLabelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OCRLabelsApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new ocr label for this user. Returns a 409 (Conflict) if there is an OCR label with the name given.
         * @summary Create Ocr Label
         * @param {string} authorization 
         * @param {OCRLabelBase} oCRLabelBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOcrLabel(authorization: string, oCRLabelBase: OCRLabelBase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OCRLabelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOcrLabel(authorization, oCRLabelBase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes the specified ocr label
         * @summary Delete Ocr Label
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOcrLabel(ocrLabelId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OCRLabelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOcrLabel(ocrLabelId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets all ocr labels. Join does not work here
         * @summary Get Many Ocr Labels
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyOcrLabels(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyOCRLabelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyOcrLabels(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the specified ocr label
         * @summary Get Ocr Label
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcrLabel(ocrLabelId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OCRLabelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcrLabel(ocrLabelId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns True if the given OCR Label is being used in any annotation. False otherwise.
         * @summary Is Ocr Label Being Used
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isOcrLabelBeingUsed(ocrLabelId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isOcrLabelBeingUsed(ocrLabelId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the specified ocr label
         * @summary Update Ocr Label
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {OCRLabelEdit} oCRLabelEdit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOcrLabel(ocrLabelId: string, authorization: string, oCRLabelEdit: OCRLabelEdit, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OCRLabelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOcrLabel(ocrLabelId, authorization, oCRLabelEdit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OCRLabelsApi - factory interface
 * @export
 */
export const OCRLabelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OCRLabelsApiFp(configuration)
    return {
        /**
         * Creates a new ocr label for this user. Returns a 409 (Conflict) if there is an OCR label with the name given.
         * @summary Create Ocr Label
         * @param {string} authorization 
         * @param {OCRLabelBase} oCRLabelBase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOcrLabel(authorization: string, oCRLabelBase: OCRLabelBase, options?: any): AxiosPromise<OCRLabelOut> {
            return localVarFp.createOcrLabel(authorization, oCRLabelBase, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the specified ocr label
         * @summary Delete Ocr Label
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOcrLabel(ocrLabelId: string, authorization: string, options?: any): AxiosPromise<OCRLabelOut> {
            return localVarFp.deleteOcrLabel(ocrLabelId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets all ocr labels. Join does not work here
         * @summary Get Many Ocr Labels
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyOcrLabels(authorization: string, options?: any): AxiosPromise<ManyOCRLabelOut> {
            return localVarFp.getManyOcrLabels(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the specified ocr label
         * @summary Get Ocr Label
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcrLabel(ocrLabelId: string, authorization: string, options?: any): AxiosPromise<OCRLabelOut> {
            return localVarFp.getOcrLabel(ocrLabelId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns True if the given OCR Label is being used in any annotation. False otherwise.
         * @summary Is Ocr Label Being Used
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isOcrLabelBeingUsed(ocrLabelId: string, authorization: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.isOcrLabelBeingUsed(ocrLabelId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the specified ocr label
         * @summary Update Ocr Label
         * @param {string} ocrLabelId 
         * @param {string} authorization 
         * @param {OCRLabelEdit} oCRLabelEdit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOcrLabel(ocrLabelId: string, authorization: string, oCRLabelEdit: OCRLabelEdit, options?: any): AxiosPromise<OCRLabelOut> {
            return localVarFp.updateOcrLabel(ocrLabelId, authorization, oCRLabelEdit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OCRLabelsApi - object-oriented interface
 * @export
 * @class OCRLabelsApi
 * @extends {BaseAPI}
 */
export class OCRLabelsApi extends BaseAPI {
    /**
     * Creates a new ocr label for this user. Returns a 409 (Conflict) if there is an OCR label with the name given.
     * @summary Create Ocr Label
     * @param {string} authorization 
     * @param {OCRLabelBase} oCRLabelBase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OCRLabelsApi
     */
    public createOcrLabel(authorization: string, oCRLabelBase: OCRLabelBase, options?: AxiosRequestConfig) {
        return OCRLabelsApiFp(this.configuration).createOcrLabel(authorization, oCRLabelBase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the specified ocr label
     * @summary Delete Ocr Label
     * @param {string} ocrLabelId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OCRLabelsApi
     */
    public deleteOcrLabel(ocrLabelId: string, authorization: string, options?: AxiosRequestConfig) {
        return OCRLabelsApiFp(this.configuration).deleteOcrLabel(ocrLabelId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets all ocr labels. Join does not work here
     * @summary Get Many Ocr Labels
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OCRLabelsApi
     */
    public getManyOcrLabels(authorization: string, options?: AxiosRequestConfig) {
        return OCRLabelsApiFp(this.configuration).getManyOcrLabels(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the specified ocr label
     * @summary Get Ocr Label
     * @param {string} ocrLabelId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OCRLabelsApi
     */
    public getOcrLabel(ocrLabelId: string, authorization: string, options?: AxiosRequestConfig) {
        return OCRLabelsApiFp(this.configuration).getOcrLabel(ocrLabelId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns True if the given OCR Label is being used in any annotation. False otherwise.
     * @summary Is Ocr Label Being Used
     * @param {string} ocrLabelId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OCRLabelsApi
     */
    public isOcrLabelBeingUsed(ocrLabelId: string, authorization: string, options?: AxiosRequestConfig) {
        return OCRLabelsApiFp(this.configuration).isOcrLabelBeingUsed(ocrLabelId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the specified ocr label
     * @summary Update Ocr Label
     * @param {string} ocrLabelId 
     * @param {string} authorization 
     * @param {OCRLabelEdit} oCRLabelEdit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OCRLabelsApi
     */
    public updateOcrLabel(ocrLabelId: string, authorization: string, oCRLabelEdit: OCRLabelEdit, options?: AxiosRequestConfig) {
        return OCRLabelsApiFp(this.configuration).updateOcrLabel(ocrLabelId, authorization, oCRLabelEdit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PDFOperationsApi - axios parameter creator
 * @export
 */
export const PDFOperationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes the specified PDF Object
         * @summary Delete Pdf Object
         * @param {string} pdfuid 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePdfObject: async (pdfuid: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pdfuid' is not null or undefined
            assertParamExists('deletePdfObject', 'pdfuid', pdfuid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deletePdfObject', 'authorization', authorization)
            const localVarPath = `/pdf-operations/{pdfuid}`
                .replace(`{${"pdfuid"}}`, encodeURIComponent(String(pdfuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the specified PDF Object
         * @summary Get Pdf Object
         * @param {string} pdfuid 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdfObject: async (pdfuid: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pdfuid' is not null or undefined
            assertParamExists('getPdfObject', 'pdfuid', pdfuid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPdfObject', 'authorization', authorization)
            const localVarPath = `/pdf-operations/{pdfuid}`
                .replace(`{${"pdfuid"}}`, encodeURIComponent(String(pdfuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the specified PDF Object
         * @summary Update Pdf Object Status
         * @param {string} pdfuid 
         * @param {string} authorization 
         * @param {PDFObjectEdit} pDFObjectEdit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePdfObjectStatus: async (pdfuid: string, authorization: string, pDFObjectEdit: PDFObjectEdit, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pdfuid' is not null or undefined
            assertParamExists('updatePdfObjectStatus', 'pdfuid', pdfuid)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePdfObjectStatus', 'authorization', authorization)
            // verify required parameter 'pDFObjectEdit' is not null or undefined
            assertParamExists('updatePdfObjectStatus', 'pDFObjectEdit', pDFObjectEdit)
            const localVarPath = `/pdf-operations/{pdfuid}`
                .replace(`{${"pdfuid"}}`, encodeURIComponent(String(pdfuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pDFObjectEdit, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a PDF Object. Only system users can do this. If owner_id is not passed in the current user will be used as the owner.
         * @summary Upload Pdf Object
         * @param {string} authorization 
         * @param {any} file 
         * @param {string} pdfObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPdfObject: async (authorization: string, file: any, pdfObject: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadPdfObject', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadPdfObject', 'file', file)
            // verify required parameter 'pdfObject' is not null or undefined
            assertParamExists('uploadPdfObject', 'pdfObject', pdfObject)
            const localVarPath = `/pdf-operations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (pdfObject !== undefined) { 
                localVarFormParams.append('pdf_object', pdfObject as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PDFOperationsApi - functional programming interface
 * @export
 */
export const PDFOperationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PDFOperationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes the specified PDF Object
         * @summary Delete Pdf Object
         * @param {string} pdfuid 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePdfObject(pdfuid: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePdfObject(pdfuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the specified PDF Object
         * @summary Get Pdf Object
         * @param {string} pdfuid 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPdfObject(pdfuid: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFObjectOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPdfObject(pdfuid, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the specified PDF Object
         * @summary Update Pdf Object Status
         * @param {string} pdfuid 
         * @param {string} authorization 
         * @param {PDFObjectEdit} pDFObjectEdit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePdfObjectStatus(pdfuid: string, authorization: string, pDFObjectEdit: PDFObjectEdit, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFObjectOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePdfObjectStatus(pdfuid, authorization, pDFObjectEdit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a PDF Object. Only system users can do this. If owner_id is not passed in the current user will be used as the owner.
         * @summary Upload Pdf Object
         * @param {string} authorization 
         * @param {any} file 
         * @param {string} pdfObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadPdfObject(authorization: string, file: any, pdfObject: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFObjectOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadPdfObject(authorization, file, pdfObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PDFOperationsApi - factory interface
 * @export
 */
export const PDFOperationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PDFOperationsApiFp(configuration)
    return {
        /**
         * Deletes the specified PDF Object
         * @summary Delete Pdf Object
         * @param {string} pdfuid 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePdfObject(pdfuid: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.deletePdfObject(pdfuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the specified PDF Object
         * @summary Get Pdf Object
         * @param {string} pdfuid 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdfObject(pdfuid: string, authorization: string, options?: any): AxiosPromise<PDFObjectOut> {
            return localVarFp.getPdfObject(pdfuid, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the specified PDF Object
         * @summary Update Pdf Object Status
         * @param {string} pdfuid 
         * @param {string} authorization 
         * @param {PDFObjectEdit} pDFObjectEdit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePdfObjectStatus(pdfuid: string, authorization: string, pDFObjectEdit: PDFObjectEdit, options?: any): AxiosPromise<PDFObjectOut> {
            return localVarFp.updatePdfObjectStatus(pdfuid, authorization, pDFObjectEdit, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a PDF Object. Only system users can do this. If owner_id is not passed in the current user will be used as the owner.
         * @summary Upload Pdf Object
         * @param {string} authorization 
         * @param {any} file 
         * @param {string} pdfObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadPdfObject(authorization: string, file: any, pdfObject: string, options?: any): AxiosPromise<PDFObjectOut> {
            return localVarFp.uploadPdfObject(authorization, file, pdfObject, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PDFOperationsApi - object-oriented interface
 * @export
 * @class PDFOperationsApi
 * @extends {BaseAPI}
 */
export class PDFOperationsApi extends BaseAPI {
    /**
     * Deletes the specified PDF Object
     * @summary Delete Pdf Object
     * @param {string} pdfuid 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFOperationsApi
     */
    public deletePdfObject(pdfuid: string, authorization: string, options?: AxiosRequestConfig) {
        return PDFOperationsApiFp(this.configuration).deletePdfObject(pdfuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the specified PDF Object
     * @summary Get Pdf Object
     * @param {string} pdfuid 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFOperationsApi
     */
    public getPdfObject(pdfuid: string, authorization: string, options?: AxiosRequestConfig) {
        return PDFOperationsApiFp(this.configuration).getPdfObject(pdfuid, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the specified PDF Object
     * @summary Update Pdf Object Status
     * @param {string} pdfuid 
     * @param {string} authorization 
     * @param {PDFObjectEdit} pDFObjectEdit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFOperationsApi
     */
    public updatePdfObjectStatus(pdfuid: string, authorization: string, pDFObjectEdit: PDFObjectEdit, options?: AxiosRequestConfig) {
        return PDFOperationsApiFp(this.configuration).updatePdfObjectStatus(pdfuid, authorization, pDFObjectEdit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a PDF Object. Only system users can do this. If owner_id is not passed in the current user will be used as the owner.
     * @summary Upload Pdf Object
     * @param {string} authorization 
     * @param {any} file 
     * @param {string} pdfObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PDFOperationsApi
     */
    public uploadPdfObject(authorization: string, file: any, pdfObject: string, options?: AxiosRequestConfig) {
        return PDFOperationsApiFp(this.configuration).uploadPdfObject(authorization, file, pdfObject, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipelineModelsApi - axios parameter creator
 * @export
 */
export const PipelineModelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Pipeline Model
         * @param {string} authorization 
         * @param {string} requestJson 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPipelineModel: async (authorization: string, requestJson: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createPipelineModel', 'authorization', authorization)
            // verify required parameter 'requestJson' is not null or undefined
            assertParamExists('createPipelineModel', 'requestJson', requestJson)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createPipelineModel', 'file', file)
            const localVarPath = `/pipeline-models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (requestJson !== undefined) { 
                localVarFormParams.append('request_json', requestJson as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Pipeline Model By Id
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePipelineModelById: async (pipelineModelId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineModelId' is not null or undefined
            assertParamExists('deletePipelineModelById', 'pipelineModelId', pipelineModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deletePipelineModelById', 'authorization', authorization)
            const localVarPath = `/pipeline-models/{pipeline_model_id}`
                .replace(`{${"pipeline_model_id"}}`, encodeURIComponent(String(pipelineModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * join works here. User ID can be sent to retrieve the pipelines for that particular user.
         * @summary Get Attached Pipelines
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineVariant} [variant] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachedPipelines: async (pipelineModelId: string, authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, variant?: PipelineVariant, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineModelId' is not null or undefined
            assertParamExists('getAttachedPipelines', 'pipelineModelId', pipelineModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAttachedPipelines', 'authorization', authorization)
            const localVarPath = `/pipeline-models/{pipeline_model_id}/pipelines`
                .replace(`{${"pipeline_model_id"}}`, encodeURIComponent(String(pipelineModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (variant !== undefined) {
                localVarQueryParameter['variant'] = variant;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * join works here
         * @summary Get Pipeline Model By Id
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineModelById: async (pipelineModelId: string, authorization: string, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineModelId' is not null or undefined
            assertParamExists('getPipelineModelById', 'pipelineModelId', pipelineModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelineModelById', 'authorization', authorization)
            const localVarPath = `/pipeline-models/{pipeline_model_id}`
                .replace(`{${"pipeline_model_id"}}`, encodeURIComponent(String(pipelineModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pipeline Model File
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineModelFile: async (pipelineModelId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineModelId' is not null or undefined
            assertParamExists('getPipelineModelFile', 'pipelineModelId', pipelineModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelineModelFile', 'authorization', authorization)
            const localVarPath = `/pipeline-models/{pipeline_model_id}/download`
                .replace(`{${"pipeline_model_id"}}`, encodeURIComponent(String(pipelineModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * join works here. User ID can be sent to retrieve the models for that particular user.
         * @summary Get Pipeline Models
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineModelVariantsForUI} [variant] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineModels: async (authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, variant?: PipelineModelVariantsForUI, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelineModels', 'authorization', authorization)
            const localVarPath = `/pipeline-models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (variant !== undefined) {
                localVarQueryParameter['variant'] = variant;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Sample Ocr Model Config
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSampleOcrModelConfig: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSampleOcrModelConfig', 'authorization', authorization)
            const localVarPath = `/pipeline-models/sample-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Pipeline Model
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {PipelineModelEdit} pipelineModelEdit  # Uploading A Pipeline Model  # Meaning of Status in returned data NOT_TRAINING &lt;br /&gt; TRAINING &lt;br /&gt; READY 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipelineModel: async (pipelineModelId: string, authorization: string, pipelineModelEdit: PipelineModelEdit, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineModelId' is not null or undefined
            assertParamExists('updatePipelineModel', 'pipelineModelId', pipelineModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePipelineModel', 'authorization', authorization)
            // verify required parameter 'pipelineModelEdit' is not null or undefined
            assertParamExists('updatePipelineModel', 'pipelineModelEdit', pipelineModelEdit)
            const localVarPath = `/pipeline-models/{pipeline_model_id}`
                .replace(`{${"pipeline_model_id"}}`, encodeURIComponent(String(pipelineModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pipelineModelEdit, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Pipeline Model File
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipelineModelFile: async (pipelineModelId: string, authorization: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineModelId' is not null or undefined
            assertParamExists('updatePipelineModelFile', 'pipelineModelId', pipelineModelId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePipelineModelFile', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('updatePipelineModelFile', 'file', file)
            const localVarPath = `/pipeline-models/{pipeline_model_id}/file`
                .replace(`{${"pipeline_model_id"}}`, encodeURIComponent(String(pipelineModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipelineModelsApi - functional programming interface
 * @export
 */
export const PipelineModelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipelineModelsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Pipeline Model
         * @param {string} authorization 
         * @param {string} requestJson 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPipelineModel(authorization: string, requestJson: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPipelineModel(authorization, requestJson, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Pipeline Model By Id
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePipelineModelById(pipelineModelId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePipelineModelById(pipelineModelId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * join works here. User ID can be sent to retrieve the pipelines for that particular user.
         * @summary Get Attached Pipelines
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineVariant} [variant] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachedPipelines(pipelineModelId: string, authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, variant?: PipelineVariant, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyPipelinesOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachedPipelines(pipelineModelId, authorization, userId, orderBy, orderDirection, variant, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * join works here
         * @summary Get Pipeline Model By Id
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineModelById(pipelineModelId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineModelById(pipelineModelId, authorization, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Pipeline Model File
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineModelFile(pipelineModelId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineModelFile(pipelineModelId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * join works here. User ID can be sent to retrieve the models for that particular user.
         * @summary Get Pipeline Models
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineModelVariantsForUI} [variant] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineModels(authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, variant?: PipelineModelVariantsForUI, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyPipelineModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineModels(authorization, userId, orderBy, orderDirection, variant, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Sample Ocr Model Config
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSampleOcrModelConfig(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSampleOcrModelConfig(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Pipeline Model
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {PipelineModelEdit} pipelineModelEdit  # Uploading A Pipeline Model  # Meaning of Status in returned data NOT_TRAINING &lt;br /&gt; TRAINING &lt;br /&gt; READY 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePipelineModel(pipelineModelId: string, authorization: string, pipelineModelEdit: PipelineModelEdit, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePipelineModel(pipelineModelId, authorization, pipelineModelEdit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Pipeline Model File
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePipelineModelFile(pipelineModelId: string, authorization: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineModelOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePipelineModelFile(pipelineModelId, authorization, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipelineModelsApi - factory interface
 * @export
 */
export const PipelineModelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipelineModelsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Pipeline Model
         * @param {string} authorization 
         * @param {string} requestJson 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPipelineModel(authorization: string, requestJson: string, file: any, options?: any): AxiosPromise<PipelineModelOut> {
            return localVarFp.createPipelineModel(authorization, requestJson, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Pipeline Model By Id
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePipelineModelById(pipelineModelId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.deletePipelineModelById(pipelineModelId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * join works here. User ID can be sent to retrieve the pipelines for that particular user.
         * @summary Get Attached Pipelines
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineVariant} [variant] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachedPipelines(pipelineModelId: string, authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, variant?: PipelineVariant, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyPipelinesOut> {
            return localVarFp.getAttachedPipelines(pipelineModelId, authorization, userId, orderBy, orderDirection, variant, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * join works here
         * @summary Get Pipeline Model By Id
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineModelById(pipelineModelId: string, authorization: string, join?: boolean, options?: any): AxiosPromise<PipelineModelOut> {
            return localVarFp.getPipelineModelById(pipelineModelId, authorization, join, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Pipeline Model File
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineModelFile(pipelineModelId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.getPipelineModelFile(pipelineModelId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * join works here. User ID can be sent to retrieve the models for that particular user.
         * @summary Get Pipeline Models
         * @param {string} authorization 
         * @param {string} [userId] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineModelVariantsForUI} [variant] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineModels(authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, variant?: PipelineModelVariantsForUI, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyPipelineModelOut> {
            return localVarFp.getPipelineModels(authorization, userId, orderBy, orderDirection, variant, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Sample Ocr Model Config
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSampleOcrModelConfig(authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.getSampleOcrModelConfig(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Pipeline Model
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {PipelineModelEdit} pipelineModelEdit  # Uploading A Pipeline Model  # Meaning of Status in returned data NOT_TRAINING &lt;br /&gt; TRAINING &lt;br /&gt; READY 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipelineModel(pipelineModelId: string, authorization: string, pipelineModelEdit: PipelineModelEdit, options?: any): AxiosPromise<any> {
            return localVarFp.updatePipelineModel(pipelineModelId, authorization, pipelineModelEdit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Pipeline Model File
         * @param {string} pipelineModelId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipelineModelFile(pipelineModelId: string, authorization: string, file: any, options?: any): AxiosPromise<PipelineModelOut> {
            return localVarFp.updatePipelineModelFile(pipelineModelId, authorization, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipelineModelsApi - object-oriented interface
 * @export
 * @class PipelineModelsApi
 * @extends {BaseAPI}
 */
export class PipelineModelsApi extends BaseAPI {
    /**
     * 
     * @summary Create Pipeline Model
     * @param {string} authorization 
     * @param {string} requestJson 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelineModelsApi
     */
    public createPipelineModel(authorization: string, requestJson: string, file: any, options?: AxiosRequestConfig) {
        return PipelineModelsApiFp(this.configuration).createPipelineModel(authorization, requestJson, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Pipeline Model By Id
     * @param {string} pipelineModelId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelineModelsApi
     */
    public deletePipelineModelById(pipelineModelId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelineModelsApiFp(this.configuration).deletePipelineModelById(pipelineModelId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * join works here. User ID can be sent to retrieve the pipelines for that particular user.
     * @summary Get Attached Pipelines
     * @param {string} pipelineModelId 
     * @param {string} authorization 
     * @param {string} [userId] 
     * @param {GenericSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {PipelineVariant} [variant] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelineModelsApi
     */
    public getAttachedPipelines(pipelineModelId: string, authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, variant?: PipelineVariant, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return PipelineModelsApiFp(this.configuration).getAttachedPipelines(pipelineModelId, authorization, userId, orderBy, orderDirection, variant, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * join works here
     * @summary Get Pipeline Model By Id
     * @param {string} pipelineModelId 
     * @param {string} authorization 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelineModelsApi
     */
    public getPipelineModelById(pipelineModelId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig) {
        return PipelineModelsApiFp(this.configuration).getPipelineModelById(pipelineModelId, authorization, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Pipeline Model File
     * @param {string} pipelineModelId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelineModelsApi
     */
    public getPipelineModelFile(pipelineModelId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelineModelsApiFp(this.configuration).getPipelineModelFile(pipelineModelId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * join works here. User ID can be sent to retrieve the models for that particular user.
     * @summary Get Pipeline Models
     * @param {string} authorization 
     * @param {string} [userId] 
     * @param {GenericSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {PipelineModelVariantsForUI} [variant] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelineModelsApi
     */
    public getPipelineModels(authorization: string, userId?: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, variant?: PipelineModelVariantsForUI, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return PipelineModelsApiFp(this.configuration).getPipelineModels(authorization, userId, orderBy, orderDirection, variant, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Sample Ocr Model Config
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelineModelsApi
     */
    public getSampleOcrModelConfig(authorization: string, options?: AxiosRequestConfig) {
        return PipelineModelsApiFp(this.configuration).getSampleOcrModelConfig(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Pipeline Model
     * @param {string} pipelineModelId 
     * @param {string} authorization 
     * @param {PipelineModelEdit} pipelineModelEdit  # Uploading A Pipeline Model  # Meaning of Status in returned data NOT_TRAINING &lt;br /&gt; TRAINING &lt;br /&gt; READY 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelineModelsApi
     */
    public updatePipelineModel(pipelineModelId: string, authorization: string, pipelineModelEdit: PipelineModelEdit, options?: AxiosRequestConfig) {
        return PipelineModelsApiFp(this.configuration).updatePipelineModel(pipelineModelId, authorization, pipelineModelEdit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Pipeline Model File
     * @param {string} pipelineModelId 
     * @param {string} authorization 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelineModelsApi
     */
    public updatePipelineModelFile(pipelineModelId: string, authorization: string, file: any, options?: AxiosRequestConfig) {
        return PipelineModelsApiFp(this.configuration).updatePipelineModelFile(pipelineModelId, authorization, file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PipelinesApi - axios parameter creator
 * @export
 */
export const PipelinesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Runs the pipeline consumer to calculate the accuracy score for all the associated or specified pipeline results in the pipeline.  If an API key is used to access this function, an access exception is thrown
         * @summary Calculate Accuracy Score Of Zero Shot Pipeline Results Labels
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {ResultsIDlist} [resultsIDlist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateAccuracyScoreOfZeroShotPipelineResultsLabels: async (pipelineId: string, authorization: string, resultsIDlist?: ResultsIDlist, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('calculateAccuracyScoreOfZeroShotPipelineResultsLabels', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('calculateAccuracyScoreOfZeroShotPipelineResultsLabels', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/calculate-accuracy-scores`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resultsIDlist, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new api key for the specified pipelines. If an API key is used to access this function, an access exception is thrown
         * @summary Create Api Key For Pipelines
         * @param {string} authorization 
         * @param {NewAPIKey} newAPIKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeyForPipelines: async (authorization: string, newAPIKey: NewAPIKey, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createApiKeyForPipelines', 'authorization', authorization)
            // verify required parameter 'newAPIKey' is not null or undefined
            assertParamExists('createApiKeyForPipelines', 'newAPIKey', newAPIKey)
            const localVarPath = `/pipelines/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newAPIKey, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new pipeline result.
         * @summary Create Pipeline Result
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {string} [attributes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPipelineResult: async (pipelineId: string, authorization: string, file: any, attributes?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('createPipelineResult', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('createPipelineResult', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createPipelineResult', 'file', file)
            const localVarPath = `/pipelines/{pipeline_id}/results`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (attributes !== undefined) { 
                localVarFormParams.append('attributes', attributes as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes pipeline results for this pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Delete All Pipeline Results
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllPipelineResults: async (pipelineId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('deleteAllPipelineResults', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteAllPipelineResults', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/results`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the specified api key If an API key is used to access this function, an access exception is thrown
         * @summary Delete Api Key
         * @param {string} apiKeyId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey: async (apiKeyId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('deleteApiKey', 'apiKeyId', apiKeyId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteApiKey', 'authorization', authorization)
            const localVarPath = `/pipelines/api-keys/{api_key_id}`
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Delete Many Pipelines Results
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {Array<string>} [pipelineResultIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyPipelinesResults: async (pipelineId: string, authorization: string, pipelineResultIds?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('deleteManyPipelinesResults', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteManyPipelinesResults', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/results/bulk`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pipelineResultIds) {
                localVarQueryParameter['pipeline_result_ids'] = pipelineResultIds;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Delete Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePipeline: async (pipelineId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('deletePipeline', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deletePipeline', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Delete Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePipelineResult: async (pipelineId: string, pipelineResultId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('deletePipelineResult', 'pipelineId', pipelineId)
            // verify required parameter 'pipelineResultId' is not null or undefined
            assertParamExists('deletePipelineResult', 'pipelineResultId', pipelineResultId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deletePipelineResult', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/{pipeline_result_id}`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)))
                .replace(`{${"pipeline_result_id"}}`, encodeURIComponent(String(pipelineResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deployes a new pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Deploy Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployPipeline: async (pipelineId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('deployPipeline', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deployPipeline', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/deploy`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the Pipeline Results file data for this pipeline.
         * @summary File Names By Pipeline Result Id
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileNamesByPipelineResultId: async (pipelineId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('fileNamesByPipelineResultId', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('fileNamesByPipelineResultId', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/file-names-by-pipeline-result-id`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the list of API Keys. If an API key is used to access this function, an access exception is thrown. ** join works here
         * @summary Get Api Keys
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeys: async (authorization: string, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getApiKeys', 'authorization', authorization)
            const localVarPath = `/pipelines/api-keys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the many group for the specified pipeline. The response can contain a combination of PDF or Image group
         * @summary Get Many Pipeline Result Groups
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {PipelineSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineResultStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyPipelineResultGroups: async (pipelineId: string, authorization: string, skip?: number, limit?: number, orderBy?: PipelineSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getManyPipelineResultGroups', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getManyPipelineResultGroups', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/groups`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calculates and returns the average score across the pipeline results of the given pipeline.  If an API key is used to access this function, an access exception is thrown
         * @summary Get Pipeline Accuracy Score
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineAccuracyScore: async (pipelineId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getPipelineAccuracyScore', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelineAccuracyScore', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/accuracy-score`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the specific pipeline with the given ID. If an API key is used to access this function, an access exception is thrown. ** join works here
         * @summary Get Pipeline By Id
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineById: async (pipelineId: string, authorization: string, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getPipelineById', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelineById', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the pipeline deploy logs of all (or given) pipeline(s)
         * @summary Get Pipeline Logs
         * @param {string} authorization 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [pipelineId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineLogs: async (authorization: string, orderDirection?: OrderDirection, pipelineId?: string, limit?: number, offset?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelineLogs', 'authorization', authorization)
            const localVarPath = `/pipelines/deploy-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (pipelineId !== undefined) {
                localVarQueryParameter['pipeline_id'] = pipelineId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a single pipeline result. Unless add_ocr_tokens is set to True, the endpoint does not return the ocr_tokens with other data. <br /> join works here
         * @summary Get Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineResult: async (pipelineId: string, pipelineResultId: string, authorization: string, addOcrTokens?: boolean, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getPipelineResult', 'pipelineId', pipelineId)
            // verify required parameter 'pipelineResultId' is not null or undefined
            assertParamExists('getPipelineResult', 'pipelineResultId', pipelineResultId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelineResult', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/results/{pipeline_result_id}`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)))
                .replace(`{${"pipeline_result_id"}}`, encodeURIComponent(String(pipelineResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (addOcrTokens !== undefined) {
                localVarQueryParameter['add_ocr_tokens'] = addOcrTokens;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Pipeline Result File
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {SMLFileVersion} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineResultFile: async (pipelineId: string, pipelineResultId: string, authorization: string, version?: SMLFileVersion, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getPipelineResultFile', 'pipelineId', pipelineId)
            // verify required parameter 'pipelineResultId' is not null or undefined
            assertParamExists('getPipelineResultFile', 'pipelineResultId', pipelineResultId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelineResultFile', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/results/{pipeline_result_id}/download`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)))
                .replace(`{${"pipeline_result_id"}}`, encodeURIComponent(String(pipelineResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the Pipeline Results for this pipeline ID.  Unless add_ocr_tokens is set to True, the endpoint does not return the ocr_tokens with other data. <br /> ** join works here
         * @summary Get Pipeline Results By Pipe Id
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineResultStatus} [status] 
         * @param {boolean} [resultReviewed] 
         * @param {boolean} [factoryTestSet] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineResultsByPipeId: async (pipelineId: string, authorization: string, addOcrTokens?: boolean, orderBy?: GenericSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, resultReviewed?: boolean, factoryTestSet?: boolean, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getPipelineResultsByPipeId', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelineResultsByPipeId', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/results`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (addOcrTokens !== undefined) {
                localVarQueryParameter['add_ocr_tokens'] = addOcrTokens;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (resultReviewed !== undefined) {
                localVarQueryParameter['result_reviewed'] = resultReviewed;
            }

            if (factoryTestSet !== undefined) {
                localVarQueryParameter['factory_test_set'] = factoryTestSet;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the Pipeline Results IDs for this pipeline ID.
         * @summary Get Pipeline Results Ids
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineResultStatus} [status] 
         * @param {boolean} [resultReviewed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineResultsIds: async (pipelineId: string, authorization: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, resultReviewed?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getPipelineResultsIds', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelineResultsIds', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/results-ids`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (resultReviewed !== undefined) {
                localVarQueryParameter['result_reviewed'] = resultReviewed;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the list of pipelines for this user. If an API key is used to access this function, an access exception is thrown. You can search the pipeline by name using the `q` query parameter. The user_id when present will cause the API to return the pipelines for that user, this action can only be performed by the admin or a worker user.  join works here
         * @summary Get Pipelines
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {string} [q] 
         * @param {PipelineSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineDeploymentStatus} [deploymentStatus] 
         * @param {string} [userId] 
         * @param {PipelineVariant} [variant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelines: async (authorization: string, skip?: number, limit?: number, join?: boolean, q?: string, orderBy?: PipelineSortBy, orderDirection?: OrderDirection, deploymentStatus?: PipelineDeploymentStatus, userId?: string, variant?: PipelineVariant, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPipelines', 'authorization', authorization)
            const localVarPath = `/pipelines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (deploymentStatus !== undefined) {
                localVarQueryParameter['deployment_status'] = deploymentStatus;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (variant !== undefined) {
                localVarQueryParameter['variant'] = variant;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the last N pipeline results that was created in the platform. If the user that calls the endpoint is an admin they will get all the recent pipeline results across the platform. If the user is a regular user, they will only get their recent pipeline results.
         * @summary Get Recent Pipeline Results
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentPipelineResults: async (authorization: string, limit?: number, skip?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getRecentPipelineResults', 'authorization', authorization)
            const localVarPath = `/pipelines/recent-results/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a single group.  A `group_id` is either a `UUID` or regular `ID` being used across the API. `UUID` to indicate it is a PDF Document (multi-page or single page PDF document) and a regular `ID` to indicate it is an image.  If the `group_id` is of the regular `ID`, this means it will only have one element returned as member of the group (`result_ids`). When the `group_id` is a `UUID`, this will contain one or multiple members in the group.  The `group_id` when it is a regular `ID` must be a pipeline result else, a `404` HTTP status code will be returned.
         * @summary Get Single Pipeline Result Group
         * @param {GroupId} groupId 
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSinglePipelineResultGroup: async (groupId: GroupId, pipelineId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getSinglePipelineResultGroup', 'groupId', groupId)
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('getSinglePipelineResultGroup', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSinglePipelineResultGroup', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/groups/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Post New Pipeline
         * @param {string} authorization 
         * @param {NewPipeline} newPipeline  # Uploading Pipeline  The pipeline_variant in the expected JSON can be one of these: 1. SUFGANIYOT_DOCUMENT_PARSER. 2. DOCUMENT_CLASSIFIER. 3. DOCUMENT_CLASSIFIER 4. ZERO_SHOT  The deployment_status is an optional field, the expected value can be one of these 1. READY 2. DEPLOYED   &#x60;&#x60;&#x60;. {   \&quot;pipeline_variant\&quot;: \&quot;SUFGANIYOT_DOCUMENT_PARSER\&quot;,   \&quot;deployment_status\&quot;: \&quot;READY\&quot;,   \&quot;pipeline_configuration\&quot;: {     \&quot;classifier_model_id\&quot;: \&quot;model id\&quot;,     \&quot;model_id\&quot;: \&quot;model id\&quot;,     \&quot;document_dataset_id\&quot;: \&quot;model id\&quot;,     \&quot;zero_shot_config\&quot;: {         \&quot;prompt_extension\&quot;: \&quot;You are looking at an invoice document\&quot;,         \&quot;question_labels\&quot;: [             {                  \&quot;label\&quot;: \&quot;CUSTOMER_NAME\&quot;,                 \&quot;question\&quot;: \&quot;What is the customer name?\&quot;,             }         ]     }   }, } &#x60;&#x60;&#x60; 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewPipeline: async (authorization: string, newPipeline: NewPipeline, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('postNewPipeline', 'authorization', authorization)
            // verify required parameter 'newPipeline' is not null or undefined
            assertParamExists('postNewPipeline', 'newPipeline', newPipeline)
            const localVarPath = `/pipelines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newPipeline, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Runs the pipeline consumer to auto label all the associated or specified pipeline results in the pipeline.  If an API key is used to access this function, an access exception is thrown
         * @summary Predict Zero Shot Pipeline Results Labels
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {boolean} [clearHumanResults] Decides if the function should reset the human results and to set the result_reviewed to False
         * @param {ResultsIDlist} [resultsIDlist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictZeroShotPipelineResultsLabels: async (pipelineId: string, authorization: string, clearHumanResults?: boolean, resultsIDlist?: ResultsIDlist, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('predictZeroShotPipelineResultsLabels', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('predictZeroShotPipelineResultsLabels', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/predict-labels`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (clearHumanResults !== undefined) {
                localVarQueryParameter['clear_human_results'] = clearHumanResults;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resultsIDlist, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * UnDeploys a pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Undeploy Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undeployPipeline: async (pipelineId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('undeployPipeline', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('undeployPipeline', 'authorization', authorization)
            const localVarPath = `/pipelines/{pipeline_id}/undeploy`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Update Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {UpdatePipeline} updatePipeline  # Updating Pipeline  The deployment_status in the expected JSON can be on of these: 1. READY. 2. DEPLOYED.  &#x60;&#x60;&#x60;. {   \&quot;deployment_status\&quot;: \&quot;READY\&quot;, } &#x60;&#x60;&#x60; 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipeline: async (pipelineId: string, authorization: string, updatePipeline: UpdatePipeline, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('updatePipeline', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePipeline', 'authorization', authorization)
            // verify required parameter 'updatePipeline' is not null or undefined
            assertParamExists('updatePipeline', 'updatePipeline', updatePipeline)
            const localVarPath = `/pipelines/{pipeline_id}/`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePipeline, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allows system users update an undeployed pipeline\'s configuration.
         * @summary Update Pipeline Configuration
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {PipelineConfiguration} pipelineConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipelineConfiguration: async (pipelineId: string, authorization: string, pipelineConfiguration: PipelineConfiguration, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('updatePipelineConfiguration', 'pipelineId', pipelineId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePipelineConfiguration', 'authorization', authorization)
            // verify required parameter 'pipelineConfiguration' is not null or undefined
            assertParamExists('updatePipelineConfiguration', 'pipelineConfiguration', pipelineConfiguration)
            const localVarPath = `/pipelines/{pipeline_id}/pipeline-configuration`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pipelineConfiguration, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the pipeline result. Do not include machine_result if you do not intend to update it. Note, for all pipeline variants except ZERO_SHOT, if machine result is present in this data, the value is set for the human result field as well, i.e the result field. For ZERO_SHOT pipeline variants, human results are expected to be sent in an object with the key name \'data\', e.g. ```{ result: { data: { ... } }```. data can not be empty. If an API key is used to access this function, an access exception is thrown.
         * @summary Update Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {UpdatePipelineResult} updatePipelineResult  # Uploading/Updating A Pipeline Result  Pipeline Result are uploaded using a multiform http request. The data to be sent is a json encoded string of the other required fields. Request data must follow a specific format, note request_log, result and machine_result are optional fields.  &#x60;&#x60;&#x60;. {   \&quot;request_log\&quot;: \&quot;multine str\&quot;,   \&quot;machine_result\&quot;: \&quot;dict\&quot;,   \&quot;result\&quot;: \&quot;dict\&quot;,   \&quot;status\&quot;: \&quot;Pending\&quot;, } &#x60;&#x60;&#x60;  # Status can either be one of these Pending &lt;br /&gt; Completed &lt;br /&gt; Failed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipelineResult: async (pipelineId: string, pipelineResultId: string, authorization: string, updatePipelineResult: UpdatePipelineResult, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('updatePipelineResult', 'pipelineId', pipelineId)
            // verify required parameter 'pipelineResultId' is not null or undefined
            assertParamExists('updatePipelineResult', 'pipelineResultId', pipelineResultId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePipelineResult', 'authorization', authorization)
            // verify required parameter 'updatePipelineResult' is not null or undefined
            assertParamExists('updatePipelineResult', 'updatePipelineResult', updatePipelineResult)
            const localVarPath = `/pipelines/{pipeline_id}/results/{pipeline_result_id}`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)))
                .replace(`{${"pipeline_result_id"}}`, encodeURIComponent(String(pipelineResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePipelineResult, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the pipeline result\'s image If an API key is used to access this function, an access exception is thrown
         * @summary Update Pipeline Result Image
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipelineResultImage: async (pipelineId: string, pipelineResultId: string, authorization: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('updatePipelineResultImage', 'pipelineId', pipelineId)
            // verify required parameter 'pipelineResultId' is not null or undefined
            assertParamExists('updatePipelineResultImage', 'pipelineResultId', pipelineResultId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updatePipelineResultImage', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('updatePipelineResultImage', 'file', file)
            const localVarPath = `/pipelines/{pipeline_id}/results/{pipeline_result_id}/image`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)))
                .replace(`{${"pipeline_result_id"}}`, encodeURIComponent(String(pipelineResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a processed file for this pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Upload Processed File To Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProcessedFileToPipelineResult: async (pipelineId: string, pipelineResultId: string, authorization: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('uploadProcessedFileToPipelineResult', 'pipelineId', pipelineId)
            // verify required parameter 'pipelineResultId' is not null or undefined
            assertParamExists('uploadProcessedFileToPipelineResult', 'pipelineResultId', pipelineResultId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadProcessedFileToPipelineResult', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadProcessedFileToPipelineResult', 'file', file)
            const localVarPath = `/pipelines/{pipeline_id}/results/{pipeline_result_id}/processed-file`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)))
                .replace(`{${"pipeline_result_id"}}`, encodeURIComponent(String(pipelineResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads a thumbnail file for this pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Upload Thumbnail File To Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadThumbnailFileToPipelineResult: async (pipelineId: string, pipelineResultId: string, authorization: string, file: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pipelineId' is not null or undefined
            assertParamExists('uploadThumbnailFileToPipelineResult', 'pipelineId', pipelineId)
            // verify required parameter 'pipelineResultId' is not null or undefined
            assertParamExists('uploadThumbnailFileToPipelineResult', 'pipelineResultId', pipelineResultId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('uploadThumbnailFileToPipelineResult', 'authorization', authorization)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadThumbnailFileToPipelineResult', 'file', file)
            const localVarPath = `/pipelines/{pipeline_id}/results/{pipeline_result_id}/thumbnail`
                .replace(`{${"pipeline_id"}}`, encodeURIComponent(String(pipelineId)))
                .replace(`{${"pipeline_result_id"}}`, encodeURIComponent(String(pipelineResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PipelinesApi - functional programming interface
 * @export
 */
export const PipelinesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PipelinesApiAxiosParamCreator(configuration)
    return {
        /**
         * Runs the pipeline consumer to calculate the accuracy score for all the associated or specified pipeline results in the pipeline.  If an API key is used to access this function, an access exception is thrown
         * @summary Calculate Accuracy Score Of Zero Shot Pipeline Results Labels
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {ResultsIDlist} [resultsIDlist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateAccuracyScoreOfZeroShotPipelineResultsLabels(pipelineId: string, authorization: string, resultsIDlist?: ResultsIDlist, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateAccuracyScoreOfZeroShotPipelineResultsLabels(pipelineId, authorization, resultsIDlist, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new api key for the specified pipelines. If an API key is used to access this function, an access exception is thrown
         * @summary Create Api Key For Pipelines
         * @param {string} authorization 
         * @param {NewAPIKey} newAPIKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApiKeyForPipelines(authorization: string, newAPIKey: NewAPIKey, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APIKeyOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApiKeyForPipelines(authorization, newAPIKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new pipeline result.
         * @summary Create Pipeline Result
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {string} [attributes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPipelineResult(pipelineId: string, authorization: string, file: any, attributes?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCreatePipelineResultPipelinesPipelineIdResultsPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPipelineResult(pipelineId, authorization, file, attributes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes pipeline results for this pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Delete All Pipeline Results
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllPipelineResults(pipelineId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllPipelineResults(pipelineId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes the specified api key If an API key is used to access this function, an access exception is thrown
         * @summary Delete Api Key
         * @param {string} apiKeyId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiKey(apiKeyId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiKey(apiKeyId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Delete Many Pipelines Results
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {Array<string>} [pipelineResultIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteManyPipelinesResults(pipelineId: string, authorization: string, pipelineResultIds?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteManyPipelinesResults(pipelineId, authorization, pipelineResultIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes a pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Delete Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePipeline(pipelineId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePipeline(pipelineId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Delete Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePipelineResult(pipelineId, pipelineResultId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deployes a new pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Deploy Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deployPipeline(pipelineId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deployPipeline(pipelineId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the Pipeline Results file data for this pipeline.
         * @summary File Names By Pipeline Result Id
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileNamesByPipelineResultId(pipelineId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyPipelineResultFileDataOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileNamesByPipelineResultId(pipelineId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the list of API Keys. If an API key is used to access this function, an access exception is thrown. ** join works here
         * @summary Get Api Keys
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getApiKeys(authorization: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyAPIKeys>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getApiKeys(authorization, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the many group for the specified pipeline. The response can contain a combination of PDF or Image group
         * @summary Get Many Pipeline Result Groups
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {PipelineSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineResultStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyPipelineResultGroups(pipelineId: string, authorization: string, skip?: number, limit?: number, orderBy?: PipelineSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyPipelineResultGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyPipelineResultGroups(pipelineId, authorization, skip, limit, orderBy, orderDirection, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Calculates and returns the average score across the pipeline results of the given pipeline.  If an API key is used to access this function, an access exception is thrown
         * @summary Get Pipeline Accuracy Score
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineAccuracyScore(pipelineId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineAccuracyScore(pipelineId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the specific pipeline with the given ID. If an API key is used to access this function, an access exception is thrown. ** join works here
         * @summary Get Pipeline By Id
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineById(pipelineId: string, authorization: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineById(pipelineId, authorization, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the pipeline deploy logs of all (or given) pipeline(s)
         * @summary Get Pipeline Logs
         * @param {string} authorization 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [pipelineId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineLogs(authorization: string, orderDirection?: OrderDirection, pipelineId?: string, limit?: number, offset?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyPipelineLogOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineLogs(authorization, orderDirection, pipelineId, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a single pipeline result. Unless add_ocr_tokens is set to True, the endpoint does not return the ocr_tokens with other data. <br /> join works here
         * @summary Get Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, addOcrTokens?: boolean, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineResultOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineResult(pipelineId, pipelineResultId, authorization, addOcrTokens, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Pipeline Result File
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {SMLFileVersion} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineResultFile(pipelineId: string, pipelineResultId: string, authorization: string, version?: SMLFileVersion, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineResultFile(pipelineId, pipelineResultId, authorization, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the Pipeline Results for this pipeline ID.  Unless add_ocr_tokens is set to True, the endpoint does not return the ocr_tokens with other data. <br /> ** join works here
         * @summary Get Pipeline Results By Pipe Id
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineResultStatus} [status] 
         * @param {boolean} [resultReviewed] 
         * @param {boolean} [factoryTestSet] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineResultsByPipeId(pipelineId: string, authorization: string, addOcrTokens?: boolean, orderBy?: GenericSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, resultReviewed?: boolean, factoryTestSet?: boolean, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyPipelinesResultOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineResultsByPipeId(pipelineId, authorization, addOcrTokens, orderBy, orderDirection, status, resultReviewed, factoryTestSet, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the Pipeline Results IDs for this pipeline ID.
         * @summary Get Pipeline Results Ids
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineResultStatus} [status] 
         * @param {boolean} [resultReviewed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelineResultsIds(pipelineId: string, authorization: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, resultReviewed?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MiniFileObjectInfoOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelineResultsIds(pipelineId, authorization, orderBy, orderDirection, status, resultReviewed, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the list of pipelines for this user. If an API key is used to access this function, an access exception is thrown. You can search the pipeline by name using the `q` query parameter. The user_id when present will cause the API to return the pipelines for that user, this action can only be performed by the admin or a worker user.  join works here
         * @summary Get Pipelines
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {string} [q] 
         * @param {PipelineSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineDeploymentStatus} [deploymentStatus] 
         * @param {string} [userId] 
         * @param {PipelineVariant} [variant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPipelines(authorization: string, skip?: number, limit?: number, join?: boolean, q?: string, orderBy?: PipelineSortBy, orderDirection?: OrderDirection, deploymentStatus?: PipelineDeploymentStatus, userId?: string, variant?: PipelineVariant, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyPipelinesOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPipelines(authorization, skip, limit, join, q, orderBy, orderDirection, deploymentStatus, userId, variant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets the last N pipeline results that was created in the platform. If the user that calls the endpoint is an admin they will get all the recent pipeline results across the platform. If the user is a regular user, they will only get their recent pipeline results.
         * @summary Get Recent Pipeline Results
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecentPipelineResults(authorization: string, limit?: number, skip?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyRecentPipelineResults>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecentPipelineResults(authorization, limit, skip, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets a single group.  A `group_id` is either a `UUID` or regular `ID` being used across the API. `UUID` to indicate it is a PDF Document (multi-page or single page PDF document) and a regular `ID` to indicate it is an image.  If the `group_id` is of the regular `ID`, this means it will only have one element returned as member of the group (`result_ids`). When the `group_id` is a `UUID`, this will contain one or multiple members in the group.  The `group_id` when it is a regular `ID` must be a pipeline result else, a `404` HTTP status code will be returned.
         * @summary Get Single Pipeline Result Group
         * @param {GroupId} groupId 
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSinglePipelineResultGroup(groupId: GroupId, pipelineId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SinglePipelineResultGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSinglePipelineResultGroup(groupId, pipelineId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Post New Pipeline
         * @param {string} authorization 
         * @param {NewPipeline} newPipeline  # Uploading Pipeline  The pipeline_variant in the expected JSON can be one of these: 1. SUFGANIYOT_DOCUMENT_PARSER. 2. DOCUMENT_CLASSIFIER. 3. DOCUMENT_CLASSIFIER 4. ZERO_SHOT  The deployment_status is an optional field, the expected value can be one of these 1. READY 2. DEPLOYED   &#x60;&#x60;&#x60;. {   \&quot;pipeline_variant\&quot;: \&quot;SUFGANIYOT_DOCUMENT_PARSER\&quot;,   \&quot;deployment_status\&quot;: \&quot;READY\&quot;,   \&quot;pipeline_configuration\&quot;: {     \&quot;classifier_model_id\&quot;: \&quot;model id\&quot;,     \&quot;model_id\&quot;: \&quot;model id\&quot;,     \&quot;document_dataset_id\&quot;: \&quot;model id\&quot;,     \&quot;zero_shot_config\&quot;: {         \&quot;prompt_extension\&quot;: \&quot;You are looking at an invoice document\&quot;,         \&quot;question_labels\&quot;: [             {                  \&quot;label\&quot;: \&quot;CUSTOMER_NAME\&quot;,                 \&quot;question\&quot;: \&quot;What is the customer name?\&quot;,             }         ]     }   }, } &#x60;&#x60;&#x60; 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNewPipeline(authorization: string, newPipeline: NewPipeline, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNewPipeline(authorization, newPipeline, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Runs the pipeline consumer to auto label all the associated or specified pipeline results in the pipeline.  If an API key is used to access this function, an access exception is thrown
         * @summary Predict Zero Shot Pipeline Results Labels
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {boolean} [clearHumanResults] Decides if the function should reset the human results and to set the result_reviewed to False
         * @param {ResultsIDlist} [resultsIDlist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async predictZeroShotPipelineResultsLabels(pipelineId: string, authorization: string, clearHumanResults?: boolean, resultsIDlist?: ResultsIDlist, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.predictZeroShotPipelineResultsLabels(pipelineId, authorization, clearHumanResults, resultsIDlist, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * UnDeploys a pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Undeploy Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undeployPipeline(pipelineId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undeployPipeline(pipelineId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Update Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {UpdatePipeline} updatePipeline  # Updating Pipeline  The deployment_status in the expected JSON can be on of these: 1. READY. 2. DEPLOYED.  &#x60;&#x60;&#x60;. {   \&quot;deployment_status\&quot;: \&quot;READY\&quot;, } &#x60;&#x60;&#x60; 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePipeline(pipelineId: string, authorization: string, updatePipeline: UpdatePipeline, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePipeline(pipelineId, authorization, updatePipeline, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allows system users update an undeployed pipeline\'s configuration.
         * @summary Update Pipeline Configuration
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {PipelineConfiguration} pipelineConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePipelineConfiguration(pipelineId: string, authorization: string, pipelineConfiguration: PipelineConfiguration, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePipelineConfiguration(pipelineId, authorization, pipelineConfiguration, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the pipeline result. Do not include machine_result if you do not intend to update it. Note, for all pipeline variants except ZERO_SHOT, if machine result is present in this data, the value is set for the human result field as well, i.e the result field. For ZERO_SHOT pipeline variants, human results are expected to be sent in an object with the key name \'data\', e.g. ```{ result: { data: { ... } }```. data can not be empty. If an API key is used to access this function, an access exception is thrown.
         * @summary Update Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {UpdatePipelineResult} updatePipelineResult  # Uploading/Updating A Pipeline Result  Pipeline Result are uploaded using a multiform http request. The data to be sent is a json encoded string of the other required fields. Request data must follow a specific format, note request_log, result and machine_result are optional fields.  &#x60;&#x60;&#x60;. {   \&quot;request_log\&quot;: \&quot;multine str\&quot;,   \&quot;machine_result\&quot;: \&quot;dict\&quot;,   \&quot;result\&quot;: \&quot;dict\&quot;,   \&quot;status\&quot;: \&quot;Pending\&quot;, } &#x60;&#x60;&#x60;  # Status can either be one of these Pending &lt;br /&gt; Completed &lt;br /&gt; Failed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, updatePipelineResult: UpdatePipelineResult, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineResultOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePipelineResult(pipelineId, pipelineResultId, authorization, updatePipelineResult, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the pipeline result\'s image If an API key is used to access this function, an access exception is thrown
         * @summary Update Pipeline Result Image
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePipelineResultImage(pipelineId: string, pipelineResultId: string, authorization: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineResultOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePipelineResultImage(pipelineId, pipelineResultId, authorization, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uploads a processed file for this pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Upload Processed File To Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadProcessedFileToPipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineResultOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadProcessedFileToPipelineResult(pipelineId, pipelineResultId, authorization, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Uploads a thumbnail file for this pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Upload Thumbnail File To Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadThumbnailFileToPipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, file: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PipelineResultOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadThumbnailFileToPipelineResult(pipelineId, pipelineResultId, authorization, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PipelinesApi - factory interface
 * @export
 */
export const PipelinesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PipelinesApiFp(configuration)
    return {
        /**
         * Runs the pipeline consumer to calculate the accuracy score for all the associated or specified pipeline results in the pipeline.  If an API key is used to access this function, an access exception is thrown
         * @summary Calculate Accuracy Score Of Zero Shot Pipeline Results Labels
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {ResultsIDlist} [resultsIDlist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateAccuracyScoreOfZeroShotPipelineResultsLabels(pipelineId: string, authorization: string, resultsIDlist?: ResultsIDlist, options?: any): AxiosPromise<StatusMessage> {
            return localVarFp.calculateAccuracyScoreOfZeroShotPipelineResultsLabels(pipelineId, authorization, resultsIDlist, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new api key for the specified pipelines. If an API key is used to access this function, an access exception is thrown
         * @summary Create Api Key For Pipelines
         * @param {string} authorization 
         * @param {NewAPIKey} newAPIKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeyForPipelines(authorization: string, newAPIKey: NewAPIKey, options?: any): AxiosPromise<APIKeyOut> {
            return localVarFp.createApiKeyForPipelines(authorization, newAPIKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new pipeline result.
         * @summary Create Pipeline Result
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {string} [attributes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPipelineResult(pipelineId: string, authorization: string, file: any, attributes?: string, options?: any): AxiosPromise<ResponseCreatePipelineResultPipelinesPipelineIdResultsPost> {
            return localVarFp.createPipelineResult(pipelineId, authorization, file, attributes, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes pipeline results for this pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Delete All Pipeline Results
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllPipelineResults(pipelineId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteAllPipelineResults(pipelineId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes the specified api key If an API key is used to access this function, an access exception is thrown
         * @summary Delete Api Key
         * @param {string} apiKeyId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKey(apiKeyId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteApiKey(apiKeyId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Delete Many Pipelines Results
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {Array<string>} [pipelineResultIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteManyPipelinesResults(pipelineId: string, authorization: string, pipelineResultIds?: Array<string>, options?: any): AxiosPromise<any> {
            return localVarFp.deleteManyPipelinesResults(pipelineId, authorization, pipelineResultIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Delete Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePipeline(pipelineId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.deletePipeline(pipelineId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Delete Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.deletePipelineResult(pipelineId, pipelineResultId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deployes a new pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Deploy Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployPipeline(pipelineId: string, authorization: string, options?: any): AxiosPromise<StatusMessage> {
            return localVarFp.deployPipeline(pipelineId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the Pipeline Results file data for this pipeline.
         * @summary File Names By Pipeline Result Id
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileNamesByPipelineResultId(pipelineId: string, authorization: string, options?: any): AxiosPromise<ManyPipelineResultFileDataOut> {
            return localVarFp.fileNamesByPipelineResultId(pipelineId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of API Keys. If an API key is used to access this function, an access exception is thrown. ** join works here
         * @summary Get Api Keys
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getApiKeys(authorization: string, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyAPIKeys> {
            return localVarFp.getApiKeys(authorization, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the many group for the specified pipeline. The response can contain a combination of PDF or Image group
         * @summary Get Many Pipeline Result Groups
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {PipelineSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineResultStatus} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyPipelineResultGroups(pipelineId: string, authorization: string, skip?: number, limit?: number, orderBy?: PipelineSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, options?: any): AxiosPromise<ManyPipelineResultGroup> {
            return localVarFp.getManyPipelineResultGroups(pipelineId, authorization, skip, limit, orderBy, orderDirection, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Calculates and returns the average score across the pipeline results of the given pipeline.  If an API key is used to access this function, an access exception is thrown
         * @summary Get Pipeline Accuracy Score
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineAccuracyScore(pipelineId: string, authorization: string, options?: any): AxiosPromise<number> {
            return localVarFp.getPipelineAccuracyScore(pipelineId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the specific pipeline with the given ID. If an API key is used to access this function, an access exception is thrown. ** join works here
         * @summary Get Pipeline By Id
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineById(pipelineId: string, authorization: string, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<PipelineOut> {
            return localVarFp.getPipelineById(pipelineId, authorization, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the pipeline deploy logs of all (or given) pipeline(s)
         * @summary Get Pipeline Logs
         * @param {string} authorization 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [pipelineId] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineLogs(authorization: string, orderDirection?: OrderDirection, pipelineId?: string, limit?: number, offset?: number, options?: any): AxiosPromise<ManyPipelineLogOut> {
            return localVarFp.getPipelineLogs(authorization, orderDirection, pipelineId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a single pipeline result. Unless add_ocr_tokens is set to True, the endpoint does not return the ocr_tokens with other data. <br /> join works here
         * @summary Get Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, addOcrTokens?: boolean, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<PipelineResultOut> {
            return localVarFp.getPipelineResult(pipelineId, pipelineResultId, authorization, addOcrTokens, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Pipeline Result File
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {SMLFileVersion} [version] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineResultFile(pipelineId: string, pipelineResultId: string, authorization: string, version?: SMLFileVersion, options?: any): AxiosPromise<any> {
            return localVarFp.getPipelineResultFile(pipelineId, pipelineResultId, authorization, version, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the Pipeline Results for this pipeline ID.  Unless add_ocr_tokens is set to True, the endpoint does not return the ocr_tokens with other data. <br /> ** join works here
         * @summary Get Pipeline Results By Pipe Id
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineResultStatus} [status] 
         * @param {boolean} [resultReviewed] 
         * @param {boolean} [factoryTestSet] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineResultsByPipeId(pipelineId: string, authorization: string, addOcrTokens?: boolean, orderBy?: GenericSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, resultReviewed?: boolean, factoryTestSet?: boolean, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyPipelinesResultOut> {
            return localVarFp.getPipelineResultsByPipeId(pipelineId, authorization, addOcrTokens, orderBy, orderDirection, status, resultReviewed, factoryTestSet, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the Pipeline Results IDs for this pipeline ID.
         * @summary Get Pipeline Results Ids
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineResultStatus} [status] 
         * @param {boolean} [resultReviewed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelineResultsIds(pipelineId: string, authorization: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, resultReviewed?: boolean, options?: any): AxiosPromise<Array<MiniFileObjectInfoOut>> {
            return localVarFp.getPipelineResultsIds(pipelineId, authorization, orderBy, orderDirection, status, resultReviewed, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the list of pipelines for this user. If an API key is used to access this function, an access exception is thrown. You can search the pipeline by name using the `q` query parameter. The user_id when present will cause the API to return the pipelines for that user, this action can only be performed by the admin or a worker user.  join works here
         * @summary Get Pipelines
         * @param {string} authorization 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {string} [q] 
         * @param {PipelineSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {PipelineDeploymentStatus} [deploymentStatus] 
         * @param {string} [userId] 
         * @param {PipelineVariant} [variant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPipelines(authorization: string, skip?: number, limit?: number, join?: boolean, q?: string, orderBy?: PipelineSortBy, orderDirection?: OrderDirection, deploymentStatus?: PipelineDeploymentStatus, userId?: string, variant?: PipelineVariant, options?: any): AxiosPromise<ManyPipelinesOut> {
            return localVarFp.getPipelines(authorization, skip, limit, join, q, orderBy, orderDirection, deploymentStatus, userId, variant, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the last N pipeline results that was created in the platform. If the user that calls the endpoint is an admin they will get all the recent pipeline results across the platform. If the user is a regular user, they will only get their recent pipeline results.
         * @summary Get Recent Pipeline Results
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [skip] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecentPipelineResults(authorization: string, limit?: number, skip?: number, options?: any): AxiosPromise<ManyRecentPipelineResults> {
            return localVarFp.getRecentPipelineResults(authorization, limit, skip, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a single group.  A `group_id` is either a `UUID` or regular `ID` being used across the API. `UUID` to indicate it is a PDF Document (multi-page or single page PDF document) and a regular `ID` to indicate it is an image.  If the `group_id` is of the regular `ID`, this means it will only have one element returned as member of the group (`result_ids`). When the `group_id` is a `UUID`, this will contain one or multiple members in the group.  The `group_id` when it is a regular `ID` must be a pipeline result else, a `404` HTTP status code will be returned.
         * @summary Get Single Pipeline Result Group
         * @param {GroupId} groupId 
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSinglePipelineResultGroup(groupId: GroupId, pipelineId: string, authorization: string, options?: any): AxiosPromise<SinglePipelineResultGroup> {
            return localVarFp.getSinglePipelineResultGroup(groupId, pipelineId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Post New Pipeline
         * @param {string} authorization 
         * @param {NewPipeline} newPipeline  # Uploading Pipeline  The pipeline_variant in the expected JSON can be one of these: 1. SUFGANIYOT_DOCUMENT_PARSER. 2. DOCUMENT_CLASSIFIER. 3. DOCUMENT_CLASSIFIER 4. ZERO_SHOT  The deployment_status is an optional field, the expected value can be one of these 1. READY 2. DEPLOYED   &#x60;&#x60;&#x60;. {   \&quot;pipeline_variant\&quot;: \&quot;SUFGANIYOT_DOCUMENT_PARSER\&quot;,   \&quot;deployment_status\&quot;: \&quot;READY\&quot;,   \&quot;pipeline_configuration\&quot;: {     \&quot;classifier_model_id\&quot;: \&quot;model id\&quot;,     \&quot;model_id\&quot;: \&quot;model id\&quot;,     \&quot;document_dataset_id\&quot;: \&quot;model id\&quot;,     \&quot;zero_shot_config\&quot;: {         \&quot;prompt_extension\&quot;: \&quot;You are looking at an invoice document\&quot;,         \&quot;question_labels\&quot;: [             {                  \&quot;label\&quot;: \&quot;CUSTOMER_NAME\&quot;,                 \&quot;question\&quot;: \&quot;What is the customer name?\&quot;,             }         ]     }   }, } &#x60;&#x60;&#x60; 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewPipeline(authorization: string, newPipeline: NewPipeline, options?: any): AxiosPromise<PipelineOut> {
            return localVarFp.postNewPipeline(authorization, newPipeline, options).then((request) => request(axios, basePath));
        },
        /**
         * Runs the pipeline consumer to auto label all the associated or specified pipeline results in the pipeline.  If an API key is used to access this function, an access exception is thrown
         * @summary Predict Zero Shot Pipeline Results Labels
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {boolean} [clearHumanResults] Decides if the function should reset the human results and to set the result_reviewed to False
         * @param {ResultsIDlist} [resultsIDlist] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        predictZeroShotPipelineResultsLabels(pipelineId: string, authorization: string, clearHumanResults?: boolean, resultsIDlist?: ResultsIDlist, options?: any): AxiosPromise<StatusMessage> {
            return localVarFp.predictZeroShotPipelineResultsLabels(pipelineId, authorization, clearHumanResults, resultsIDlist, options).then((request) => request(axios, basePath));
        },
        /**
         * UnDeploys a pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Undeploy Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undeployPipeline(pipelineId: string, authorization: string, options?: any): AxiosPromise<StatusMessage> {
            return localVarFp.undeployPipeline(pipelineId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the pipeline. If an API key is used to access this function, an access exception is thrown
         * @summary Update Pipeline
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {UpdatePipeline} updatePipeline  # Updating Pipeline  The deployment_status in the expected JSON can be on of these: 1. READY. 2. DEPLOYED.  &#x60;&#x60;&#x60;. {   \&quot;deployment_status\&quot;: \&quot;READY\&quot;, } &#x60;&#x60;&#x60; 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipeline(pipelineId: string, authorization: string, updatePipeline: UpdatePipeline, options?: any): AxiosPromise<PipelineOut> {
            return localVarFp.updatePipeline(pipelineId, authorization, updatePipeline, options).then((request) => request(axios, basePath));
        },
        /**
         * Allows system users update an undeployed pipeline\'s configuration.
         * @summary Update Pipeline Configuration
         * @param {string} pipelineId 
         * @param {string} authorization 
         * @param {PipelineConfiguration} pipelineConfiguration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipelineConfiguration(pipelineId: string, authorization: string, pipelineConfiguration: PipelineConfiguration, options?: any): AxiosPromise<PipelineOut> {
            return localVarFp.updatePipelineConfiguration(pipelineId, authorization, pipelineConfiguration, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the pipeline result. Do not include machine_result if you do not intend to update it. Note, for all pipeline variants except ZERO_SHOT, if machine result is present in this data, the value is set for the human result field as well, i.e the result field. For ZERO_SHOT pipeline variants, human results are expected to be sent in an object with the key name \'data\', e.g. ```{ result: { data: { ... } }```. data can not be empty. If an API key is used to access this function, an access exception is thrown.
         * @summary Update Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {UpdatePipelineResult} updatePipelineResult  # Uploading/Updating A Pipeline Result  Pipeline Result are uploaded using a multiform http request. The data to be sent is a json encoded string of the other required fields. Request data must follow a specific format, note request_log, result and machine_result are optional fields.  &#x60;&#x60;&#x60;. {   \&quot;request_log\&quot;: \&quot;multine str\&quot;,   \&quot;machine_result\&quot;: \&quot;dict\&quot;,   \&quot;result\&quot;: \&quot;dict\&quot;,   \&quot;status\&quot;: \&quot;Pending\&quot;, } &#x60;&#x60;&#x60;  # Status can either be one of these Pending &lt;br /&gt; Completed &lt;br /&gt; Failed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, updatePipelineResult: UpdatePipelineResult, options?: any): AxiosPromise<PipelineResultOut> {
            return localVarFp.updatePipelineResult(pipelineId, pipelineResultId, authorization, updatePipelineResult, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the pipeline result\'s image If an API key is used to access this function, an access exception is thrown
         * @summary Update Pipeline Result Image
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePipelineResultImage(pipelineId: string, pipelineResultId: string, authorization: string, file: any, options?: any): AxiosPromise<PipelineResultOut> {
            return localVarFp.updatePipelineResultImage(pipelineId, pipelineResultId, authorization, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a processed file for this pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Upload Processed File To Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProcessedFileToPipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, file: any, options?: any): AxiosPromise<PipelineResultOut> {
            return localVarFp.uploadProcessedFileToPipelineResult(pipelineId, pipelineResultId, authorization, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads a thumbnail file for this pipeline result. If an API key is used to access this function, an access exception is thrown
         * @summary Upload Thumbnail File To Pipeline Result
         * @param {string} pipelineId 
         * @param {string} pipelineResultId 
         * @param {string} authorization 
         * @param {any} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadThumbnailFileToPipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, file: any, options?: any): AxiosPromise<PipelineResultOut> {
            return localVarFp.uploadThumbnailFileToPipelineResult(pipelineId, pipelineResultId, authorization, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PipelinesApi - object-oriented interface
 * @export
 * @class PipelinesApi
 * @extends {BaseAPI}
 */
export class PipelinesApi extends BaseAPI {
    /**
     * Runs the pipeline consumer to calculate the accuracy score for all the associated or specified pipeline results in the pipeline.  If an API key is used to access this function, an access exception is thrown
     * @summary Calculate Accuracy Score Of Zero Shot Pipeline Results Labels
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {ResultsIDlist} [resultsIDlist] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public calculateAccuracyScoreOfZeroShotPipelineResultsLabels(pipelineId: string, authorization: string, resultsIDlist?: ResultsIDlist, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).calculateAccuracyScoreOfZeroShotPipelineResultsLabels(pipelineId, authorization, resultsIDlist, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new api key for the specified pipelines. If an API key is used to access this function, an access exception is thrown
     * @summary Create Api Key For Pipelines
     * @param {string} authorization 
     * @param {NewAPIKey} newAPIKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public createApiKeyForPipelines(authorization: string, newAPIKey: NewAPIKey, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).createApiKeyForPipelines(authorization, newAPIKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new pipeline result.
     * @summary Create Pipeline Result
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {any} file 
     * @param {string} [attributes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public createPipelineResult(pipelineId: string, authorization: string, file: any, attributes?: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).createPipelineResult(pipelineId, authorization, file, attributes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes pipeline results for this pipeline. If an API key is used to access this function, an access exception is thrown
     * @summary Delete All Pipeline Results
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public deleteAllPipelineResults(pipelineId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).deleteAllPipelineResults(pipelineId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the specified api key If an API key is used to access this function, an access exception is thrown
     * @summary Delete Api Key
     * @param {string} apiKeyId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public deleteApiKey(apiKeyId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).deleteApiKey(apiKeyId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes pipeline result. If an API key is used to access this function, an access exception is thrown
     * @summary Delete Many Pipelines Results
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {Array<string>} [pipelineResultIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public deleteManyPipelinesResults(pipelineId: string, authorization: string, pipelineResultIds?: Array<string>, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).deleteManyPipelinesResults(pipelineId, authorization, pipelineResultIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a pipeline. If an API key is used to access this function, an access exception is thrown
     * @summary Delete Pipeline
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public deletePipeline(pipelineId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).deletePipeline(pipelineId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes pipeline result. If an API key is used to access this function, an access exception is thrown
     * @summary Delete Pipeline Result
     * @param {string} pipelineId 
     * @param {string} pipelineResultId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public deletePipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).deletePipelineResult(pipelineId, pipelineResultId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deployes a new pipeline. If an API key is used to access this function, an access exception is thrown
     * @summary Deploy Pipeline
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public deployPipeline(pipelineId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).deployPipeline(pipelineId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the Pipeline Results file data for this pipeline.
     * @summary File Names By Pipeline Result Id
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public fileNamesByPipelineResultId(pipelineId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).fileNamesByPipelineResultId(pipelineId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the list of API Keys. If an API key is used to access this function, an access exception is thrown. ** join works here
     * @summary Get Api Keys
     * @param {string} authorization 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getApiKeys(authorization: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getApiKeys(authorization, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the many group for the specified pipeline. The response can contain a combination of PDF or Image group
     * @summary Get Many Pipeline Result Groups
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {PipelineSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {PipelineResultStatus} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getManyPipelineResultGroups(pipelineId: string, authorization: string, skip?: number, limit?: number, orderBy?: PipelineSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getManyPipelineResultGroups(pipelineId, authorization, skip, limit, orderBy, orderDirection, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calculates and returns the average score across the pipeline results of the given pipeline.  If an API key is used to access this function, an access exception is thrown
     * @summary Get Pipeline Accuracy Score
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getPipelineAccuracyScore(pipelineId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getPipelineAccuracyScore(pipelineId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the specific pipeline with the given ID. If an API key is used to access this function, an access exception is thrown. ** join works here
     * @summary Get Pipeline By Id
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getPipelineById(pipelineId: string, authorization: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getPipelineById(pipelineId, authorization, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the pipeline deploy logs of all (or given) pipeline(s)
     * @summary Get Pipeline Logs
     * @param {string} authorization 
     * @param {OrderDirection} [orderDirection] 
     * @param {string} [pipelineId] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getPipelineLogs(authorization: string, orderDirection?: OrderDirection, pipelineId?: string, limit?: number, offset?: number, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getPipelineLogs(authorization, orderDirection, pipelineId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a single pipeline result. Unless add_ocr_tokens is set to True, the endpoint does not return the ocr_tokens with other data. <br /> join works here
     * @summary Get Pipeline Result
     * @param {string} pipelineId 
     * @param {string} pipelineResultId 
     * @param {string} authorization 
     * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getPipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, addOcrTokens?: boolean, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getPipelineResult(pipelineId, pipelineResultId, authorization, addOcrTokens, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Pipeline Result File
     * @param {string} pipelineId 
     * @param {string} pipelineResultId 
     * @param {string} authorization 
     * @param {SMLFileVersion} [version] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getPipelineResultFile(pipelineId: string, pipelineResultId: string, authorization: string, version?: SMLFileVersion, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getPipelineResultFile(pipelineId, pipelineResultId, authorization, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the Pipeline Results for this pipeline ID.  Unless add_ocr_tokens is set to True, the endpoint does not return the ocr_tokens with other data. <br /> ** join works here
     * @summary Get Pipeline Results By Pipe Id
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {boolean} [addOcrTokens] Specifies if the ocr_tokens should be returned in the result data
     * @param {GenericSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {PipelineResultStatus} [status] 
     * @param {boolean} [resultReviewed] 
     * @param {boolean} [factoryTestSet] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getPipelineResultsByPipeId(pipelineId: string, authorization: string, addOcrTokens?: boolean, orderBy?: GenericSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, resultReviewed?: boolean, factoryTestSet?: boolean, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getPipelineResultsByPipeId(pipelineId, authorization, addOcrTokens, orderBy, orderDirection, status, resultReviewed, factoryTestSet, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the Pipeline Results IDs for this pipeline ID.
     * @summary Get Pipeline Results Ids
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {GenericSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {PipelineResultStatus} [status] 
     * @param {boolean} [resultReviewed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getPipelineResultsIds(pipelineId: string, authorization: string, orderBy?: GenericSortBy, orderDirection?: OrderDirection, status?: PipelineResultStatus, resultReviewed?: boolean, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getPipelineResultsIds(pipelineId, authorization, orderBy, orderDirection, status, resultReviewed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the list of pipelines for this user. If an API key is used to access this function, an access exception is thrown. You can search the pipeline by name using the `q` query parameter. The user_id when present will cause the API to return the pipelines for that user, this action can only be performed by the admin or a worker user.  join works here
     * @summary Get Pipelines
     * @param {string} authorization 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {string} [q] 
     * @param {PipelineSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {PipelineDeploymentStatus} [deploymentStatus] 
     * @param {string} [userId] 
     * @param {PipelineVariant} [variant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getPipelines(authorization: string, skip?: number, limit?: number, join?: boolean, q?: string, orderBy?: PipelineSortBy, orderDirection?: OrderDirection, deploymentStatus?: PipelineDeploymentStatus, userId?: string, variant?: PipelineVariant, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getPipelines(authorization, skip, limit, join, q, orderBy, orderDirection, deploymentStatus, userId, variant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the last N pipeline results that was created in the platform. If the user that calls the endpoint is an admin they will get all the recent pipeline results across the platform. If the user is a regular user, they will only get their recent pipeline results.
     * @summary Get Recent Pipeline Results
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [skip] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getRecentPipelineResults(authorization: string, limit?: number, skip?: number, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getRecentPipelineResults(authorization, limit, skip, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a single group.  A `group_id` is either a `UUID` or regular `ID` being used across the API. `UUID` to indicate it is a PDF Document (multi-page or single page PDF document) and a regular `ID` to indicate it is an image.  If the `group_id` is of the regular `ID`, this means it will only have one element returned as member of the group (`result_ids`). When the `group_id` is a `UUID`, this will contain one or multiple members in the group.  The `group_id` when it is a regular `ID` must be a pipeline result else, a `404` HTTP status code will be returned.
     * @summary Get Single Pipeline Result Group
     * @param {GroupId} groupId 
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public getSinglePipelineResultGroup(groupId: GroupId, pipelineId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).getSinglePipelineResultGroup(groupId, pipelineId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new pipeline. If an API key is used to access this function, an access exception is thrown
     * @summary Post New Pipeline
     * @param {string} authorization 
     * @param {NewPipeline} newPipeline  # Uploading Pipeline  The pipeline_variant in the expected JSON can be one of these: 1. SUFGANIYOT_DOCUMENT_PARSER. 2. DOCUMENT_CLASSIFIER. 3. DOCUMENT_CLASSIFIER 4. ZERO_SHOT  The deployment_status is an optional field, the expected value can be one of these 1. READY 2. DEPLOYED   &#x60;&#x60;&#x60;. {   \&quot;pipeline_variant\&quot;: \&quot;SUFGANIYOT_DOCUMENT_PARSER\&quot;,   \&quot;deployment_status\&quot;: \&quot;READY\&quot;,   \&quot;pipeline_configuration\&quot;: {     \&quot;classifier_model_id\&quot;: \&quot;model id\&quot;,     \&quot;model_id\&quot;: \&quot;model id\&quot;,     \&quot;document_dataset_id\&quot;: \&quot;model id\&quot;,     \&quot;zero_shot_config\&quot;: {         \&quot;prompt_extension\&quot;: \&quot;You are looking at an invoice document\&quot;,         \&quot;question_labels\&quot;: [             {                  \&quot;label\&quot;: \&quot;CUSTOMER_NAME\&quot;,                 \&quot;question\&quot;: \&quot;What is the customer name?\&quot;,             }         ]     }   }, } &#x60;&#x60;&#x60; 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public postNewPipeline(authorization: string, newPipeline: NewPipeline, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).postNewPipeline(authorization, newPipeline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Runs the pipeline consumer to auto label all the associated or specified pipeline results in the pipeline.  If an API key is used to access this function, an access exception is thrown
     * @summary Predict Zero Shot Pipeline Results Labels
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {boolean} [clearHumanResults] Decides if the function should reset the human results and to set the result_reviewed to False
     * @param {ResultsIDlist} [resultsIDlist] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public predictZeroShotPipelineResultsLabels(pipelineId: string, authorization: string, clearHumanResults?: boolean, resultsIDlist?: ResultsIDlist, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).predictZeroShotPipelineResultsLabels(pipelineId, authorization, clearHumanResults, resultsIDlist, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * UnDeploys a pipeline. If an API key is used to access this function, an access exception is thrown
     * @summary Undeploy Pipeline
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public undeployPipeline(pipelineId: string, authorization: string, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).undeployPipeline(pipelineId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the pipeline. If an API key is used to access this function, an access exception is thrown
     * @summary Update Pipeline
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {UpdatePipeline} updatePipeline  # Updating Pipeline  The deployment_status in the expected JSON can be on of these: 1. READY. 2. DEPLOYED.  &#x60;&#x60;&#x60;. {   \&quot;deployment_status\&quot;: \&quot;READY\&quot;, } &#x60;&#x60;&#x60; 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public updatePipeline(pipelineId: string, authorization: string, updatePipeline: UpdatePipeline, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).updatePipeline(pipelineId, authorization, updatePipeline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allows system users update an undeployed pipeline\'s configuration.
     * @summary Update Pipeline Configuration
     * @param {string} pipelineId 
     * @param {string} authorization 
     * @param {PipelineConfiguration} pipelineConfiguration 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public updatePipelineConfiguration(pipelineId: string, authorization: string, pipelineConfiguration: PipelineConfiguration, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).updatePipelineConfiguration(pipelineId, authorization, pipelineConfiguration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the pipeline result. Do not include machine_result if you do not intend to update it. Note, for all pipeline variants except ZERO_SHOT, if machine result is present in this data, the value is set for the human result field as well, i.e the result field. For ZERO_SHOT pipeline variants, human results are expected to be sent in an object with the key name \'data\', e.g. ```{ result: { data: { ... } }```. data can not be empty. If an API key is used to access this function, an access exception is thrown.
     * @summary Update Pipeline Result
     * @param {string} pipelineId 
     * @param {string} pipelineResultId 
     * @param {string} authorization 
     * @param {UpdatePipelineResult} updatePipelineResult  # Uploading/Updating A Pipeline Result  Pipeline Result are uploaded using a multiform http request. The data to be sent is a json encoded string of the other required fields. Request data must follow a specific format, note request_log, result and machine_result are optional fields.  &#x60;&#x60;&#x60;. {   \&quot;request_log\&quot;: \&quot;multine str\&quot;,   \&quot;machine_result\&quot;: \&quot;dict\&quot;,   \&quot;result\&quot;: \&quot;dict\&quot;,   \&quot;status\&quot;: \&quot;Pending\&quot;, } &#x60;&#x60;&#x60;  # Status can either be one of these Pending &lt;br /&gt; Completed &lt;br /&gt; Failed 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public updatePipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, updatePipelineResult: UpdatePipelineResult, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).updatePipelineResult(pipelineId, pipelineResultId, authorization, updatePipelineResult, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the pipeline result\'s image If an API key is used to access this function, an access exception is thrown
     * @summary Update Pipeline Result Image
     * @param {string} pipelineId 
     * @param {string} pipelineResultId 
     * @param {string} authorization 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public updatePipelineResultImage(pipelineId: string, pipelineResultId: string, authorization: string, file: any, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).updatePipelineResultImage(pipelineId, pipelineResultId, authorization, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a processed file for this pipeline result. If an API key is used to access this function, an access exception is thrown
     * @summary Upload Processed File To Pipeline Result
     * @param {string} pipelineId 
     * @param {string} pipelineResultId 
     * @param {string} authorization 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public uploadProcessedFileToPipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, file: any, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).uploadProcessedFileToPipelineResult(pipelineId, pipelineResultId, authorization, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads a thumbnail file for this pipeline result. If an API key is used to access this function, an access exception is thrown
     * @summary Upload Thumbnail File To Pipeline Result
     * @param {string} pipelineId 
     * @param {string} pipelineResultId 
     * @param {string} authorization 
     * @param {any} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PipelinesApi
     */
    public uploadThumbnailFileToPipelineResult(pipelineId: string, pipelineResultId: string, authorization: string, file: any, options?: AxiosRequestConfig) {
        return PipelinesApiFp(this.configuration).uploadThumbnailFileToPipelineResult(pipelineId, pipelineResultId, authorization, file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SLFactoryDocumentClassifierWorkOrderApi - axios parameter creator
 * @export
 */
export const SLFactoryDocumentClassifierWorkOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a singular dataset to pipeline work order. Join works here
         * @summary Get Document Classifier Work By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentClassifierWorkById: async (orderId: string, authorization: string, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getDocumentClassifierWorkById', 'orderId', orderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDocumentClassifierWorkById', 'authorization', authorization)
            const localVarPath = `/sl-factory/work-orders/document-classifier-work-orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the Document Classifier Work Orders. Join works here
         * @summary Get Document Classifier Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [classifierModelId] Returns the specific work order that matches this model
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentClassifierWorkOrders: async (authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, classifierModelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getDocumentClassifierWorkOrders', 'authorization', authorization)
            const localVarPath = `/sl-factory/work-orders/document-classifier-work-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (classifierModelId !== undefined) {
                localVarQueryParameter['classifier_model_id'] = classifierModelId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new document classifier work order
         * @summary Post New Document Classifier Work Order
         * @param {string} authorization 
         * @param {DocumentClassifierWorkOrderIn} documentClassifierWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewDocumentClassifierWorkOrder: async (authorization: string, documentClassifierWorkOrderIn: DocumentClassifierWorkOrderIn, dryrun?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('postNewDocumentClassifierWorkOrder', 'authorization', authorization)
            // verify required parameter 'documentClassifierWorkOrderIn' is not null or undefined
            assertParamExists('postNewDocumentClassifierWorkOrder', 'documentClassifierWorkOrderIn', documentClassifierWorkOrderIn)
            const localVarPath = `/sl-factory/work-orders/document-classifier-work-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dryrun !== undefined) {
                localVarQueryParameter['dryrun'] = dryrun;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentClassifierWorkOrderIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the document classifier work order.
         * @summary Update Document Classifier Work By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {DocumentClassifierWorkOrderUpdate} documentClassifierWorkOrderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentClassifierWorkById: async (orderId: string, authorization: string, documentClassifierWorkOrderUpdate: DocumentClassifierWorkOrderUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateDocumentClassifierWorkById', 'orderId', orderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateDocumentClassifierWorkById', 'authorization', authorization)
            // verify required parameter 'documentClassifierWorkOrderUpdate' is not null or undefined
            assertParamExists('updateDocumentClassifierWorkById', 'documentClassifierWorkOrderUpdate', documentClassifierWorkOrderUpdate)
            const localVarPath = `/sl-factory/work-orders/document-classifier-work-orders/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentClassifierWorkOrderUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SLFactoryDocumentClassifierWorkOrderApi - functional programming interface
 * @export
 */
export const SLFactoryDocumentClassifierWorkOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SLFactoryDocumentClassifierWorkOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a singular dataset to pipeline work order. Join works here
         * @summary Get Document Classifier Work By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentClassifierWorkById(orderId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentClassifierWorkOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentClassifierWorkById(orderId, authorization, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the Document Classifier Work Orders. Join works here
         * @summary Get Document Classifier Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [classifierModelId] Returns the specific work order that matches this model
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentClassifierWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, classifierModelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyDocumentClassifierWorkOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentClassifierWorkOrders(authorization, status, orderBy, orderDirection, classifierModelId, userId, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new document classifier work order
         * @summary Post New Document Classifier Work Order
         * @param {string} authorization 
         * @param {DocumentClassifierWorkOrderIn} documentClassifierWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNewDocumentClassifierWorkOrder(authorization: string, documentClassifierWorkOrderIn: DocumentClassifierWorkOrderIn, dryrun?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNewDocumentClassifierWorkOrder(authorization, documentClassifierWorkOrderIn, dryrun, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the document classifier work order.
         * @summary Update Document Classifier Work By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {DocumentClassifierWorkOrderUpdate} documentClassifierWorkOrderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDocumentClassifierWorkById(orderId: string, authorization: string, documentClassifierWorkOrderUpdate: DocumentClassifierWorkOrderUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentClassifierWorkOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocumentClassifierWorkById(orderId, authorization, documentClassifierWorkOrderUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SLFactoryDocumentClassifierWorkOrderApi - factory interface
 * @export
 */
export const SLFactoryDocumentClassifierWorkOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SLFactoryDocumentClassifierWorkOrderApiFp(configuration)
    return {
        /**
         * Retrieve a singular dataset to pipeline work order. Join works here
         * @summary Get Document Classifier Work By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentClassifierWorkById(orderId: string, authorization: string, join?: boolean, options?: any): AxiosPromise<DocumentClassifierWorkOrderOut> {
            return localVarFp.getDocumentClassifierWorkById(orderId, authorization, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the Document Classifier Work Orders. Join works here
         * @summary Get Document Classifier Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [classifierModelId] Returns the specific work order that matches this model
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentClassifierWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, classifierModelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyDocumentClassifierWorkOrderOut> {
            return localVarFp.getDocumentClassifierWorkOrders(authorization, status, orderBy, orderDirection, classifierModelId, userId, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new document classifier work order
         * @summary Post New Document Classifier Work Order
         * @param {string} authorization 
         * @param {DocumentClassifierWorkOrderIn} documentClassifierWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewDocumentClassifierWorkOrder(authorization: string, documentClassifierWorkOrderIn: DocumentClassifierWorkOrderIn, dryrun?: boolean, options?: any): AxiosPromise<ResponsePostNewDocumentClassifierWorkOrderSlFactoryWorkOrdersDocumentClassifierWorkOrdersPost> {
            return localVarFp.postNewDocumentClassifierWorkOrder(authorization, documentClassifierWorkOrderIn, dryrun, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the document classifier work order.
         * @summary Update Document Classifier Work By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {DocumentClassifierWorkOrderUpdate} documentClassifierWorkOrderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDocumentClassifierWorkById(orderId: string, authorization: string, documentClassifierWorkOrderUpdate: DocumentClassifierWorkOrderUpdate, options?: any): AxiosPromise<DocumentClassifierWorkOrderOut> {
            return localVarFp.updateDocumentClassifierWorkById(orderId, authorization, documentClassifierWorkOrderUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SLFactoryDocumentClassifierWorkOrderApi - object-oriented interface
 * @export
 * @class SLFactoryDocumentClassifierWorkOrderApi
 * @extends {BaseAPI}
 */
export class SLFactoryDocumentClassifierWorkOrderApi extends BaseAPI {
    /**
     * Retrieve a singular dataset to pipeline work order. Join works here
     * @summary Get Document Classifier Work By Id
     * @param {string} orderId 
     * @param {string} authorization 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryDocumentClassifierWorkOrderApi
     */
    public getDocumentClassifierWorkById(orderId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryDocumentClassifierWorkOrderApiFp(this.configuration).getDocumentClassifierWorkById(orderId, authorization, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the Document Classifier Work Orders. Join works here
     * @summary Get Document Classifier Work Orders
     * @param {string} authorization 
     * @param {WorkOrderStatus} [status] 
     * @param {GenericSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {string} [classifierModelId] Returns the specific work order that matches this model
     * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryDocumentClassifierWorkOrderApi
     */
    public getDocumentClassifierWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, classifierModelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryDocumentClassifierWorkOrderApiFp(this.configuration).getDocumentClassifierWorkOrders(authorization, status, orderBy, orderDirection, classifierModelId, userId, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new document classifier work order
     * @summary Post New Document Classifier Work Order
     * @param {string} authorization 
     * @param {DocumentClassifierWorkOrderIn} documentClassifierWorkOrderIn 
     * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryDocumentClassifierWorkOrderApi
     */
    public postNewDocumentClassifierWorkOrder(authorization: string, documentClassifierWorkOrderIn: DocumentClassifierWorkOrderIn, dryrun?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryDocumentClassifierWorkOrderApiFp(this.configuration).postNewDocumentClassifierWorkOrder(authorization, documentClassifierWorkOrderIn, dryrun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the document classifier work order.
     * @summary Update Document Classifier Work By Id
     * @param {string} orderId 
     * @param {string} authorization 
     * @param {DocumentClassifierWorkOrderUpdate} documentClassifierWorkOrderUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryDocumentClassifierWorkOrderApi
     */
    public updateDocumentClassifierWorkById(orderId: string, authorization: string, documentClassifierWorkOrderUpdate: DocumentClassifierWorkOrderUpdate, options?: AxiosRequestConfig) {
        return SLFactoryDocumentClassifierWorkOrderApiFp(this.configuration).updateDocumentClassifierWorkById(orderId, authorization, documentClassifierWorkOrderUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SLFactoryWorkOrderSufganiyotParserApi - axios parameter creator
 * @export
 */
export const SLFactoryWorkOrderSufganiyotParserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a singular work order. Join works here
         * @summary Get Sufganiyot Work Order By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSufganiyotWorkOrderById: async (orderId: string, authorization: string, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getSufganiyotWorkOrderById', 'orderId', orderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSufganiyotWorkOrderById', 'authorization', authorization)
            const localVarPath = `/sl-factory/work-orders/sufganiyot-document-parser/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the Dataset to Pipeline Work Orders. Join works here
         * @summary Get Sufganiyot Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [modelId] Returns the specific work order that matches this model
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSufganiyotWorkOrders: async (authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, modelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getSufganiyotWorkOrders', 'authorization', authorization)
            const localVarPath = `/sl-factory/work-orders/sufganiyot-document-parser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (modelId !== undefined) {
                localVarQueryParameter['model_id'] = modelId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new dataset to pipeline work order for sufganiyot model
         * @summary Post New Sufganiyot Work Order
         * @param {string} authorization 
         * @param {SufganiyotWorkOrderIn} sufganiyotWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewSufganiyotWorkOrder: async (authorization: string, sufganiyotWorkOrderIn: SufganiyotWorkOrderIn, dryrun?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('postNewSufganiyotWorkOrder', 'authorization', authorization)
            // verify required parameter 'sufganiyotWorkOrderIn' is not null or undefined
            assertParamExists('postNewSufganiyotWorkOrder', 'sufganiyotWorkOrderIn', sufganiyotWorkOrderIn)
            const localVarPath = `/sl-factory/work-orders/sufganiyot-document-parser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dryrun !== undefined) {
                localVarQueryParameter['dryrun'] = dryrun;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sufganiyotWorkOrderIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new dataset to pipeline work order
         * @summary Post New Sufganiyot Work Order With Custom Model Config
         * @param {string} authorization 
         * @param {SufganiyotCustomModelWorkOrderIn} sufganiyotCustomModelWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewSufganiyotWorkOrderWithCustomModelConfig: async (authorization: string, sufganiyotCustomModelWorkOrderIn: SufganiyotCustomModelWorkOrderIn, dryrun?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('postNewSufganiyotWorkOrderWithCustomModelConfig', 'authorization', authorization)
            // verify required parameter 'sufganiyotCustomModelWorkOrderIn' is not null or undefined
            assertParamExists('postNewSufganiyotWorkOrderWithCustomModelConfig', 'sufganiyotCustomModelWorkOrderIn', sufganiyotCustomModelWorkOrderIn)
            const localVarPath = `/sl-factory/work-orders/sufganiyot-document-parser-custom-model-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dryrun !== undefined) {
                localVarQueryParameter['dryrun'] = dryrun;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sufganiyotCustomModelWorkOrderIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the dataset work order.
         * @summary Update Sufganiyot Work Order
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {SufganiyotWorkOrderUpdate} sufganiyotWorkOrderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSufganiyotWorkOrder: async (orderId: string, authorization: string, sufganiyotWorkOrderUpdate: SufganiyotWorkOrderUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateSufganiyotWorkOrder', 'orderId', orderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateSufganiyotWorkOrder', 'authorization', authorization)
            // verify required parameter 'sufganiyotWorkOrderUpdate' is not null or undefined
            assertParamExists('updateSufganiyotWorkOrder', 'sufganiyotWorkOrderUpdate', sufganiyotWorkOrderUpdate)
            const localVarPath = `/sl-factory/work-orders/sufganiyot-document-parser/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sufganiyotWorkOrderUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SLFactoryWorkOrderSufganiyotParserApi - functional programming interface
 * @export
 */
export const SLFactoryWorkOrderSufganiyotParserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SLFactoryWorkOrderSufganiyotParserApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a singular work order. Join works here
         * @summary Get Sufganiyot Work Order By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSufganiyotWorkOrderById(orderId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SufganiyotWorkOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSufganiyotWorkOrderById(orderId, authorization, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the Dataset to Pipeline Work Orders. Join works here
         * @summary Get Sufganiyot Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [modelId] Returns the specific work order that matches this model
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSufganiyotWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, modelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManySufganiyotWorkOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSufganiyotWorkOrders(authorization, status, orderBy, orderDirection, modelId, userId, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new dataset to pipeline work order for sufganiyot model
         * @summary Post New Sufganiyot Work Order
         * @param {string} authorization 
         * @param {SufganiyotWorkOrderIn} sufganiyotWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNewSufganiyotWorkOrder(authorization: string, sufganiyotWorkOrderIn: SufganiyotWorkOrderIn, dryrun?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNewSufganiyotWorkOrder(authorization, sufganiyotWorkOrderIn, dryrun, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new dataset to pipeline work order
         * @summary Post New Sufganiyot Work Order With Custom Model Config
         * @param {string} authorization 
         * @param {SufganiyotCustomModelWorkOrderIn} sufganiyotCustomModelWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNewSufganiyotWorkOrderWithCustomModelConfig(authorization: string, sufganiyotCustomModelWorkOrderIn: SufganiyotCustomModelWorkOrderIn, dryrun?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNewSufganiyotWorkOrderWithCustomModelConfig(authorization, sufganiyotCustomModelWorkOrderIn, dryrun, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the dataset work order.
         * @summary Update Sufganiyot Work Order
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {SufganiyotWorkOrderUpdate} sufganiyotWorkOrderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSufganiyotWorkOrder(orderId: string, authorization: string, sufganiyotWorkOrderUpdate: SufganiyotWorkOrderUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SufganiyotWorkOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSufganiyotWorkOrder(orderId, authorization, sufganiyotWorkOrderUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SLFactoryWorkOrderSufganiyotParserApi - factory interface
 * @export
 */
export const SLFactoryWorkOrderSufganiyotParserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SLFactoryWorkOrderSufganiyotParserApiFp(configuration)
    return {
        /**
         * Retrieve a singular work order. Join works here
         * @summary Get Sufganiyot Work Order By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSufganiyotWorkOrderById(orderId: string, authorization: string, join?: boolean, options?: any): AxiosPromise<SufganiyotWorkOrderOut> {
            return localVarFp.getSufganiyotWorkOrderById(orderId, authorization, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the Dataset to Pipeline Work Orders. Join works here
         * @summary Get Sufganiyot Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [modelId] Returns the specific work order that matches this model
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSufganiyotWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, modelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManySufganiyotWorkOrderOut> {
            return localVarFp.getSufganiyotWorkOrders(authorization, status, orderBy, orderDirection, modelId, userId, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new dataset to pipeline work order for sufganiyot model
         * @summary Post New Sufganiyot Work Order
         * @param {string} authorization 
         * @param {SufganiyotWorkOrderIn} sufganiyotWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewSufganiyotWorkOrder(authorization: string, sufganiyotWorkOrderIn: SufganiyotWorkOrderIn, dryrun?: boolean, options?: any): AxiosPromise<ResponsePostNewSufganiyotWorkOrderSlFactoryWorkOrdersSufganiyotDocumentParserPost> {
            return localVarFp.postNewSufganiyotWorkOrder(authorization, sufganiyotWorkOrderIn, dryrun, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new dataset to pipeline work order
         * @summary Post New Sufganiyot Work Order With Custom Model Config
         * @param {string} authorization 
         * @param {SufganiyotCustomModelWorkOrderIn} sufganiyotCustomModelWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewSufganiyotWorkOrderWithCustomModelConfig(authorization: string, sufganiyotCustomModelWorkOrderIn: SufganiyotCustomModelWorkOrderIn, dryrun?: boolean, options?: any): AxiosPromise<ResponsePostNewSufganiyotWorkOrderWithCustomModelConfigSlFactoryWorkOrdersSufganiyotDocumentParserCustomModelConfigPost> {
            return localVarFp.postNewSufganiyotWorkOrderWithCustomModelConfig(authorization, sufganiyotCustomModelWorkOrderIn, dryrun, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the dataset work order.
         * @summary Update Sufganiyot Work Order
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {SufganiyotWorkOrderUpdate} sufganiyotWorkOrderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSufganiyotWorkOrder(orderId: string, authorization: string, sufganiyotWorkOrderUpdate: SufganiyotWorkOrderUpdate, options?: any): AxiosPromise<SufganiyotWorkOrderOut> {
            return localVarFp.updateSufganiyotWorkOrder(orderId, authorization, sufganiyotWorkOrderUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SLFactoryWorkOrderSufganiyotParserApi - object-oriented interface
 * @export
 * @class SLFactoryWorkOrderSufganiyotParserApi
 * @extends {BaseAPI}
 */
export class SLFactoryWorkOrderSufganiyotParserApi extends BaseAPI {
    /**
     * Retrieve a singular work order. Join works here
     * @summary Get Sufganiyot Work Order By Id
     * @param {string} orderId 
     * @param {string} authorization 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryWorkOrderSufganiyotParserApi
     */
    public getSufganiyotWorkOrderById(orderId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryWorkOrderSufganiyotParserApiFp(this.configuration).getSufganiyotWorkOrderById(orderId, authorization, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the Dataset to Pipeline Work Orders. Join works here
     * @summary Get Sufganiyot Work Orders
     * @param {string} authorization 
     * @param {WorkOrderStatus} [status] 
     * @param {GenericSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {string} [modelId] Returns the specific work order that matches this model
     * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryWorkOrderSufganiyotParserApi
     */
    public getSufganiyotWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, modelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryWorkOrderSufganiyotParserApiFp(this.configuration).getSufganiyotWorkOrders(authorization, status, orderBy, orderDirection, modelId, userId, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new dataset to pipeline work order for sufganiyot model
     * @summary Post New Sufganiyot Work Order
     * @param {string} authorization 
     * @param {SufganiyotWorkOrderIn} sufganiyotWorkOrderIn 
     * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryWorkOrderSufganiyotParserApi
     */
    public postNewSufganiyotWorkOrder(authorization: string, sufganiyotWorkOrderIn: SufganiyotWorkOrderIn, dryrun?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryWorkOrderSufganiyotParserApiFp(this.configuration).postNewSufganiyotWorkOrder(authorization, sufganiyotWorkOrderIn, dryrun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new dataset to pipeline work order
     * @summary Post New Sufganiyot Work Order With Custom Model Config
     * @param {string} authorization 
     * @param {SufganiyotCustomModelWorkOrderIn} sufganiyotCustomModelWorkOrderIn 
     * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryWorkOrderSufganiyotParserApi
     */
    public postNewSufganiyotWorkOrderWithCustomModelConfig(authorization: string, sufganiyotCustomModelWorkOrderIn: SufganiyotCustomModelWorkOrderIn, dryrun?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryWorkOrderSufganiyotParserApiFp(this.configuration).postNewSufganiyotWorkOrderWithCustomModelConfig(authorization, sufganiyotCustomModelWorkOrderIn, dryrun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the dataset work order.
     * @summary Update Sufganiyot Work Order
     * @param {string} orderId 
     * @param {string} authorization 
     * @param {SufganiyotWorkOrderUpdate} sufganiyotWorkOrderUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryWorkOrderSufganiyotParserApi
     */
    public updateSufganiyotWorkOrder(orderId: string, authorization: string, sufganiyotWorkOrderUpdate: SufganiyotWorkOrderUpdate, options?: AxiosRequestConfig) {
        return SLFactoryWorkOrderSufganiyotParserApiFp(this.configuration).updateSufganiyotWorkOrder(orderId, authorization, sufganiyotWorkOrderUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SLFactoryWorkOrderZeroShotApi - axios parameter creator
 * @export
 */
export const SLFactoryWorkOrderZeroShotApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a singular work order. Join works here
         * @summary Get Zero Shot Work Order By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeroShotWorkOrderById: async (orderId: string, authorization: string, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getZeroShotWorkOrderById', 'orderId', orderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getZeroShotWorkOrderById', 'authorization', authorization)
            const localVarPath = `/sl-factory/work-orders/zero-shot/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the Zero Shot Pipeline Work Orders. Join works here
         * @summary Get Zero Shot Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeroShotWorkOrders: async (authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, userId?: string, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getZeroShotWorkOrders', 'authorization', authorization)
            const localVarPath = `/sl-factory/work-orders/zero-shot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new Zero Shot Pipeline work order for zero_shot pipeline
         * @summary Post New Zero Shot Work Order
         * @param {string} authorization 
         * @param {ZeroShotWorkOrderIn} zeroShotWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewZeroShotWorkOrder: async (authorization: string, zeroShotWorkOrderIn: ZeroShotWorkOrderIn, dryrun?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('postNewZeroShotWorkOrder', 'authorization', authorization)
            // verify required parameter 'zeroShotWorkOrderIn' is not null or undefined
            assertParamExists('postNewZeroShotWorkOrder', 'zeroShotWorkOrderIn', zeroShotWorkOrderIn)
            const localVarPath = `/sl-factory/work-orders/zero-shot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dryrun !== undefined) {
                localVarQueryParameter['dryrun'] = dryrun;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zeroShotWorkOrderIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the dataset work order.
         * @summary Update Zero Shot Work Order
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {ZeroShotWorkOrderUpdate} zeroShotWorkOrderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZeroShotWorkOrder: async (orderId: string, authorization: string, zeroShotWorkOrderUpdate: ZeroShotWorkOrderUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateZeroShotWorkOrder', 'orderId', orderId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateZeroShotWorkOrder', 'authorization', authorization)
            // verify required parameter 'zeroShotWorkOrderUpdate' is not null or undefined
            assertParamExists('updateZeroShotWorkOrder', 'zeroShotWorkOrderUpdate', zeroShotWorkOrderUpdate)
            const localVarPath = `/sl-factory/work-orders/zero-shot/{order_id}`
                .replace(`{${"order_id"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(zeroShotWorkOrderUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SLFactoryWorkOrderZeroShotApi - functional programming interface
 * @export
 */
export const SLFactoryWorkOrderZeroShotApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SLFactoryWorkOrderZeroShotApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve a singular work order. Join works here
         * @summary Get Zero Shot Work Order By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZeroShotWorkOrderById(orderId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZeroShotWorkOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZeroShotWorkOrderById(orderId, authorization, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve the Zero Shot Pipeline Work Orders. Join works here
         * @summary Get Zero Shot Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getZeroShotWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, userId?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyZeroShotWorkOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getZeroShotWorkOrders(authorization, status, orderBy, orderDirection, userId, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new Zero Shot Pipeline work order for zero_shot pipeline
         * @summary Post New Zero Shot Work Order
         * @param {string} authorization 
         * @param {ZeroShotWorkOrderIn} zeroShotWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNewZeroShotWorkOrder(authorization: string, zeroShotWorkOrderIn: ZeroShotWorkOrderIn, dryrun?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNewZeroShotWorkOrder(authorization, zeroShotWorkOrderIn, dryrun, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates the dataset work order.
         * @summary Update Zero Shot Work Order
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {ZeroShotWorkOrderUpdate} zeroShotWorkOrderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateZeroShotWorkOrder(orderId: string, authorization: string, zeroShotWorkOrderUpdate: ZeroShotWorkOrderUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZeroShotWorkOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateZeroShotWorkOrder(orderId, authorization, zeroShotWorkOrderUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SLFactoryWorkOrderZeroShotApi - factory interface
 * @export
 */
export const SLFactoryWorkOrderZeroShotApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SLFactoryWorkOrderZeroShotApiFp(configuration)
    return {
        /**
         * Retrieve a singular work order. Join works here
         * @summary Get Zero Shot Work Order By Id
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeroShotWorkOrderById(orderId: string, authorization: string, join?: boolean, options?: any): AxiosPromise<ZeroShotWorkOrderOut> {
            return localVarFp.getZeroShotWorkOrderById(orderId, authorization, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the Zero Shot Pipeline Work Orders. Join works here
         * @summary Get Zero Shot Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZeroShotWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, userId?: string, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyZeroShotWorkOrderOut> {
            return localVarFp.getZeroShotWorkOrders(authorization, status, orderBy, orderDirection, userId, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new Zero Shot Pipeline work order for zero_shot pipeline
         * @summary Post New Zero Shot Work Order
         * @param {string} authorization 
         * @param {ZeroShotWorkOrderIn} zeroShotWorkOrderIn 
         * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewZeroShotWorkOrder(authorization: string, zeroShotWorkOrderIn: ZeroShotWorkOrderIn, dryrun?: boolean, options?: any): AxiosPromise<ResponsePostNewZeroShotWorkOrderSlFactoryWorkOrdersZeroShotPost> {
            return localVarFp.postNewZeroShotWorkOrder(authorization, zeroShotWorkOrderIn, dryrun, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the dataset work order.
         * @summary Update Zero Shot Work Order
         * @param {string} orderId 
         * @param {string} authorization 
         * @param {ZeroShotWorkOrderUpdate} zeroShotWorkOrderUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateZeroShotWorkOrder(orderId: string, authorization: string, zeroShotWorkOrderUpdate: ZeroShotWorkOrderUpdate, options?: any): AxiosPromise<ZeroShotWorkOrderOut> {
            return localVarFp.updateZeroShotWorkOrder(orderId, authorization, zeroShotWorkOrderUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SLFactoryWorkOrderZeroShotApi - object-oriented interface
 * @export
 * @class SLFactoryWorkOrderZeroShotApi
 * @extends {BaseAPI}
 */
export class SLFactoryWorkOrderZeroShotApi extends BaseAPI {
    /**
     * Retrieve a singular work order. Join works here
     * @summary Get Zero Shot Work Order By Id
     * @param {string} orderId 
     * @param {string} authorization 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryWorkOrderZeroShotApi
     */
    public getZeroShotWorkOrderById(orderId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryWorkOrderZeroShotApiFp(this.configuration).getZeroShotWorkOrderById(orderId, authorization, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the Zero Shot Pipeline Work Orders. Join works here
     * @summary Get Zero Shot Work Orders
     * @param {string} authorization 
     * @param {WorkOrderStatus} [status] 
     * @param {GenericSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryWorkOrderZeroShotApi
     */
    public getZeroShotWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, userId?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryWorkOrderZeroShotApiFp(this.configuration).getZeroShotWorkOrders(authorization, status, orderBy, orderDirection, userId, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new Zero Shot Pipeline work order for zero_shot pipeline
     * @summary Post New Zero Shot Work Order
     * @param {string} authorization 
     * @param {ZeroShotWorkOrderIn} zeroShotWorkOrderIn 
     * @param {boolean} [dryrun] Perform a pre-validation check on the work order request without adding any messages to the event queue or allocating any additional resources. This check can be utilized to evaluate the feasibility of the work order request before it is actually processed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryWorkOrderZeroShotApi
     */
    public postNewZeroShotWorkOrder(authorization: string, zeroShotWorkOrderIn: ZeroShotWorkOrderIn, dryrun?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryWorkOrderZeroShotApiFp(this.configuration).postNewZeroShotWorkOrder(authorization, zeroShotWorkOrderIn, dryrun, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the dataset work order.
     * @summary Update Zero Shot Work Order
     * @param {string} orderId 
     * @param {string} authorization 
     * @param {ZeroShotWorkOrderUpdate} zeroShotWorkOrderUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryWorkOrderZeroShotApi
     */
    public updateZeroShotWorkOrder(orderId: string, authorization: string, zeroShotWorkOrderUpdate: ZeroShotWorkOrderUpdate, options?: AxiosRequestConfig) {
        return SLFactoryWorkOrderZeroShotApiFp(this.configuration).updateZeroShotWorkOrder(orderId, authorization, zeroShotWorkOrderUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SLFactoryWorkOrdersApi - axios parameter creator
 * @export
 */
export const SLFactoryWorkOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve all the work orders in the database. Join works here
         * @summary Get All Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [modelId] Returns the specific work order that matches this model
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWorkOrders: async (authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, modelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getAllWorkOrders', 'authorization', authorization)
            const localVarPath = `/sl-factory/work-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (modelId !== undefined) {
                localVarQueryParameter['model_id'] = modelId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SLFactoryWorkOrdersApi - functional programming interface
 * @export
 */
export const SLFactoryWorkOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SLFactoryWorkOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve all the work orders in the database. Join works here
         * @summary Get All Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [modelId] Returns the specific work order that matches this model
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, modelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyGenericWorkOrderOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllWorkOrders(authorization, status, orderBy, orderDirection, modelId, userId, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SLFactoryWorkOrdersApi - factory interface
 * @export
 */
export const SLFactoryWorkOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SLFactoryWorkOrdersApiFp(configuration)
    return {
        /**
         * Retrieve all the work orders in the database. Join works here
         * @summary Get All Work Orders
         * @param {string} authorization 
         * @param {WorkOrderStatus} [status] 
         * @param {GenericSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {string} [modelId] Returns the specific work order that matches this model
         * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, modelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyGenericWorkOrderOut> {
            return localVarFp.getAllWorkOrders(authorization, status, orderBy, orderDirection, modelId, userId, skip, limit, join, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SLFactoryWorkOrdersApi - object-oriented interface
 * @export
 * @class SLFactoryWorkOrdersApi
 * @extends {BaseAPI}
 */
export class SLFactoryWorkOrdersApi extends BaseAPI {
    /**
     * Retrieve all the work orders in the database. Join works here
     * @summary Get All Work Orders
     * @param {string} authorization 
     * @param {WorkOrderStatus} [status] 
     * @param {GenericSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {string} [modelId] Returns the specific work order that matches this model
     * @param {string} [userId] Returns the specific work order that matches this user\&#39;s
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SLFactoryWorkOrdersApi
     */
    public getAllWorkOrders(authorization: string, status?: WorkOrderStatus, orderBy?: GenericSortBy, orderDirection?: OrderDirection, modelId?: string, userId?: string, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return SLFactoryWorkOrdersApiFp(this.configuration).getAllWorkOrders(authorization, status, orderBy, orderDirection, modelId, userId, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SupportApi - axios parameter creator
 * @export
 */
export const SupportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change Ticket Admin
         * @param {string} ticketId 
         * @param {string} newAdminUserId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTicketAdmin: async (ticketId: string, newAdminUserId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('changeTicketAdmin', 'ticketId', ticketId)
            // verify required parameter 'newAdminUserId' is not null or undefined
            assertParamExists('changeTicketAdmin', 'newAdminUserId', newAdminUserId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('changeTicketAdmin', 'authorization', authorization)
            const localVarPath = `/support/ticket/{ticket_id}/change-admin/{new_admin_user_id}`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)))
                .replace(`{${"new_admin_user_id"}}`, encodeURIComponent(String(newAdminUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download Ticket Attachment
         * @param {string} ticketId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTicketAttachment: async (ticketId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('downloadTicketAttachment', 'ticketId', ticketId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('downloadTicketAttachment', 'authorization', authorization)
            const localVarPath = `/support/ticket/{ticket_id}/attachment`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download Ticket Response Attachment
         * @param {string} ticketResponseId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTicketResponseAttachment: async (ticketResponseId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketResponseId' is not null or undefined
            assertParamExists('downloadTicketResponseAttachment', 'ticketResponseId', ticketResponseId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('downloadTicketResponseAttachment', 'authorization', authorization)
            const localVarPath = `/support/ticket-response/{ticket_response_id}/attachment`
                .replace(`{${"ticket_response_id"}}`, encodeURIComponent(String(ticketResponseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * join works here
         * @summary Get A Single Ticket
         * @param {string} ticketId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getASingleTicket: async (ticketId: string, authorization: string, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('getASingleTicket', 'ticketId', ticketId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getASingleTicket', 'authorization', authorization)
            const localVarPath = `/support/tickets/{ticket_id}`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Tickets
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [start] 
         * @param {boolean} [activeAdminOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTickets: async (authorization: string, limit?: number, start?: number, activeAdminOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getTickets', 'authorization', authorization)
            const localVarPath = `/support/tickets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (activeAdminOnly !== undefined) {
                localVarQueryParameter['active_admin_only'] = activeAdminOnly;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Post New Ticket
         * @param {string} authorization 
         * @param {string} message 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewTicket: async (authorization: string, message: string, file?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('postNewTicket', 'authorization', authorization)
            // verify required parameter 'message' is not null or undefined
            assertParamExists('postNewTicket', 'message', message)
            const localVarPath = `/support/create-ticket`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (message !== undefined) { 
                localVarFormParams.append('message', message as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Respond To Ticket
         * @param {string} ticketId 
         * @param {string} authorization 
         * @param {string} message 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToTicket: async (ticketId: string, authorization: string, message: string, file?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('respondToTicket', 'ticketId', ticketId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('respondToTicket', 'authorization', authorization)
            // verify required parameter 'message' is not null or undefined
            assertParamExists('respondToTicket', 'message', message)
            const localVarPath = `/support/ticket/{ticket_id}/respond`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


            if (message !== undefined) { 
                localVarFormParams.append('message', message as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Status
         * @param {string} ticketId 
         * @param {TicketStatus} status 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus: async (ticketId: string, status: TicketStatus, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ticketId' is not null or undefined
            assertParamExists('updateStatus', 'ticketId', ticketId)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('updateStatus', 'status', status)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateStatus', 'authorization', authorization)
            const localVarPath = `/support/ticket/{ticket_id}/status-update`
                .replace(`{${"ticket_id"}}`, encodeURIComponent(String(ticketId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SupportApi - functional programming interface
 * @export
 */
export const SupportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SupportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change Ticket Admin
         * @param {string} ticketId 
         * @param {string} newAdminUserId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeTicketAdmin(ticketId: string, newAdminUserId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeTicketAdmin(ticketId, newAdminUserId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download Ticket Attachment
         * @param {string} ticketId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadTicketAttachment(ticketId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadTicketAttachment(ticketId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download Ticket Response Attachment
         * @param {string} ticketResponseId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadTicketResponseAttachment(ticketResponseId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadTicketResponseAttachment(ticketResponseId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * join works here
         * @summary Get A Single Ticket
         * @param {string} ticketId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getASingleTicket(ticketId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getASingleTicket(ticketId, authorization, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Tickets
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [start] 
         * @param {boolean} [activeAdminOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTickets(authorization: string, limit?: number, start?: number, activeAdminOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TicketOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTickets(authorization, limit, start, activeAdminOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Post New Ticket
         * @param {string} authorization 
         * @param {string} message 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postNewTicket(authorization: string, message: string, file?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postNewTicket(authorization, message, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Respond To Ticket
         * @param {string} ticketId 
         * @param {string} authorization 
         * @param {string} message 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondToTicket(ticketId: string, authorization: string, message: string, file?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketResponseOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.respondToTicket(ticketId, authorization, message, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Status
         * @param {string} ticketId 
         * @param {TicketStatus} status 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatus(ticketId: string, status: TicketStatus, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TicketOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus(ticketId, status, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SupportApi - factory interface
 * @export
 */
export const SupportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SupportApiFp(configuration)
    return {
        /**
         * 
         * @summary Change Ticket Admin
         * @param {string} ticketId 
         * @param {string} newAdminUserId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeTicketAdmin(ticketId: string, newAdminUserId: string, authorization: string, options?: any): AxiosPromise<TicketOut> {
            return localVarFp.changeTicketAdmin(ticketId, newAdminUserId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download Ticket Attachment
         * @param {string} ticketId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTicketAttachment(ticketId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadTicketAttachment(ticketId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download Ticket Response Attachment
         * @param {string} ticketResponseId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadTicketResponseAttachment(ticketResponseId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.downloadTicketResponseAttachment(ticketResponseId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * join works here
         * @summary Get A Single Ticket
         * @param {string} ticketId 
         * @param {string} authorization 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getASingleTicket(ticketId: string, authorization: string, join?: boolean, options?: any): AxiosPromise<TicketOut> {
            return localVarFp.getASingleTicket(ticketId, authorization, join, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Tickets
         * @param {string} authorization 
         * @param {number} [limit] 
         * @param {number} [start] 
         * @param {boolean} [activeAdminOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTickets(authorization: string, limit?: number, start?: number, activeAdminOnly?: boolean, options?: any): AxiosPromise<Array<TicketOut>> {
            return localVarFp.getTickets(authorization, limit, start, activeAdminOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Post New Ticket
         * @param {string} authorization 
         * @param {string} message 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNewTicket(authorization: string, message: string, file?: any, options?: any): AxiosPromise<TicketOut> {
            return localVarFp.postNewTicket(authorization, message, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Respond To Ticket
         * @param {string} ticketId 
         * @param {string} authorization 
         * @param {string} message 
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondToTicket(ticketId: string, authorization: string, message: string, file?: any, options?: any): AxiosPromise<TicketResponseOut> {
            return localVarFp.respondToTicket(ticketId, authorization, message, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Status
         * @param {string} ticketId 
         * @param {TicketStatus} status 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatus(ticketId: string, status: TicketStatus, authorization: string, options?: any): AxiosPromise<TicketOut> {
            return localVarFp.updateStatus(ticketId, status, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SupportApi - object-oriented interface
 * @export
 * @class SupportApi
 * @extends {BaseAPI}
 */
export class SupportApi extends BaseAPI {
    /**
     * 
     * @summary Change Ticket Admin
     * @param {string} ticketId 
     * @param {string} newAdminUserId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public changeTicketAdmin(ticketId: string, newAdminUserId: string, authorization: string, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).changeTicketAdmin(ticketId, newAdminUserId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download Ticket Attachment
     * @param {string} ticketId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public downloadTicketAttachment(ticketId: string, authorization: string, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).downloadTicketAttachment(ticketId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download Ticket Response Attachment
     * @param {string} ticketResponseId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public downloadTicketResponseAttachment(ticketResponseId: string, authorization: string, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).downloadTicketResponseAttachment(ticketResponseId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * join works here
     * @summary Get A Single Ticket
     * @param {string} ticketId 
     * @param {string} authorization 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public getASingleTicket(ticketId: string, authorization: string, join?: boolean, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).getASingleTicket(ticketId, authorization, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Tickets
     * @param {string} authorization 
     * @param {number} [limit] 
     * @param {number} [start] 
     * @param {boolean} [activeAdminOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public getTickets(authorization: string, limit?: number, start?: number, activeAdminOnly?: boolean, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).getTickets(authorization, limit, start, activeAdminOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Post New Ticket
     * @param {string} authorization 
     * @param {string} message 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public postNewTicket(authorization: string, message: string, file?: any, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).postNewTicket(authorization, message, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Respond To Ticket
     * @param {string} ticketId 
     * @param {string} authorization 
     * @param {string} message 
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public respondToTicket(ticketId: string, authorization: string, message: string, file?: any, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).respondToTicket(ticketId, authorization, message, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Status
     * @param {string} ticketId 
     * @param {TicketStatus} status 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupportApi
     */
    public updateStatus(ticketId: string, status: TicketStatus, authorization: string, options?: AxiosRequestConfig) {
        return SupportApiFp(this.configuration).updateStatus(ticketId, status, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept Premium Upgrade Request
         * @param {string} requestId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptPremiumUpgradeRequest: async (requestId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('acceptPremiumUpgradeRequest', 'requestId', requestId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('acceptPremiumUpgradeRequest', 'authorization', authorization)
            const localVarPath = `/premium/upgrade-request/{request_id}/accept`
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add Api Calls
         * @param {string} userId 
         * @param {string} authorization 
         * @param {AddAPICallsUnit} addAPICallsUnit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addApiCalls: async (userId: string, authorization: string, addAPICallsUnit: AddAPICallsUnit, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addApiCalls', 'userId', userId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('addApiCalls', 'authorization', authorization)
            // verify required parameter 'addAPICallsUnit' is not null or undefined
            assertParamExists('addApiCalls', 'addAPICallsUnit', addAPICallsUnit)
            const localVarPath = `/users/{user_id}/add-api-calls`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addAPICallsUnit, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticate User
         * @param {AccessTokenIn} accessTokenIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser: async (accessTokenIn: AccessTokenIn, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessTokenIn' is not null or undefined
            assertParamExists('authenticateUser', 'accessTokenIn', accessTokenIn)
            const localVarPath = `/authenticate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accessTokenIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete User
         * @param {string} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('deleteUser', 'authorization', authorization)
            const localVarPath = `/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Premium Request Status
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPremiumRequestStatus: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPremiumRequestStatus', 'authorization', authorization)
            const localVarPath = `/premium/requests-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Premium Upgrade Requests
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPremiumUpgradeRequests: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getPremiumUpgradeRequests', 'authorization', authorization)
            const localVarPath = `/premium/upgrade-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets basic statistics of the users in the system, such as premium accounts, verified users and the total number of users in the system. exlcude_system_users when true, excludes the worker and the admin users from the stats
         * @summary Get Users Statistics
         * @param {string} authorization 
         * @param {boolean} [excludeSystemUsers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersStatistics: async (authorization: string, excludeSystemUsers?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('getUsersStatistics', 'authorization', authorization)
            const localVarPath = `/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (excludeSystemUsers !== undefined) {
                localVarQueryParameter['exclude_system_users'] = excludeSystemUsers;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read User By Id
         * @param {string} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUserById: async (userId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('readUserById', 'userId', userId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('readUserById', 'authorization', authorization)
            const localVarPath = `/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all users in the system. Query parameters account_type, username, role and email can all be used together.
         * @summary Read Users
         * @param {string} authorization 
         * @param {BusinessModel} [accountType] 
         * @param {string} [username] 
         * @param {string} [email] 
         * @param {UserRoles} [role] 
         * @param {UsersSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUsers: async (authorization: string, accountType?: BusinessModel, username?: string, email?: string, role?: UserRoles, orderBy?: UsersSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('readUsers', 'authorization', authorization)
            const localVarPath = `/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountType !== undefined) {
                localVarQueryParameter['account_type'] = accountType;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['order_direction'] = orderDirection;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (join !== undefined) {
                localVarQueryParameter['join'] = join;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request Password Reset
         * @param {EmailVerificationRequest} emailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: async (emailVerificationRequest: EmailVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailVerificationRequest' is not null or undefined
            assertParamExists('requestPasswordReset', 'emailVerificationRequest', emailVerificationRequest)
            const localVarPath = `/password/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request Verification Key
         * @param {EmailVerificationRequest} emailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestVerificationKey: async (emailVerificationRequest: EmailVerificationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailVerificationRequest' is not null or undefined
            assertParamExists('requestVerificationKey', 'emailVerificationRequest', emailVerificationRequest)
            const localVarPath = `/email-verification/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user into the platform
         * @summary Signup User
         * @param {UserSignUpIn} userSignUpIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signupUser: async (userSignUpIn: UserSignUpIn, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userSignUpIn' is not null or undefined
            assertParamExists('signupUser', 'userSignUpIn', userSignUpIn)
            const localVarPath = `/users/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSignUpIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Roles can only be updated by an admin.
         * @summary Update User
         * @param {string} userId 
         * @param {string} authorization 
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: string, authorization: string, userUpdate: UserUpdate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('updateUser', 'authorization', authorization)
            // verify required parameter 'userUpdate' is not null or undefined
            assertParamExists('updateUser', 'userUpdate', userUpdate)
            const localVarPath = `/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upgrade Request
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeRequest: async (authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('upgradeRequest', 'authorization', authorization)
            const localVarPath = `/premium/request-upgrade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify Email With Token
         * @param {EmailVerificationToken} emailVerificationToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailWithToken: async (emailVerificationToken: EmailVerificationToken, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailVerificationToken' is not null or undefined
            assertParamExists('verifyEmailWithToken', 'emailVerificationToken', emailVerificationToken)
            const localVarPath = `/email-verification/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailVerificationToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify User
         * @param {string} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUser: async (userId: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('verifyUser', 'userId', userId)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('verifyUser', 'authorization', authorization)
            const localVarPath = `/users/{user_id}/verify`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify User With Email
         * @param {string} email 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserWithEmail: async (email: string, authorization: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('verifyUserWithEmail', 'email', email)
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('verifyUserWithEmail', 'authorization', authorization)
            const localVarPath = `/users/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (authorization !== undefined && authorization !== null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept Premium Upgrade Request
         * @param {string} requestId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptPremiumUpgradeRequest(requestId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptPremiumUpgradeRequest(requestId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add Api Calls
         * @param {string} userId 
         * @param {string} authorization 
         * @param {AddAPICallsUnit} addAPICallsUnit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addApiCalls(userId: string, authorization: string, addAPICallsUnit: AddAPICallsUnit, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addApiCalls(userId, authorization, addAPICallsUnit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Authenticate User
         * @param {AccessTokenIn} accessTokenIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authenticateUser(accessTokenIn: AccessTokenIn, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessTokenOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authenticateUser(accessTokenIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete User
         * @param {string} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Premium Request Status
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPremiumRequestStatus(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PremiumRequestStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPremiumRequestStatus(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Premium Upgrade Requests
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPremiumUpgradeRequests(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyPremiumRequests>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPremiumUpgradeRequests(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Gets basic statistics of the users in the system, such as premium accounts, verified users and the total number of users in the system. exlcude_system_users when true, excludes the worker and the admin users from the stats
         * @summary Get Users Statistics
         * @param {string} authorization 
         * @param {boolean} [excludeSystemUsers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersStatistics(authorization: string, excludeSystemUsers?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersStat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersStatistics(authorization, excludeSystemUsers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Read User By Id
         * @param {string} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readUserById(userId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOutWithStat>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readUserById(userId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all users in the system. Query parameters account_type, username, role and email can all be used together.
         * @summary Read Users
         * @param {string} authorization 
         * @param {BusinessModel} [accountType] 
         * @param {string} [username] 
         * @param {string} [email] 
         * @param {UserRoles} [role] 
         * @param {UsersSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readUsers(authorization: string, accountType?: BusinessModel, username?: string, email?: string, role?: UserRoles, orderBy?: UsersSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ManyUsersOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readUsers(authorization, accountType, username, email, role, orderBy, orderDirection, skip, limit, join, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request Password Reset
         * @param {EmailVerificationRequest} emailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPasswordReset(emailVerificationRequest: EmailVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPasswordReset(emailVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request Verification Key
         * @param {EmailVerificationRequest} emailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestVerificationKey(emailVerificationRequest: EmailVerificationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestVerificationKey(emailVerificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new user into the platform
         * @summary Signup User
         * @param {UserSignUpIn} userSignUpIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signupUser(userSignUpIn: UserSignUpIn, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signupUser(userSignUpIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Roles can only be updated by an admin.
         * @summary Update User
         * @param {string} userId 
         * @param {string} authorization 
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: string, authorization: string, userUpdate: UserUpdate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, authorization, userUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upgrade Request
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upgradeRequest(authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upgradeRequest(authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify Email With Token
         * @param {EmailVerificationToken} emailVerificationToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmailWithToken(emailVerificationToken: EmailVerificationToken, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmailWithToken(emailVerificationToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify User
         * @param {string} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyUser(userId: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyUser(userId, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify User With Email
         * @param {string} email 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyUserWithEmail(email: string, authorization: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyUserWithEmail(email, authorization, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept Premium Upgrade Request
         * @param {string} requestId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptPremiumUpgradeRequest(requestId: string, authorization: string, options?: any): AxiosPromise<StatusMessage> {
            return localVarFp.acceptPremiumUpgradeRequest(requestId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add Api Calls
         * @param {string} userId 
         * @param {string} authorization 
         * @param {AddAPICallsUnit} addAPICallsUnit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addApiCalls(userId: string, authorization: string, addAPICallsUnit: AddAPICallsUnit, options?: any): AxiosPromise<StatusMessage> {
            return localVarFp.addApiCalls(userId, authorization, addAPICallsUnit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticate User
         * @param {AccessTokenIn} accessTokenIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authenticateUser(accessTokenIn: AccessTokenIn, options?: any): AxiosPromise<AccessTokenOut> {
            return localVarFp.authenticateUser(accessTokenIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete User
         * @param {string} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: string, authorization: string, options?: any): AxiosPromise<any> {
            return localVarFp.deleteUser(userId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Premium Request Status
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPremiumRequestStatus(authorization: string, options?: any): AxiosPromise<PremiumRequestStatus> {
            return localVarFp.getPremiumRequestStatus(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Premium Upgrade Requests
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPremiumUpgradeRequests(authorization: string, options?: any): AxiosPromise<ManyPremiumRequests> {
            return localVarFp.getPremiumUpgradeRequests(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets basic statistics of the users in the system, such as premium accounts, verified users and the total number of users in the system. exlcude_system_users when true, excludes the worker and the admin users from the stats
         * @summary Get Users Statistics
         * @param {string} authorization 
         * @param {boolean} [excludeSystemUsers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersStatistics(authorization: string, excludeSystemUsers?: boolean, options?: any): AxiosPromise<UsersStat> {
            return localVarFp.getUsersStatistics(authorization, excludeSystemUsers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read User By Id
         * @param {string} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUserById(userId: string, authorization: string, options?: any): AxiosPromise<UserOutWithStat> {
            return localVarFp.readUserById(userId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all users in the system. Query parameters account_type, username, role and email can all be used together.
         * @summary Read Users
         * @param {string} authorization 
         * @param {BusinessModel} [accountType] 
         * @param {string} [username] 
         * @param {string} [email] 
         * @param {UserRoles} [role] 
         * @param {UsersSortBy} [orderBy] 
         * @param {OrderDirection} [orderDirection] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {boolean} [join] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readUsers(authorization: string, accountType?: BusinessModel, username?: string, email?: string, role?: UserRoles, orderBy?: UsersSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options?: any): AxiosPromise<ManyUsersOut> {
            return localVarFp.readUsers(authorization, accountType, username, email, role, orderBy, orderDirection, skip, limit, join, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request Password Reset
         * @param {EmailVerificationRequest} emailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(emailVerificationRequest: EmailVerificationRequest, options?: any): AxiosPromise<StatusMessage> {
            return localVarFp.requestPasswordReset(emailVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request Verification Key
         * @param {EmailVerificationRequest} emailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestVerificationKey(emailVerificationRequest: EmailVerificationRequest, options?: any): AxiosPromise<StatusMessage> {
            return localVarFp.requestVerificationKey(emailVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new user into the platform
         * @summary Signup User
         * @param {UserSignUpIn} userSignUpIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signupUser(userSignUpIn: UserSignUpIn, options?: any): AxiosPromise<UserOut> {
            return localVarFp.signupUser(userSignUpIn, options).then((request) => request(axios, basePath));
        },
        /**
         * Roles can only be updated by an admin.
         * @summary Update User
         * @param {string} userId 
         * @param {string} authorization 
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userId: string, authorization: string, userUpdate: UserUpdate, options?: any): AxiosPromise<UserOut> {
            return localVarFp.updateUser(userId, authorization, userUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upgrade Request
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upgradeRequest(authorization: string, options?: any): AxiosPromise<StatusMessage> {
            return localVarFp.upgradeRequest(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify Email With Token
         * @param {EmailVerificationToken} emailVerificationToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmailWithToken(emailVerificationToken: EmailVerificationToken, options?: any): AxiosPromise<StatusMessage> {
            return localVarFp.verifyEmailWithToken(emailVerificationToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify User
         * @param {string} userId 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUser(userId: string, authorization: string, options?: any): AxiosPromise<UserOut> {
            return localVarFp.verifyUser(userId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify User With Email
         * @param {string} email 
         * @param {string} authorization 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyUserWithEmail(email: string, authorization: string, options?: any): AxiosPromise<UserOut> {
            return localVarFp.verifyUserWithEmail(email, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Accept Premium Upgrade Request
     * @param {string} requestId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public acceptPremiumUpgradeRequest(requestId: string, authorization: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).acceptPremiumUpgradeRequest(requestId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add Api Calls
     * @param {string} userId 
     * @param {string} authorization 
     * @param {AddAPICallsUnit} addAPICallsUnit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public addApiCalls(userId: string, authorization: string, addAPICallsUnit: AddAPICallsUnit, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).addApiCalls(userId, authorization, addAPICallsUnit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticate User
     * @param {AccessTokenIn} accessTokenIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public authenticateUser(accessTokenIn: AccessTokenIn, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).authenticateUser(accessTokenIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete User
     * @param {string} userId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteUser(userId: string, authorization: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).deleteUser(userId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Premium Request Status
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getPremiumRequestStatus(authorization: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getPremiumRequestStatus(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Premium Upgrade Requests
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getPremiumUpgradeRequests(authorization: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getPremiumUpgradeRequests(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets basic statistics of the users in the system, such as premium accounts, verified users and the total number of users in the system. exlcude_system_users when true, excludes the worker and the admin users from the stats
     * @summary Get Users Statistics
     * @param {string} authorization 
     * @param {boolean} [excludeSystemUsers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUsersStatistics(authorization: string, excludeSystemUsers?: boolean, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersStatistics(authorization, excludeSystemUsers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read User By Id
     * @param {string} userId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public readUserById(userId: string, authorization: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).readUserById(userId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all users in the system. Query parameters account_type, username, role and email can all be used together.
     * @summary Read Users
     * @param {string} authorization 
     * @param {BusinessModel} [accountType] 
     * @param {string} [username] 
     * @param {string} [email] 
     * @param {UserRoles} [role] 
     * @param {UsersSortBy} [orderBy] 
     * @param {OrderDirection} [orderDirection] 
     * @param {number} [skip] 
     * @param {number} [limit] 
     * @param {boolean} [join] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public readUsers(authorization: string, accountType?: BusinessModel, username?: string, email?: string, role?: UserRoles, orderBy?: UsersSortBy, orderDirection?: OrderDirection, skip?: number, limit?: number, join?: boolean, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).readUsers(authorization, accountType, username, email, role, orderBy, orderDirection, skip, limit, join, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request Password Reset
     * @param {EmailVerificationRequest} emailVerificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public requestPasswordReset(emailVerificationRequest: EmailVerificationRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).requestPasswordReset(emailVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request Verification Key
     * @param {EmailVerificationRequest} emailVerificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public requestVerificationKey(emailVerificationRequest: EmailVerificationRequest, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).requestVerificationKey(emailVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new user into the platform
     * @summary Signup User
     * @param {UserSignUpIn} userSignUpIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public signupUser(userSignUpIn: UserSignUpIn, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).signupUser(userSignUpIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Roles can only be updated by an admin.
     * @summary Update User
     * @param {string} userId 
     * @param {string} authorization 
     * @param {UserUpdate} userUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUser(userId: string, authorization: string, userUpdate: UserUpdate, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUser(userId, authorization, userUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upgrade Request
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public upgradeRequest(authorization: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).upgradeRequest(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify Email With Token
     * @param {EmailVerificationToken} emailVerificationToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public verifyEmailWithToken(emailVerificationToken: EmailVerificationToken, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).verifyEmailWithToken(emailVerificationToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify User
     * @param {string} userId 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public verifyUser(userId: string, authorization: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).verifyUser(userId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify User With Email
     * @param {string} email 
     * @param {string} authorization 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public verifyUserWithEmail(email: string, authorization: string, options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).verifyUserWithEmail(email, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}


